/* eslint-disable */
/* eslint-disable no-debugger */
/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty */
/* eslint-disable prefer-const */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
/* eslint-disable-next-line sonarjs/no-identical-functions */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-identical-functions*/
import { ReactComponent as Addimage } from "../../../assets/images/ImageAdd.svg";
import { ReactComponent as Successimage } from "../../../assets/images/success-icon.svg";
import React, { useEffect, useState, useContext, useRef } from "react";
import Eposchedule from "../AddCoCustomer/Eposchedule";
import AddCoCustomer from "../AddCoCustomer/AddCocustomer";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { ReactComponent as Alertimage } from "../../../assets/images/no-records-found.svg";
import { ReactComponent as WarningIcon } from "../../../assets/images/warningIcon.svg";
import { ReactComponent as AddIcon } from "../../../assets/images/Add-icon.svg";
import { ReactComponent as TickIcon } from "../../../assets/images/tick-icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg";
import { ReactComponent as DeleteRedIcon } from "../../../assets/images/deleteRed-icon.svg";

import { AgreementContext } from "../../../context/AgreementContext";
import AgreementReturn from "../../Rental/View Agreement/AgreementReturn";
import SecondFactor from "../TwoFactorPopup/TwoFactorPopup";
import { fieldDeviceStyles } from "../../../JSstyles/fieldDeviceStyles";
import { fixedGridStyles } from "../../../JSstyles/fixedGridStyles";
import { agrGeneralInfoStyles } from "../../../JSstyles/agrGeneralInfoStyles";
import { getSalesPersonOptions1, getCustomerAppointment,fetchOrganizationDetails } from "../../../api/user";
import {deliveryResultStatus} from "../CreateAgreement/DeliveryMethodRentalInterface"

import VoidAgreement from '../../Rental/AddCoCustomer/voidagreement';


import {
  GetDeliveryAddress,
  GetTimeSlots,
  // Getglobalcustomerid,
  UpdateAddressInfo,
  // updatecustomer,
  FinishdeliveryStatus,
  CoworkerRequired,
  Confirmdelivery,
  GetstateDropdown,
  GetSuggestedAddress,
  getAgreementInfo,
  GenerateReceipt,
  getCurrentInfo,
  getRadiusStores,
  sendEPO,
  GetRole,
  LoadDeliveryreceipt,
  getnextpaymentamount,
  getAgreementDelivery,
} from "../../../api/user";
import { CombinedValidationResponseItem } from "../../../common/addressValidationInterface";
import { addDays } from "date-fns";
import {
  RACRadio,
  RACTextbox,
  RACDatePicker,
  RACButton,
  RACTable,
  RACTableCell,
  RACTableRow,
  RACSelect,
  RACModalCard,
  Card,
  CardContent,
  Typography,
  Grid,
  CircularProgress,
  Box,
  RACToggle,
  RACCheckBox,
  RACTooltip,
  RACMUIDatePicker
} from "@rentacenter/racstrap";

import clsx from "clsx";
import { agreementDeliveryStyles } from "../../../JSstyles/agreementDeliveryStyles";
import { agreementGlobalStyles } from "../../../JSstyles/agreementGlobalStyles";
import { OriginContext } from "../../../context/OriginContext";
import { AMOrigin } from "../../../constants/constants";
import { AppRoute } from "../../../config/route-config";
import { ContainerContext } from "../../../app/App";
import { CustomPropInterface } from "../../../index";
import { FeatureFlagContext } from "../../../context/FeatureFlagContext";
import validateAddressFn from "../../../common/vaidateAddressFn";
import { matchCommitmentToSlot, CommitmentLocationState } from "../../../utils/utils";
import { useTranslation } from "react-i18next";
import { EVENT_TYPES, getEventType } from '../../../types/types';
import MXAddressComp from "../../../common/MXAddressComponent";

let addRowArray: any;
// eslint-disable-next-line prefer-const
addRowArray = [];
// let BindtimeslotId = '';
let BindtimeslotDate = "";
let ExBindtimeslotDate = "";

interface ParamType {
  customerId: string;
  agreementId: string;
}

export interface RadiusStoreType {
  response: [
    {
      neighborStoreId: string;
      neighborStoreNumber: string;
    }
  ];
}

export interface ComboBoxOption {
  value: string;
  label: string;
}

// eslint-disable-next-line sonarjs/cognitive-complexity
export default function Deliverymethod(props: any) {
  const { i18n, t } = useTranslation("rental");

  const classes1 = fieldDeviceStyles();
  const classes = agreementDeliveryStyles();
  const globalStyle = agreementGlobalStyles();
  const { customerId } = useParams<ParamType>();
  const { agreementId } = useParams<ParamType>();
  const containerData = useContext(ContainerContext) as CustomPropInterface;
  const [returnbtnRdn, setreturnbtnRdn] = useState(false);
  const [confirmFlow, setconfirmFlow] = useState(false);
  const history = useHistory();
  const location = useLocation<CommitmentLocationState>();
  const commitmentAppliedRef = useRef(false);
  const { redirectOrigin } = useContext(OriginContext);
  const [coCustomerId, setcocustomerId] = useState("");
  const [coCustomerName, setcoCustomerName] = useState("");
  const [TimeSlotYes, setTimeSlotYes] = useState(false);
  const [desktopView, setdesktopView] = useState(true);
  const { featureFlagDetails } = useContext(FeatureFlagContext);
  const [canSuggestAddress, setCanSuggestAddress] = useState(false);
  const [cantSuggestAddress, setCantSuggestAddress] = useState(false);
  const [FieldVisitOverride, setFieldVisitOverride] = useState(false);
  const [overrideButtons, setOverrideButtons] = useState(true);
  const [overrideButtonOff, setOverrideButtonOff] = useState(true);
  const [DAPEventOverrideSLA, setDAPEventOverrideSLA] = useState(false);

  const [validatedAddresses, setValidatedAddress] = useState<any>({});
  const [canEnableGoogleValdation, setCanEnableGoogleValdation] =
    useState(false);
  const [verificationWarningPopup, setverificationWarningPopup] =
    useState(false);
  const [verifcationRequiredContinue, setVerifcationRequiredContinue] =
    useState(false);
  const [mxDeliveryKey, setmxDeliveryKey] = useState(false);
  const fixedGridClassName = fixedGridStyles();
  const { agreementOptions, setagreementOptions } =
    useContext(AgreementContext);

  const agrGeneralInfoClassName = agrGeneralInfoStyles();

  const eventOverrideSLAsuccess = () => {
    setDAPEventOverrideSLA(false);
    enableFieldVisitOverride();
  };

  const enableFieldVisitOverride = () => {

     if (props.triggerdateChaged) {
      props.triggerdateChaged();
    }
    SetTime("");
    Settimeslotid("");
    setBindtimeslotId("");

    if ( FieldVisitOverride ) {
      setFieldVisitOverride( false );
      setOverrideButtons( true );
    } else {
      setFieldVisitOverride( true );
      setOverrideButtons( false );
    }
    
  };
  const {
    viewAgrData,
    setdeliveryMethodData,
    SetaddressId,
    addressId,
    resumebtnFeatureFlag,
    setNewAppointmentId,
    manualSignatureEnabled,
    setManualSignatureEnabled,
    deliveryMethodData,
    rescheduleEnable,
    setRescheduleEnable,
    datePickerEnable,
    setdatePickerEnable,
    createAAgreementTiemslot,
    setcreateAAgreementTiemslot,
    getCustomerResponse,
  } = useContext(AgreementContext);
  const [AppoinmentSource, setAppoinmentSource]: any = React.useState("");

  const pull_data = (data) => {
    setcocustomerId(data.coCustomerId);
    setcoCustomerName(data.coCustomerName);
    props.func({
      coCustomerId: data.coCustomerId,
      coCustomerName: data.coCustomerName,
    });

    console.log("Footer contex", data);
  };

  // Setting up State Variables for the Component

  // State Variables for the  the ID's that we use in the component
  const [InventoryNumber, setInventoryNumber] = useState<any>();
  const [appointmentId, setappointmentId] = useState<any>("");
  const [ContextStartDate, SetContextStartDate] = useState("");
  const [ContextEndDate, SetContextEndDate] = useState("");
  const [agreementid, Setagreementid] = useState("");
  const [IdAddress, SetIdAddress] = useState("");
  const [Coworkers, SetCoworkers]: any = useState("");
  const [getaddress, SetGetAddress] = useState([]);
  const [timeslotid, Settimeslotid] = useState("");
  const [storepickupMsg, setStorepickupMsg] = useState("");
  const [DeliveryRdo, SetDeliveryRdo] = useState("");
  const [CarryoutRdo, SetCarryouutRdo] = useState("");
  const [Deliverytype, SetDeliverytype] = useState("D");
  const [DeliverytypeExc, SetDeliverytypeExc] = useState("P");
  const [checkDeliverytype, SetcheckDeliverytype] = useState("DEL");
  const [checkDeliverytypeExc, SetcheckDeliverytypeExc] = useState("DEL");
  const [CarryinRdoExc, SetCarryinRdoExc] = useState("");
  const [DeliveryRdoExc, SetDeliveryRdoExc] = useState("");
  const [CoworkersExc, SetCoworkersExc]: any = useState("");
  const [inventoryInfo, setInventoryInfo]: any = useState([]);

  // State Variables for the Delivery Address in Delivery Address Heading

  const [Addressline1, SetAddressline1] = useState("");
  const [Addressline2, SetAddressline2] = useState("-");
  const [Zip, SetZip] = useState("");
  const [City, SetCity] = useState("");
  const [State, SetState] = useState("");
  const [exteriorNumber, setExteriorNumber] = useState("-");
  const [suggestAddress, setSuggestAddress] = useState(false);
  const [actionCompleted, setActionCompeleted] = useState(false);
  const [interiorNumber, setInteriorNumber] = useState("-");
  interface Address {
    street: string;
    interiorNum: string;
    exteriorNum: string;
    suburb?: string;
    zipcode: string;
    city: string;
    state: string;
  }
  const [address, setAddress] = useState<Address>({
    street: '',
    interiorNum: '',
    exteriorNum: '',
    suburb: '',
    zipcode: '',
    city: '',
    state: ''
  });
  useEffect(() => {
    if (actionCompleted) {
      updateMXAddress()
    }
  }, [actionCompleted])

  const [pdfresponse, setpdfresponse] = useState([]);

  // State Variables for the Pop-Up display on clicking Select Other Address

  const [Popup, SetPopup] = useState(false);

  // State Variables for the Delivery Address that is displayed in the input field in the Pop-up

  const [Line1Popup, SetLine1Popup] = useState("");
  const [Line2Popup, SetLine2Popup] = useState("");

  //return
  const [ReturnDeliveryCompleted, SetReturnDeliveryCompleted] = useState(false);
  const [ReverseConfirmation, setReverseConfirmation] = useState(false);

  const [SOTwoFactorReturnEnabled, setSOTwoFactorReturnEnabled] =
    useState(false);
  const [currentUserRole, setCurrentUserRole] = React.useState("");
  const [ZipPopup, SetZipPopup] = useState("");
  const [CityPopup, SetCityPopup] = useState("");
  const [StatePopup, SetStatePopup] = useState("");
  const [StatePopupId, SetStatePopupId] = useState("");
  const [Statedrop, SetStatedrop]: any = useState([]);

  // State Variables for adding rows in the Pop-Up below the input field for each value entered
  const [addRow, SetAddRow] = useState([]);
  const [timeSlotData, SettimeSlotData]: any = useState([]);
  const [coWorkerRequiredArray, setcoWorkerRequiredArray]: any = useState([]);
  const [ResendVopen, setResendVopen] = useState(false);
  const [resendsuccess, setResendsuccess] = useState(false);
  const [textMsg, settextMsg] = useState(false);
  const [sendEmail, setsendEmail] = useState(true);
  const [emailText, setemailText] = useState("");
  const [phoneNo, setphoneNo] = useState("");
  const [EmailErrVal, setEmailErrVal] = useState(false);
  const [welcomeEnable, setwelcomeEnable] = useState(false);
  const [phoneErrMsg, setphoneErrMsg] = useState("");
  const [emailErrMsg, setemailErrMsg] = useState("");
  // State Variables for showing details in Delivery Details heading
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [startDateExc, setStartDateExc] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [Time, SetTime] = useState("");
  const [Instructions, SetInstructions] = useState("");
  const [InstructionsExc, SetExcInstructions] = useState("");
  const [Errorpopup, SetErrorpopup] = useState(false);
  // State Variables for displaying 5 days from the Selected Date
  const [TEMP, SetTEMP] = useState("0");
  const [inventoryid, Setinventoryid] = useState([]);
  const [agreementNumber, SetagreementNumber] = useState("");
  const [Starttime, SetStarttime]: any = useState("");
  const [Endtime, SetEndtime]: any = useState("");
  const [enableadd, Setenableadd] = useState(true);
  const [enableFinish, SetenableFinish] = useState(true);
  // const [enableSave, SetenableSave] = useState(true);
  const [editdisable, Seteditdisable] = useState(false);
  const [InputGrid, SetInputGrid] = useState(false);
  const [EpoProps, SetEpoProps] = useState<any>();
  const [savedisable, Setsavedisable] = useState(false);
  const [conditionLoader, SetconditionLoader] = useState(true);
  const [StateconditionLoader, SetStateconditionLoader] = useState(true);
  const [ValidateIsOpen, setValidateIsOpen] = useState(false);
  const [BtnIsdisabled1, setBtnIsdisabled1] = useState(true);
  const [BtnIsdisabled2, setBtnIsdisabled2] = useState(false);
  const [SuggestedAddress, setSuggestedAddress]: any = useState();

  const [RescheduleEventId, SetRescheduleEventId] = useState("");
  const [masterLoader, setmasterLoader]: any = React.useState(true);
  const [defaultSuggestedAddress, setdefaultSuggestedAddress] = useState("SUG");
  const [Opendeliveryconfirmpopup, SetOpendeliveryconfirmpopup] =
    useState(false);
  const [Openreturnconfirmpopup, SetOpenreturnconfirmpopup] = useState(false);
  const [OpenPickupConfirmPopup, SetOpenPickupConfirmPopup] = useState(false);
  const [RescheduleProps, SetRescheduleProps] = useState("Schedule");
  const [SaveTrigger, SetSaveTrigger] = useState(false);
  const nextpaymentobj = {
    nextamountdue: "",
    nextduedate: "",
  };
  const [nextpaymentinfo, setnextpaymentinfo] = useState(nextpaymentobj);
  const [GCID, SetGCID] = useState("");
  const [DisplayErrorMessage, SetDisplayErrorMessage] = useState("");
  const [BindtimeslotId, setBindtimeslotId] = useState("");
  const [hideswitchoutbutton, sethideswitchoutbutton] = useState(true);
  const [cusName, setCustomerName] = useState<any>();
  const [customer, setCustomer] = useState({
            firstName: '',
            lastName: ''
      });
  const [AgrNumber, setAgrNumber] = useState<any>();
  const [deliveryStatus, SetdeliveryStatus] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  // eslint-disable-next-line prefer-const
  let [newDeliveryAddress, setNewDeliverAddress] = useState<any>();
  const [addressErrorMsg, setAddressErrorMsg]: any = useState("");
  const [MaxDate, setMaxDate] = useState("");
  const [dateError, setdateError] = useState("");
  const [previousBtnEnable, setpreviousBtnEnable] = useState(false);
  const [timeslotCount, settimeslotCount] = useState<any>();
  const [getAgreementDeliveryRes, setgetAgreementDeliveryRes] =
    useState<any>("");
  const storeNumber = window.sessionStorage.getItem("storeNumber");
  const [LMDConfigurable, setLMDConfigurable] = useState(false);
  const [headerPresent, setHeaderPresent] = useState(false);
  const [FVSConfigurable, setFVSConfigurable] = useState<boolean>(false);
  const [currentBtnClass, setCurrentBtnClass] = useState<any>('');
  const [inventoryStorePickUp, setInventoryStorePickUp] = useState("");
  const defaultStore = {
    value: "Select",
    label: t("Select"),
  };
  const [radiusStores, setRadiusStores] = useState<ComboBoxOption[]>([
    defaultStore,
  ]);
  const [radiusSelected, setRadiusSelected] = useState<string>("Select");

  const [getAgreementInfoRes, setgetAgreementInfoRes] = useState<any>("");
  const [agrInfoResp, setagrInfoResp] = useState<any>("");

  // eslint-disable-next-line sonarjs/cognitive-complexity

  const searchParams = new URLSearchParams(window.location.search);

  // Get specific query parameters
  const exchangeAgreementId = searchParams.get("exagreementid");
  const [openReturnContent, setOpenReturnContent] = useState<boolean>(false);
  const [exReturnTime, setExReturnTime] = useState<any>("");
  // const [exReturnContextStartDate, SetExReturnContextStartDate] = useState<any>("");
  // const [exReturnContextEndDate, SetExReturnContextEndDate] = useState<any>("");
  const [exReturnTimeSlotId, SetExReturnTimeSlotId] = useState<any>("");
  const [exReturnBindtimeslotId, SetExReturnBindtimeslotId] = useState<any>("");
  const [getagreementResponse, setAgreementResponse] = useState<any>("");
  const [inventoryNumberExc, setInventoryNumberExc] = useState();
  const [inventoryIdExc, Setinventoryidexc] = useState([]);
  const [agrNumberExc, setAgrNumberExc] = useState<any>();
  const [slicetimeExc, setslicetimeExc] = useState<any>("");
  const [modifiedtimeExc, setmodifiedEndtimeExc] = useState<any>(false);
  let [colourExc, setcolourExc] = useState<any>("");
  const [timeSlotDataExc, SettimeSlotDataExc]: any = useState([]);

  // const [exReturnStartDate, SetExReturnStartDate] = useState<any>("");
  /*mexican store*/
  const[isLoading,setIsLoading]= useState<boolean>();
  const [selectedStore, setSelectedStore] = useState("");
  const [selectedInventory, setSelectedInventory] = useState("");
  const [selectedInventoryId, setSelectedInventoryId] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTimeSlot, setSelectedTimeSlot] = useState("");
  const [description, setDescription] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [editingRowIndex, setEditingRowIndex] = useState<number | null>(null);
  const [isProceedConfirmationPopupOpen, setProceedConfirmationPopup] = useState(false);
  const [ErrorpopupMsg, SetErrorpopupMsg] = useState(false);


  const [storeListArray, setStoreListArray] = useState([]);
  const [inventoryList, setInventoryList] = useState([]);
  const[inventoryIdList,setInventoryIdList] = useState([]);
  const [dateList, setDateList] = useState<any>([]);
  const [timeSlotList, setTimeSlotList] = useState<any>([]);
  const [salesPersonValue, setsalesPersonValue] = useState("");
  const [salesPersonOptions, setsalesPersonOptions] = useState([
    {
      value: "",
      label: t("Select"),
    },
  ]);
  const [isDisableSalesPerson, setIsDisableSalesPerson] = useState<boolean>(false)

  const [allStoreTimeSlots, setAllStoreTimeSlots] = useState<Map<string, any>>(
    new Map()
  );

  const defaultDropdownValue = {
    value: "",
    label: t("Select"),
  };

  // Commitment pre-selection: auto-select date and timeslot from AM navigation state
  useEffect(() => {
    if (commitmentAppliedRef.current) return;
    if (!TimeSlotYes || !timeSlotData?.length) return;

    const commitmentDate = (location.state as CommitmentLocationState)?.commitmentDate;
    const commitmentTime = (location.state as CommitmentLocationState)?.commitmentTime;
    if (!commitmentDate || !commitmentTime) return;

    const result = matchCommitmentToSlot(commitmentDate, commitmentTime, timeSlotData);
    if (!result) return;

    commitmentAppliedRef.current = true;
    setStartDate(result.date);
    Settimeslotid(result.slot.timeSlot);
    setBindtimeslotId(result.slot.timeSlot);
    BindtimeslotDate = result.date;
    setCurrentBtnClass(result.slot.id);
    SetSaveTrigger(false);

    if (props.triggertimeChanged !== undefined) {
      props.triggertimeChanged();
    }

    const formattedStart = moment(result.slot.startTime, "HH:mm:ss").format("LT");
    const formattedEnd = moment(result.slot.endTime, "HH:mm:ss").format("LT");
    const slicedStart = formattedStart.slice(0, 5) + formattedStart.slice(8, formattedStart.length);
    const slotDuration = slicedStart + "-" + formattedEnd;
    SetTime(slotDuration);
  }, [timeSlotData, TimeSlotYes]);

  console.log("Just Checking Time slot", timeSlotData);
  const SalesPersonOnchange = (value: any) => {
    setsalesPersonValue(value);
  };

  useEffect(() => {
    const fetchAll = async () => {
      const storeNumber = window.sessionStorage.getItem("storeNumber");
      try {
        const res = await getAgreementInfo(agreementId);
        const InventoryInformation = res.data?.agreementInventories || [];

        const uniqueStores: any = Array.from(
          new Set(
            InventoryInformation.map((item) => item.fromStoreID)
              .filter(
                (storeNumber) =>
                  storeNumber !== null && storeNumber !== undefined
              )
              .map((storeNumber) => String(storeNumber).padStart(5, "0"))
          )
        ).map((storeNumber) => ({
          label: `Store ${storeNumber}`,
          value: storeNumber,
        }));

        const inventories = InventoryInformation.map((item) => ({
          label: item.inventoryNumber,
          value: item.inventoryNumber,
          storeId: item.fromStoreID,
          description: item.description,

        }));

        const inventoryIdNo = InventoryInformation.map((item) => ({
          label: item.inventoryId,
          value: item.inventoryId,
          storeId: item.fromStoreID,
          description: item.description,
          inventoryNo:item.inventoryNumber
          
        }));

        

        console.log(inventories, "inventory list");
        uniqueStores.forEach((store) => {
          if (store.value) fetchTimeSlots(store.value);
        });

        setStoreListArray(uniqueStores);
        setInventoryList(inventories);
        setInventoryIdList(inventoryIdNo);
      } catch (error) {
        console.error("Error in fetchAll useEffect", error);
      }
    
    };

    fetchAll();
  }, [agreementId]);

  const assigneeDropDown = async () =>{
    setIsLoading(true);
      const dapStoreDetails: any = {
        type: "STORE",
        filterType: "STORE-CENTRALIZED",
        filterValue: [storeNumber],
      };
      
      const dapStoreDetailsResponse: any = await fetchOrganizationDetails(
        dapStoreDetails
      );
      console.log("dapStoreDetailsResponse", dapStoreDetailsResponse);
      if (dapStoreDetailsResponse?.status === 200) {
        let storeList: any = [];
        if (dapStoreDetailsResponse?.data == "") {
          const storenumber = window.sessionStorage.getItem("storeNumber");
          storeList = [storenumber];
          
        } else {
          const result = dapStoreDetailsResponse?.data?.result?.map(
            (item: any) => {
              storeList.push(String(item.referenceName));
            }
          );
        }

        const dropdownval: any = await getSalesPersonOptions1({
          storeNumbers: storeList,
          callSalesPersonApi: true,         
          storeNumber: window.sessionStorage.getItem("storeNumber"),
        });
        console.log("SalesPerson Data:", dropdownval);
        if (dropdownval?.status === 200 && dropdownval.data) {
          const agreementData = dropdownval.data.salespersonsData;
          setagreementOptions(agreementData);

          // Check if salesPerson exists and is an array
          if (Array.isArray(agreementData)) {
            const SalesPersonArray = agreementData.map((ele: any) => ({
              value: ele.employee_id?.toString(),
              label: ele.appUserName || "",
            }));

             SalesPersonArray.unshift(defaultDropdownValue); // Add default option
            setsalesPersonOptions(SalesPersonArray);
            setIsLoading(false);
            console.log("Dropdown options:", SalesPersonArray);
          } else {
            console.warn("No salesPerson data found.");
            setsalesPersonOptions([defaultDropdownValue]); // fallback
            setIsLoading(false)
          }
        
        } else {
          console.error("Dropdown API failed", dropdownval);
          setIsLoading(false)
        }
      }
  
}

  console.log(
    selectedStore,
    selectedInventory,
    "after the useEffect selected");

  const fetchTimeSlots = async (storeIdValue: string) => {
    let storeId : any;

    if(storeIdValue.length < 5){     
       storeId = storeIdValue.padStart(5, "0");
    }else{
       storeId = storeIdValue;
    }
    

    const startDateInfo = moment().format("YYYY-MM-DD");
    const endDateInfo = moment().add(9, "days").format("YYYY-MM-DD");

    const payload = {
      isLoaner: "Y",
      customerId: customerId,
      startDate: startDateInfo,
      endDate: endDateInfo,
      eventSource: "STO",
      storeId: storeId,
    };

    try {
      const response = await GetTimeSlots(payload);
      const timeSlots = response.data?.timeSlots;

      if (timeSlots) {
        setAllStoreTimeSlots((prev) => {
          const updated = new Map(prev);
          updated.set(storeId, timeSlots);
          return updated;
        });
      }

      console.log(`Fetched raw time slots for store ${storeId}`, timeSlots);
    } catch (err) {
      console.error("Error fetching time slots", err);
    }
  };

  useEffect(() => {

    console.log("inside the useffect")
    if (rows.length > 0 && timeslotid && startDate && Time && mxDeliveryKey) {
      console.log("inside the useffect of delivery schedule ",timeslotid, startDate)
     
      const getDeliveryMoment = (dateStr: string, timeStr: string): moment.Moment => {
        const cleaned = timeStr.replace(/\s+/g, ' ').trim(); // Normalize spaces
      
        // Match pattern like "10:00 - 12:00 PM" or "11:00-1:00 AM"
        const match = cleaned.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})\s*(AM|PM)/i);
      
        if (!match) {
          console.error("Invalid delivery time format:", cleaned);
          return moment.invalid();
        }
      
        const [, startTime, endTime, endAmPm] = match;
        const endHour = parseInt(endTime.split(":")[0], 10);
        const startHour = parseInt(startTime.split(":")[0], 10);
        const endAmPmUpper = endAmPm.toUpperCase();
      
        let startAmPm;
    
    if (endAmPmUpper === 'AM') {
      if (endHour === 12) {
        startAmPm = 'PM';
      } else {
        startAmPm = 'AM';
      }
    } else { // PM
      if (endHour === 12) {
        startAmPm = 'AM';
      } else {
        startAmPm = 'PM';
      }
    }  
        const fullTime = `${startTime} ${startAmPm}`;
        return moment(`${dateStr} ${fullTime}`, "YYYY-MM-DD hh:mm A");
      };
      
      const getPickupMoment = (
        storeId: string,
        dateStr: string,
        timeSlotId: string
      ): moment.Moment => {
        const rawSlots = allStoreTimeSlots.get(storeId);
        if (!rawSlots || !rawSlots[dateStr]) return moment.invalid();
  
        const slot = rawSlots[dateStr].find((s: any) => s.timeSlot === timeSlotId);
        if (!slot) return moment.invalid();
        console.log("Inside the getpickup moment",slot,dateStr);

  
        return moment(`${dateStr} ${slot.startTime}`, "YYYY-MM-DD HH:mm:ss");
      };
  
      const deliveryMoment = getDeliveryMoment(startDate, Time);
      if (!deliveryMoment.isValid()) return;
  
      console.log("deliveryMomet",deliveryMoment);
      
      const hasInvalidPickup = rows.some((row) => {
        const pickupMoment = getPickupMoment(row.store, row.date, row.timeSlot);
        return pickupMoment.isSameOrAfter(deliveryMoment);
      });
      console.log(hasInvalidPickup,"value of hasInvalidPickup")
  
      if (hasInvalidPickup) {
        SetErrorpopupMsg(true);
        SetDisplayErrorMessage("Selected delivery date is invalid for the scheduled pickup.");
        setRows([]);
        return;
      }
    }
  
    if (selectedStore) {
      console.log(startDate, Time, "the time selected", selectedDate, selectedTimeSlot);
      filterTimeSlotsForDelivery(selectedStore, startDate, Time);
    }
  }, [timeslotid, selectedStore, Time, startDate, rows]);
  

  const filterTimeSlotsForDelivery = (
    storeId: string,
    deliveryDateStr: string,
    deliveryTimeStr: string,
    inventoryId?: string
  ) => {
    setSelectedDate("");
    setSelectedTimeSlot("");
    console.log(deliveryDateStr,deliveryTimeStr,"filterTimeSlots");
    
    const rawSlots = allStoreTimeSlots.get(storeId);
    if (!rawSlots) return;

    const deliveryDate = moment(deliveryDateStr, "YYYY-MM-DD");

    const timeMatch = deliveryTimeStr.match(/(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})\s*(AM|PM)/i);
    if (!timeMatch) {
      console.error("Invalid time format:", deliveryTimeStr);
      return;
    }
    
    let [, startTime, endTime, endAmPm] = timeMatch;
    
    let startHour = parseInt(startTime.split(":")[0], 10);
    let endHour = parseInt(endTime.split(":")[0], 10);
    
    const endAmPmUpper = endAmPm.toUpperCase();
    
    // Determine start AM/PM based on rules you gave:
    let startAmPm;
    
    if (endAmPmUpper === 'AM') {
      if (endHour === 12) {
        startAmPm = 'PM';
      } else {
        startAmPm = 'AM';
      }
    } else { // PM
      if (endHour === 12) {
        startAmPm = 'AM';
      } else {
        startAmPm = 'PM';
      }
    }
    
    const fullStartTime = `${startTime} ${startAmPm}`;
    const fullEndTime = `${endTime} ${endAmPmUpper}`;
    
    // Create moments with the deliveryDate
    const deliveryStartMoment = moment(fullStartTime, "hh:mm A");

    console.log(fullStartTime,deliveryStartMoment,"delivery start time");
    

    const sortedDates = Object.keys(rawSlots).sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime()
    );

    const dateArray: any[] = [];
    const slotArray: any[] = [];

    for (const date of sortedDates) {
      const dateMoment = moment(date, "YYYY-MM-DD");

      if (dateMoment.isAfter(deliveryDate, "day")) continue;

      const slotsForDate = rawSlots[date] || [];

      const availableSlots = slotsForDate.filter((slot: any) => {
        const slotTime = moment(slot.startTime, "HH:mm:ss");
        let slotTimeFormatted = slotTime.format("hh:mm A");

        if (dateMoment.isSame(deliveryDate, "day")) {
          console.log(slotTimeFormatted ,"that day slotTime");
          
          return (
            slot.status === "Available" &&
            slotTime.isBefore(deliveryStartMoment)
          );
        }

        return slot.status === "Available";
      });

      if (availableSlots.length > 0) {
        dateArray.push({
          label: date,
          value: date,
          inventoryId,
        });

        availableSlots.forEach((slot: any) => {
          slotArray.push({
            label: `${slot.startTime} - ${slot.endTime}`,
            value: slot.timeSlot,
            dateId: date,
          });
        });
      }
    }

    setDateList(dateArray);
    setTimeSlotList(slotArray);

    console.log("Filtered date options", dateArray);
    console.log("Filtered time slots", slotArray);
  };
  

  console.log(storeListArray.length, "value of array", storeListArray);
  console.log(dateList, "select date");

  const getStoreOptions = () => {
    const usedInventories = new Set(rows.map((r) => r.inventory));
  
    const options = storeListArray.filter((store: any) => {
      const storeId = String(store.value).padStart(5, "0");
  
      // Find inventories for this store
      const storeInventories = inventoryList.filter(
        (inv: any) => String(inv.storeId).padStart(5, "0") === storeId
      );
  
      // Check if at least one inventory is unused
      return storeInventories.some((inv: any) => !usedInventories.has(inv.value));
    })
    .map((store: any) => ({
      label: store.value,
      value: store.value,
    }));
  
    return [
      {  label: t("Select"), value: "", disabled: true },
      ...options,
    ];
  };
  
  
    const getInventoryOptions = (storeId: string) => {
      console.log(storeId, "inside getInventory");
      console.log(rows, "rows looks");
  
      const used = new Set(rows.map((r) => r.inventory));
      console.log(used, "used looks");
  
      const options = inventoryList
        .filter(
          (i: any) =>
            String(i.storeId).padStart(5, "0") ===
            String(storeId).padStart(5, "0")
        )
        .filter((i: any) => !used.has(i.value))
        .map((i: any) => ({
          label: i.value,
          value: i.value,
        }));
      console.log(inventoryList, "inventory state variable");
      console.log(options, "inventorylist");
  
      const usedInventoryId = new Set(rows.map((r) => r.inventory));
      console.log(used, "used looks");
  
      const inventoryIdValue = inventoryIdList
        .filter(
          (i: any) =>
            String(i.storeId).padStart(5, "0") ===
            String(storeId).padStart(5, "0")
        )
        .filter((i: any) => !usedInventoryId.has(i.inventoryNo))
        .map((i: any) => ({
          label: i.value,
          value: i.value,
        }));
  
      return [{  label: t("Select"), value: "" }, ...options];
    };
  

  const getDateOptions = (inventoryId: string, isEditmode : boolean) => {
    console.log(inventoryId, "inventoryId");
    console.log(dateList, "date values");
    console.log(rows, "rows looks");
    
    // Reset timeSlot only for rows with matching inventoryId
//   if(isEditmode){
//     const updatedRows = rows.map((r) => {
//       if (r.inventoryId === inventoryId) {
//         return { ...r, timeSlot: "" };
//       }
//       return r;
//     });
//     setRows(updatedRows); 
//   }
//  // Use the state setter here
    

    const used = new Set(rows.map((r) => `${r.value}-${r.inventoryId}`));
    console.log(used, "used looks");

    const options = dateList
      .filter((d: any) => !used.has(`${d.value}-${inventoryId}`))
      .map((d: any) => ({
        label: moment(d.value, "YYYY-MM-DD").format("ddd, MMMM D"),
        value: d.value,
        inventoryId: d.inventoryId,
      }));

    console.log(options, "dateoptions");

    return [{label: t("Select"), value: "" }, ...options];
   };
  

   const getTimeSlotOptions = (dateId: string) => {
    const used = new Set(rows.map((r) => r.timeSlot));
  
    const options = timeSlotList
      .filter((t: any) => t.dateId === dateId)
      
      .map((t: any) => {
        const [start, end] = t.label.split("-");

        const formattedStart = moment(start.trim(), "HH:mm:ss").format(
          "hh:mm A"
        );
        const formattedEnd = moment(end.trim(), "HH:mm:ss").format("hh:mm A");
  
  
        return {
          ...t,
          label: `${formattedStart} - ${formattedEnd}`,
        };
            });     
            return [{ label: t("Select"), value: "" }, ...options]; 
       };
  
  


  const deleteRow = (index) => {
    console.log(startDate,Time,"the time selected ",

    selectedDate,selectedTimeSlot)
  
    const updatedRows = [...rows];
    updatedRows.splice(index, 1); // Remove the row at the specified index
  
    setRows(updatedRows);
    setEditingRowIndex(null); // Optional: reset edit state if needed
  };
  
  function formatDateInGrid(input: string): string {
    const date = new Date(input + 'T00:00:00')

    console.log("Date Input", input);

    // if (isNaN(date.getTime())) {
    //   throw new Error("Invalid date format. Expected format like '2025-06-10'");
    // }

    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const dayOfWeek = weekdays[date.getDay()];
    const month = months[date.getMonth()];
    const day = date.getDate();
    console.log(dayOfWeek,month,day,"date format for grid");
    

    return `${dayOfWeek}, ${month} ${day}`;
  }

  function formatTimeRange(input: string): string {
    const match = input.match(/^(\d+)([AP])$/i);
    if (!match) {
      throw new Error("Invalid time format. Expected format like '8A' or '9P'");
    }

    let hour = parseInt(match[1], 10);
    let period = match[2].toUpperCase();

    if (hour < 1 || hour > 12) {
      throw new Error("Hour must be between 1 and 12.");
    }

    // Convert to 24-hour format for easier calculation
    let startHour24 =
      period === "P" && hour !== 12
        ? hour + 12
        : period === "A" && hour === 12
        ? 0
        : hour;

    // Add 2 hours
    let endHour24 = (startHour24 + 2) % 24;

    // Convert back to 12-hour format
    let endPeriod = endHour24 >= 12 ? "PM" : "AM";
    let endHour = endHour24 % 12 === 0 ? 12 : endHour24 % 12;
   
    return `${hour}:00 - ${endHour}:00 ${endPeriod}`;
  }

  useEffect(() => {
    const selected : any= inventoryList.find(
      (i: any) => i.value === selectedInventory
    );
    setDescription(selected?.description || "");
  }, [selectedInventory]);

  const handleAddRow = () => {
    console.log(selectedStore,selectedInventory,selectedDate,selectedTimeSlot,"Inside Add row")
    if (
      !selectedStore ||
      !selectedInventory ||
      !selectedDate ||
      !selectedTimeSlot
    ) {
      // Optional: show a message to fill all fields
      return;
    }

    const newRow = {
      store: selectedStore,
      inventory: selectedInventory,
      inventoryIdvalue:selectedInventoryId,
      date: selectedDate,
      timeSlot: selectedTimeSlot,
      description: description,
    };

    const exists = rows.some(
      (r) =>
        r.store === newRow.store &&
        r.inventory === newRow.inventory &&
        r.date === newRow.date &&
        r.timeSlot === newRow.timeSlot &&
        r.invetoryIdvalue === newRow.inventoryIdvalue,
    );

    if (!exists) {
      setRows((prev) => [...prev, newRow]);

      // Reset all selections
      setSelectedStore("");
      setSelectedInventory("");
      setSelectedInventoryId("");
      setSelectedDate("");
      setSelectedTimeSlot("");
      setDescription("");
    } else {
      // Optional: show a message that row already exists
    }
  };

 
  const renderTableContentGrid = () =>
    rows.map((row, index) => (
      <RACTableRow key={index}>
        
        <RACTableCell style={{ width: '17%',  marginRight: '25px'}}>
        {row.store}
        </RACTableCell>

        <RACTableCell style={{ width: '17%' }}>
        {row.inventory}
        </RACTableCell>  
         {console.log(row.date,row,"inside the grid")}
        <RACTableCell  style={{ width: '17%' }}>
          {editingRowIndex === index ? (
            <div style={{ position: 'relative', width: '100%' }}>
              <RACSelect
                style={{ width: '100%' }}
                options={getDateOptions(row.inventory, true)}            
                defaultValue={row.date}
                onChange={(e) => { 
                  const updated = [...rows];
                  updated[index].date = e.target.value;
                  const validDateOptions = getDateOptions(row.inventory, true);
                  
                  // Step 3: Check if the current timeSlot is still valid
                  const currentTimeSlot = updated[index].timeSlot;
                  const isTimeSlotStillValid = validDateOptions.some(
                    (opt) => opt.value === currentTimeSlot
                  );
  
                  // Step 4: If invalid, reset to "Select" (value: "")
                  if (!isTimeSlotStillValid) {
                    updated[index].timeSlot = ""; // or validDateOptions[0].value
                  }
                  setRows(updated);
                }}
              />
              {!row.date && (
               <div style={{ color: 'red', marginTop: '4px', minHeight: '18px' }}>
                  {t("Please select a valid date")}
                </div>
              )}
            </div>
          ) : (
            <>{formatDateInGrid(row.date)}</>
          )}
        </RACTableCell>
  

        <RACTableCell  style={{ width: '17%' }}>
          {editingRowIndex === index ? (
             <div style={{ position: 'relative', width: '100%' }}>
              <RACSelect
                style={{ width: '100%' }}
                options={getTimeSlotOptions(row.date)}
                defaultValue={row.timeSlot}
                onChange={(e) => {
                  const updated = [...rows];
                  updated[index].timeSlot = e.target.value;
                  setRows(updated);
                }}
              />
              {!row.timeSlot && (
              <div style={{ color: 'red', marginTop: '4px', minHeight: '18px' }}>
                 {t("Please select a valid timeslot")}
                </div>
              )}
            </div>
          ) : (
            <>{formatTimeRange(row.timeSlot)}</>
          )}
        </RACTableCell>
  
        <RACTableCell
          style={{
            maxWidth: 100,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {row.description}
        </RACTableCell>
  
        <RACTableCell>
          {editingRowIndex === index ? (
            <RACButton
              onClick={() => setEditingRowIndex(null)}
              variant="icon"
              disabled={!row.date || !row.timeSlot}
            >
              <TickIcon style={{ fontSize: "5rem" }} />
            </RACButton>
          ) : (
            <RACButton
              onClick={() => setEditingRowIndex(index)}
              variant="icon"
            >
              <EditIcon style={{ fontSize: "5rem" }} />
            </RACButton>
          )}
          
          <RACButton onClick={() => deleteRow(index)} variant="icon">
            <DeleteRedIcon />
          </RACButton>
        </RACTableCell>

      </RACTableRow>
    ));
  
   

  const handleFinish = async () => {
    // MX Store validation: Check if agreement source store matches current store
    if (mxDeliveryKey) {
      const agreementSourceStore = getAgreementInfoRes?.agreementInformation?.storeNumber;
      const currentStore = window.sessionStorage.getItem("storeNumber");
      
      if (agreementSourceStore && currentStore && agreementSourceStore !== currentStore) {
        SetErrorpopup(true);
        SetDisplayErrorMessage(t("Agreement belongs to a different store. Please schedule delivery from the source store."));
        return;
      }
    }

    // setmasterLoader(true);

    const deliveryDetails = {
      date: startDate,
      store: storeNumber,
      inventory: InventoryNumber,
      timeSlot: timeslotid,
      description: "",
      type: 'D'
    };
    const updatedExistingRows = rows.map((r) => ({
      ...r,
      inventory: [
        {
          inventoryNumber: r.inventory,
        },
      ],
      type: "P", // Adding the new field 'type' with value "P" at the same level as 'inventory'
    }));
    console.log(deliveryDetails,"delivery details");

    // Append static row to the existing rows
    const combinedRows = [...updatedExistingRows, deliveryDetails];

    // Mark all rows as pending
    const updatedRows = combinedRows.map((r) => ({ ...r, status: "pending" }));
    // setRows(updatedRows);

    const promises = updatedRows.map((row) => {
      return Complete_delivery_status(false, row);
    });

    const results = await Promise.all(promises);
    console.log(results, "result from simultaneous call");
    
    
   
let pickupStatus = "success";
let deliveryStatus = "success";

results.forEach((item : deliveryResultStatus | any) => {
 const { status , row } = item

  let TransferStatus = status
  if (row.type === "P") {
    console.log(status,"status result");
    
     if (TransferStatus === "failed") {
      pickupStatus = "failed";
    }
  } else if (row.type === "D") {
    console.log(status,"deliverly type status");
    if (TransferStatus === "failed") {
      deliveryStatus = "failed";
    }
  }
});


  if (pickupStatus === "failed" && deliveryStatus === "success") {
    // Notify: Pickup failed, delivery passed
    console.log("inside pick failed delivey passed");
    
    setProceedConfirmationPopup(true);
    return;
  }

  if (pickupStatus === "success" && deliveryStatus === "failed") {
    console.log("inside pick success delivey failed");
    SetErrorpopup(true);
    SetDisplayErrorMessage("Something Went Wrong");
    return;
  }

  if (pickupStatus === "failed" && deliveryStatus === "failed") {
    console.log("both failed");
    
    SetErrorpopup(true);
    SetDisplayErrorMessage("Something Went Wrong");
    return;
  }
  console.log("both passed");
  
  // Both passed
  SetOpendeliveryconfirmpopup(true);
  };

  console.log(
    { exReturnTime, exReturnBindtimeslotId, exReturnTimeSlotId, startDateExc },
    "exReturnTimeeeeeeee"
  );
  console.log(Time, "Timeeeeeee");
  useEffect(() => {
    console.log("WindowSize", window.innerWidth);
    windowSizeFn();
  }, []);
  useEffect(() => {
    if (
      getCustomerResponse &&
      getCustomerResponse?.GetApproval?.value?.customerApprovalDetails
        ?.verificationStatus != "COMPLETED" &&
      getCustomerResponse?.GetApproval?.value?.customerApprovalDetails
        ?.verificationStatus != "NOTREQUIRED" &&
      featureFlagDetails?.CustomerVerificationOptimization == 1 && featureFlagDetails?.MXDecisionEngine != 1
    ) {
      setverificationWarningPopup(true);
    }
  }, [getCustomerResponse]);

  useEffect(() => {
    getAgreementDeliveryFn();
  }, [LMDConfigurable]);

  useEffect(() => {
    const { isRenderedByContainer } = window;
    setHeaderPresent(
      isRenderedByContainer != null && isRenderedByContainer != undefined
        ? true
        : false
    );
  }, []);

  useEffect(() => {
    let employeeIdGA: any;
    let loggedRole: any;
    const GettingRole = async () => {
      const userResponse = await getCurrentInfo();
      console.log("getCurrentUser Response", userResponse);
      const empId = userResponse?.data?.employeeId;
      const mailId = userResponse?.data?.email.toLowerCase();
      const id = userResponse?.data?.employeeId ? empId : mailId;
      let storesPayload: any;
      // eslint-disable-next-line prefer-const
      storesPayload = { coworkerId: id };
      // eslint-disable-next-line no-console
      console.log("coworkerId", storesPayload);
      const userRole = await GetRole(storesPayload);
      const coworkerRole = userRole?.data?.coworkerProfile?.role;
      setEmployeeId(userRole?.data?.coworkerProfile?.employeeId);

      // eslint-disable-next-line no-console
      console.log("Logged In user Role : ", coworkerRole);

      setCurrentUserRole(coworkerRole);
      loggedRole = coworkerRole;
      employeeIdGA = userRole?.data?.coworkerProfile?.employeeId;
    };
    if (containerData !== undefined) {
      console.log("containerData", containerData);

      console.log("containerDataRole", containerData?.GetRole());
      setEmployeeId(containerData?.GetEmployeeId());
      setCurrentUserRole(containerData?.GetRole());
      loggedRole = containerData.GetRole();
      employeeIdGA = containerData?.GetEmployeeId();
    } else {
      GettingRole();
    }
    window.dataLayer?.push({
      event: "Loaded the Rental-Agreement Delivery Schedule page",
      customerId: customerId,
      storeNo: storeNumber,
      agreementNo: agreementId,
      employeeId: employeeIdGA,
      role: loggedRole,
      currentScreen: "Rental-Agreement Schedule page",
      previousScreen: "Initial Payment",
    });
  }, [containerData]);

  const determineLocationId = (): any => {
    if (radiusSelected != "Select") {
      return radiusSelected;
    }

    return;
  };

  const buildPayload = (
    locationId: string,
    parentAppointmentID: string,
    numOfCoworkers: string,
    eventType: string,
    invIds: any,
    invNumbers: any
  ) => {
    return {
      storeNumber: storeNumber,
      address_id: IdAddress,
      eventInformation: {
        partyId: customerId,
        agreementId: agreementId,
        inventoryIds: invIds,
        type: eventType,
        eventDate: moment(startDate).format("MM/DD/YYYY"),
        eventSource: "Store",
        timeSlot: {
          timeSlotId: timeslotid,
        },
        eventInstruction: Instructions,
        requiredCoworkers: numOfCoworkers,
        racdbSourced: true,
        agreementNumber: AgrNumber,
        customerName: cusName,
        isLoaner: "Y",
        loanerCreate: {
          storeNumber: storeNumber,
          timeSlot: timeslotid,
          customerId: String(customerId),
          agreementNumber: AgrNumber,
          inventories: invNumbers,
          appointmentInfo: {
            appointmentType: "STOPIC",
            appointmentSource: AppoinmentSource,
            locationId: locationId,
            parentAppointmentId: parentAppointmentID,
            appointmentDate: startDate,
            requiredCoworkers: numOfCoworkers,
            instructions: Instructions,
          },
        },
      },
    };
  };

  const buildPayload2 = (
    locationId: string,
    parentAppointmentID: string,
    numOfCoworkers: string,
    eventType: string
  ) => {
    return {
      storeNumber: storeNumber,
      address_id: IdAddress,
      eventInformation: {
        partyId: customerId,
        agreementId: agreementId,
        inventoryIds: inventoryid,
        type: eventType,
        eventDate: moment(startDate).format("MM/DD/YYYY"),
        eventSource: "Store",
        timeSlot: {
          timeSlotId: timeslotid,
        },
        eventInstruction: Instructions,
        requiredCoworkers: numOfCoworkers,
        racdbSourced: true,
        agreementNumber: AgrNumber,
        customerName: cusName,
        isLoaner: "Y",
        loanerCreate: {
          storeNumber: storeNumber,
          timeSlot: timeslotid,
          customerId: String(customerId),
          agreementNumber: AgrNumber,
          inventories: InventoryNumber,
          appointmentInfo: {
            appointmentType: "STOPIC",
            appointmentSource: AppoinmentSource,
            locationId: locationId,
            parentAppointmentId: parentAppointmentID,
            appointmentDate: startDate,
            requiredCoworkers: numOfCoworkers,
            instructions: Instructions,
          },
        },
      },
    };
  };

  // const createStorePickupEvent2 = async (apiResult: any, numOfCoworkers: string, returningAgreement: boolean): Promise<any> => {

  //   if (apiResult && apiResult.status == 200) {
  //   const parentAppointmentID = String(apiResult.data?.appointmentInfo?.appointmentId); //zz
  //   if ((Deliverytype == "D" || Deliverytype == "P") && LMDConfigurable && locationId && parentAppointmentID) {

  //     // we have created the parent appointment since store pickups are ONLY created if there is a parent appointment
  //     const locationId = determineLocationId();

  //     // only for Delivery Type and if turned on for the store and if the coworker selected a radius store

  //       let eventType = "D";
  //       if (returningAgreement) {  // we are returning the agreement so the Delivery Type is Pickup P not Delivery since we are getting
  //         eventType = "Return";
  //       }
  //       numOfCoworkers = numOfCoworkers ? numOfCoworkers : '1';

  //       // create the store pickup to the radius store selected
  //
  //       const payload = buildPayload2(locationId, parentAppointmentID, numOfCoworkers, eventType);
  //       await FinishdeliveryStatus(payload);
  //     }
  //   }

  //   return;
  // }
  const createStorePickupEvent = async (
    apiResult: any,
    numOfCoworkers: string,
    returningAgreement: boolean
  ): Promise<any> => {
    console.log("Inside CreatStorePickup");

    if (!apiResult || apiResult.status != 200) return;
    const parentAppointmentID = String(
      apiResult.data?.appointmentInfo?.appointmentId
    );
    console.log("Inside CreatStorePickup");
    if (
      !(
        (Deliverytype == "D" || Deliverytype == "P") &&
        LMDConfigurable &&
        parentAppointmentID
      )
    )
      return;
    let eventType = "D";
    console.log("Inside CreatStorePickup");
    if (returningAgreement) {
      // we are returning the agreement so the Delivery Type is Pickup P not Delivery since we are getting
      eventType = "Return";
    }
    numOfCoworkers = numOfCoworkers ? numOfCoworkers : "1";
    console.log("Inside CreatStorePickup");
    let targetStore: any[] = [];
    for (const item of inventoryInfo) {
      if (item.store === "Select") continue;
      let target = targetStore.find((element) => element.store == item.store);
      if (target) {
        target.inventoryId.push(item.inventoryId);
        target.inventoryNumber.push({ inventoryNumber: item.inventoryNumber });
      } else {
        let inventoryId: any[] = [];
        inventoryId.push(item.inventoryId);
        let inventoryNumber: any[] = [];
        inventoryNumber.push({
          inventoryNumber: item.inventoryNumber,
        });
        targetStore.push({
          store: item.store,
          inventoryId: inventoryId,
          inventoryNumber: inventoryNumber,
        });
      }
    }
    console.log("Inside CreatStorePickup");
    for (let i = 0; i < targetStore.length; i++) {
      const payload = buildPayload(
        targetStore[i].store,
        parentAppointmentID,
        numOfCoworkers,
        eventType,
        targetStore[i].inventoryId,
        targetStore[i].inventoryNumber
      );
      const result = await FinishdeliveryStatus(payload);
      console.log(result, "in createStorePickupEvent");

      if (result.status == 400) {
        const storeMsg = buildStorePickupMsg(i, targetStore);
        setStorepickupMsg(storeMsg);
        return;
      }
    }
  };
  const buildStorePickupMsg = (index: any, storelist: any): string => {
    let result = "";
    for (let i = index; i < storelist.length; i++) {
      result += storelist[i].store;
      if (i != storelist.length - 1) result += ",";
    }
    return result;
  };

  const buildRadiusStores = (resp: any): void => {
    if (resp && resp.data) {
      let outputFromSvc: RadiusStoreType = resp.data;
      if (outputFromSvc && outputFromSvc.response?.length > 0) {
        let allStores: ComboBoxOption[] = [defaultStore];
        outputFromSvc.response.forEach((oneStore) => {
          const st: ComboBoxOption = {
            value: oneStore.neighborStoreId,
            label: oneStore.neighborStoreNumber,
          };
          allStores.push(st);
        });

        setRadiusStores(allStores);
      }
    }
  };
  //LMD configurable
  const getEnableLMD = async () => {
    const bodyObj = {
      storeNumbers: [storeNumber],
      paramKeyNames: ["EnableLMD"],
    };

    const enableAccessLMD = await CoworkerRequired(bodyObj);
    return enableAccessLMD?.data.storeProfileResponse.configDetails[0]
      .configDetails[0].paramValue;
  };

  //FVS configurable
  const getEnableFVS = async () => {
    const bodyObj = {
      storeNumbers: [storeNumber],
      paramKeyNames: ['EnableFieldVisitStrategy']
    }

    const enableAccessFVS = await CoworkerRequired(bodyObj)

    let enableFVS = enableAccessFVS?.data.storeProfileResponse.configDetails[0].configDetails[0].paramValue;
    if (!enableFVS) {
      enableFVS = false
    }
    if (enableFVS != FVSConfigurable) setFVSConfigurable(enableFVS);

  }

  const getAgreementDeliveryFn = async () => {
    setmasterLoader(true);

    let showLMD =
      !props.isReturn &&
      (props.reScheduleData == undefined ||
        props.reScheduleData.deliveryType == "");
    const enableLMD = await getEnableLMD();

    let getAgreementInfoRes = await getAgreementInfo(agreementId);
    console.log(
      "getAgreementInfoRes in getAreementDeliveryFn",
      getAgreementInfoRes
    );

    setgetAgreementInfoRes(getAgreementInfoRes?.data);
    setmasterLoader(false);
    if (getAgreementInfoRes?.data?.agreementInformation?.appointmentId) {
      setmasterLoader(true);
      let getAgreementDeliveryRes1 = await getAgreementDelivery(
        agreementId,
        getAgreementInfoRes?.data?.agreementInformation?.appointmentId
      );
      setmasterLoader(false);
      if (
        getAgreementDeliveryRes1?.status == 200 &&
        getAgreementDeliveryRes1?.data
      ) {
        if (
          getAgreementDeliveryRes1?.data?.appointmentInfo?.appointmentStatus ==
            "TD" ||
          getAgreementDeliveryRes1?.data?.appointmentInfo?.appointmentStatus ==
            "CMP"
        ) {
          setdatePickerEnable(true);
          setRescheduleEnable(true);
        }
        setgetAgreementDeliveryRes(getAgreementDeliveryRes1?.data);
      }
    } else if (createAAgreementTiemslot) {
      setdatePickerEnable(true);
      setRescheduleEnable(true);
    }

    if (showLMD) {
      if (enableLMD === "1") {
        buildRadiusStores(await getRadiusStores(storeNumber));
        setLMDConfigurable(true);
      }
    }
  };

  const windowSizeFn = async () => {
    if (window.innerWidth <= 1280) {
      settimeslotCount(3);
      setdesktopView(false);
      setdatePickerEnable(false);
    } else {
      setRescheduleEnable(false);
      settimeslotCount(5);
      setdesktopView(true);
      setdatePickerEnable(false);
    }
  };
  useEffect(() => {
    const checkForOverrides = async () => {
      setOverrideButtonOff(true);
      if (timeSlotData != undefined && timeSlotData.length > 0) {
        for ( let idx = 0 ; idx < timeSlotData.length ; idx++ ) {
          const dateForFieldCheck = timeSlotData[idx].Date;
          const datesTimeSlot = timeSlotData[idx].TimeSlots;
          for ( let innerIdx = 0 ; innerIdx < datesTimeSlot?.length ; innerIdx ++ ) {
            if ( datesTimeSlot[innerIdx].status == 'Busy' ) {
              // check to see if there is a FIELD event
              if ( await fieldEventPresent( dateForFieldCheck, datesTimeSlot[innerIdx].timeSlot ) ) {
                setOverrideButtonOff(false);  // turn the button ON 
              }
            }
          }      
        }
      }      
    }
    
    if (TimeSlotYes && timeSlotData.length > 0) {
      let yourDate = timeSlotData[0]["Date"];
      if (timeSlotData[0]["Date"].length) {
        const pastDateCheckRes = isPastDateCheck(yourDate);
        if (pastDateCheckRes) {
          setpreviousBtnEnable(true);
        } else {
          setpreviousBtnEnable(false);
        }
      }
    }

    checkForOverrides();

    console.log("timeSlotDataCheck", timeSlotData);
  }, [timeSlotData]);


  const fieldEventPresent = async ( dateToCheck, timeslotToCheck ) => {
    // call the service here 
     const payload = {        
        storeNumber: storeNumber,
        startDate: dateToCheck,
        endDate: dateToCheck,
        appointmentTypes: ["FIELD"],
      };
      const apts = await getCustomerAppointment(payload);
      
      if (apts?.data?.appointments && apts?.data?.appointments.length > 0) {
        for ( let idx = 0 ; idx < apts.data.appointments.length; idx++ ) {
          if (apts.data.appointments[idx].timeSlotInfo?.timeSlot == timeslotToCheck ) {
            
            return true;
          }
        }
      } 


      return false;
      
  };

  const isPastDateCheck = (dateString: any) => {
    let date1: any = "";
    let date2: any = "";
    date2 = date2 = new Date(dateString);
    date1 = new Date(
      new Date().toLocaleString("en-US", { timeZone: "America/Chicago" })
    );
    const differenceInMilliseconds = date2 - date1;
    let differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    differenceInDays = Math.ceil(differenceInDays);
    if (differenceInDays > 0) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    /* eslint-disable no-console */
  // debugger
    console.log("Props Log", props);

    if (props !== undefined && props.reScheduleData !== undefined) {
      if (
        props.AgrNum != undefined &&
        props.AgrNum != null &&
        props.InvId != undefined &&
        props.InvId != null
      ) {
        Setinventoryid(props.InvId);
        SetagreementNumber(props.AgrNum);
      }

      if (
        props.globalCustomerId != undefined &&
        props.globalCustomerId != null
      ) {
        SetGCID(props.globalCustomerId);
      }

      SetRescheduleProps("Reschedule");
      getCoworkerRequiredData();
      getEnableFVS();
      getStatedata();
      GetAddressMethod();
      // getInventoryId();
      setmasterLoader(false);
      GetTimeSlot(
        props.reScheduleData.appointmentDate !== undefined &&
          props.reScheduleData.appointmentDate !== ""
          ? props.reScheduleData.appointmentDate
          : "",
        props?.reScheduleData?.appointmentSource
      );

      GetTimeSlotExc(
        props.reScheduleData.appointmentDate !== undefined &&
          props.reScheduleData.appointmentDate !== ""
          ? props.reScheduleData.appointmentDate
          : "",
        props?.reScheduleData?.appointmentSource
      );
      // eslint-disable-next-line no-console
      console.log(coWorkerRequiredArray);
      setBindtimeslotId(
        props.reScheduleData.timeSlotId !== undefined &&
          props.reScheduleData.timeSlotId !== ""
          ? props.reScheduleData.timeSlotId
          : ""
      );
      SetExReturnBindtimeslotId(
        props.reScheduleData.timeSlotId !== undefined &&
          props.reScheduleData.timeSlotId !== ""
          ? props.reScheduleData.timeSlotId
          : ""
      );
      // BindtimeslotId =
      //   props.reScheduleData.timeSlotId !== undefined &&
      //   props.reScheduleData.timeSlotId !== ''
      //     ? props.reScheduleData.timeSlotId
      //     : '';
      BindtimeslotDate =
        props.reScheduleData.appointmentDate !== undefined &&
        props.reScheduleData.appointmentDate !== ""
          ? props.reScheduleData.appointmentDate
          : "";
      ExBindtimeslotDate =
        props.reScheduleData.appointmentDate !== undefined &&
        props.reScheduleData.appointmentDate !== ""
          ? props.reScheduleData.appointmentDate
          : "";

      const StartingTime =
        props.reScheduleData.appointmentStartTime !== undefined &&
        props.reScheduleData.appointmentStartTime !== ""
          ? props.reScheduleData.appointmentStartTime
          : "";
      const EndingTime =
        props.reScheduleData.appointmentEndTime !== undefined &&
        props.reScheduleData.appointmentEndTime !== ""
          ? props.reScheduleData.appointmentEndTime
          : "";
      const slicedStartdate =
        StartingTime.slice(0, 5) + StartingTime.slice(8, StartingTime.length);

      const Selectedslot = slicedStartdate + "-" + EndingTime;
      const slotDuration =
        moment(StartingTime, "HH:mm").format("hh:mm") +
        "-" +
        moment(EndingTime, "HH:mm").format("hh:mm A");
      SetTime(slotDuration);

      SetContextStartDate(
        props.reScheduleData.appointmentStartTime !== undefined &&
          props.reScheduleData.appointmentStartTime !== ""
          ? props.reScheduleData.appointmentStartTime
          : ""
      );

      SetContextEndDate(
        props.reScheduleData.appointmentEndTime !== undefined &&
          props.reScheduleData.appointmentEndTime !== ""
          ? props.reScheduleData.appointmentEndTime
          : ""
      );

      // if(exchangeAgreementId){
      setStartDateExc(moment(ExBindtimeslotDate).format("YYYY-MM-DD"));
      // }
      // else{
      setStartDate(moment(BindtimeslotDate).format("YYYY-MM-DD"));
      // }

      SetCoworkers(
        props.reScheduleData.coWorkersRequired !== undefined &&
          props.reScheduleData.coWorkersRequired !== ""
          ? props.reScheduleData.coWorkersRequired
          : ""
      );
      SetCoworkersExc(
        props.reScheduleData.coWorkersRequired !== undefined &&
          props.reScheduleData.coWorkersRequired !== ""
          ? props.reScheduleData.coWorkersRequired
          : ""
      );
      SetAddressline1(
        props.reScheduleData.addressLine1 !== undefined &&
          props.reScheduleData.addressLine1 !== ""
          ? props.reScheduleData.addressLine1
          : ""
      );
      SetAddressline2(
        props.reScheduleData.addressLine2 !== undefined &&
          props.reScheduleData.addressLine2 !== ""
          ? props.reScheduleData.addressLine2
          : ""
      );
      SetZip(
        props.reScheduleData.zip !== undefined &&
          props.reScheduleData.zip !== ""
          ? props.reScheduleData.zip
          : ""
      );
      setExteriorNumber(props.reScheduleData.exteriorNumber !== undefined &&
          props.reScheduleData.exteriorNumber !== ""
          ? props.reScheduleData.exteriorNumber
          : "");
      setInteriorNumber(props.reScheduleData.interiorNumber !== undefined &&
          props.reScheduleData.interiorNumber !== ""
          ? props.reScheduleData.interiorNumber
          : "");
      SetCity(
        props.reScheduleData.city !== undefined &&
          props.reScheduleData.city !== ""
          ? props.reScheduleData.city
          : ""
      );
      SetState(
        props.reScheduleData.state != undefined &&
          props.reScheduleData.state != ""
          ? props.reScheduleData.state
          : ""
      );
      SetInstructions(
        props.reScheduleData.instructions !== undefined &&
          props.reScheduleData.instructions !== ""
          ? props.reScheduleData.instructions
          : ""
      );
      SetExcInstructions(
        props.reScheduleData.instructions !== undefined &&
          props.reScheduleData.instructions !== ""
          ? props.reScheduleData.instructions
          : ""
      );
      SetRescheduleEventId(
        props.reScheduleData.eventId !== undefined &&
          props.reScheduleData.eventId !== ""
          ? props.reScheduleData.eventId
          : ""
      );
      SetdeliveryStatus(
        props.reScheduleData.deliveryStatus !== undefined &&
          props.reScheduleData.deliveryStatus !== ""
          ? props.reScheduleData.deliveryStatus
          : ""
      );
      Settimeslotid(
        props.reScheduleData.timeSlotId != undefined &&
          props.reScheduleData.timeSlotId !== ""
          ? props.reScheduleData.timeSlotId
          : ""
      );
      SetExReturnTimeSlotId(
        props.reScheduleData.timeSlotId != undefined &&
          props.reScheduleData.timeSlotId !== ""
          ? props.reScheduleData.timeSlotId
          : ""
      );
      SetIdAddress(
        props.reScheduleData.addressId != undefined &&  
          props.reScheduleData.addressId !== ""
          ? props.reScheduleData.addressId
          : ""
      );
      console.log(props.reScheduleData.deliveryPersonId,"assignee value")
      if(props.reScheduleData.deliveryPersonId != undefined && props.reScheduleData.deliveryPersonId !== ""){
        setsalesPersonValue(props.reScheduleData.deliveryPersonId != undefined &&
          props.reScheduleData.deliveryPersonId !== ""
          ? props.reScheduleData.deliveryPersonId
          : "")

           setIsDisableSalesPerson(true)
          const assigneeDetails ={
            label :props.reScheduleData.deliveryPersonName,
            value :props.reScheduleData.deliveryPersonId
          }

          setsalesPersonOptions([assigneeDetails]);
      }
     
      if (
        props.reScheduleData.deliveryType != undefined &&
        props.reScheduleData.deliveryType !== ""
      ) {
        if (
          props.reScheduleData.deliveryType == "Delivery" ||
          props.appiontmentType == "P"
        ) {
          SetcheckDeliverytype("DEL");
          SetDeliverytype("D");
        } else if (props.reScheduleData.deliveryType == "Pickup") {
          SetcheckDeliverytypeExc("DEL");
          SetDeliverytypeExc("P");
        } else if (props.reScheduleData.deliveryType == "Carry In") {
          SetcheckDeliverytypeExc("CAR");
          SetDeliverytypeExc("CI");
        } else {
          SetcheckDeliverytype("CAR");
          SetDeliverytype("CO");
        }
      }
    } else {
      console.log("BindtimeslotId", BindtimeslotId);
      console.log("BindtimeslotDate", BindtimeslotDate);
      // setBindtimeslotId('');
      // (BindtimeslotId = ''),
      // BindtimeslotDate = '';
      SetRescheduleProps("Schedule");
      getCoworkerRequiredData();
      getEnableFVS();
      getStatedata();
      GetTimeSlot(new Date());
      GetTimeSlotExc(new Date());
      GetAddressMethod();
      getInventoryId();
      setmasterLoader(false);
      // eslint-disable-next-line no-console
      console.log(coWorkerRequiredArray);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {    
  if (mxDeliveryKey && !props?.reScheduleData?.deliveryPersonId  && !salesPersonValue ) {
    console.log("inside the assigneeDropdown useeffect",salesPersonValue,props?.reScheduleData?.deliveryPersonId);
    assigneeDropDown();
  }
}, [mxDeliveryKey]);

  useEffect(() => {
    console.log(StatePopup,"statePopup");
    if (
      Line1Popup != "" &&
      CityPopup != "" &&
      ZipPopup != "" &&
      StatePopup !== "" &&
      StatePopup !== "0"
    ) {
      Setenableadd(false);
    } else {
      Setenableadd(true);
    }
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (
      ZipPopup !== undefined &&
      ZipPopup !== null &&
      ZipPopup != "" &&
      ZipPopup.length > 0
    ) {
      if (
        ZipPopup.length == 5 &&
        Line1Popup != "" &&
        CityPopup != "" &&
        StatePopup !== "" &&
        StatePopup !== "0"
      ) {
        Setenableadd(false);
      } else if (
        Line1Popup != "" &&
        CityPopup != "" &&
        StatePopup !== "" &&
        StatePopup !== "0" &&
        ZipPopup.length == 10
      ) {
        Setenableadd(false);
      } else {
        Setenableadd(true);
      }
    } else {
      Setenableadd(true);
    }
    console.log("eddfe4555", timeslotid);

    const hasDeliveryType = Deliverytype !== "";
    const hasTimeslot = timeslotid !== "";
    const hasSalesPerson = salesPersonValue !== "";
  
    if (mxDeliveryKey === true) {
      if (hasDeliveryType && hasTimeslot && hasSalesPerson) {
        console.log(" Finish button status: Enabled (Mexico store)");
        SetenableFinish(false);
      } else {
        console.log(" Finish button status: Disabled (Mexico store)");
        SetenableFinish(true);
      }
    } else {
      if (hasDeliveryType && hasTimeslot) {
        console.log(" Finish button status: Enabled (US store)");
        SetenableFinish(false);
      } else {
        console.log(" Finish button status: Disabled (US store)");
        SetenableFinish(true);
      }
    }
  }, [Line1Popup, ZipPopup, CityPopup, timeslotid, StatePopup, Deliverytype,salesPersonValue]);

  useEffect(
    () => {
      if (
        props.setItemSearchCompleted &&
        props.setAgrDetailsCompleted &&
        props.setInitialPaymentCompleted
      ) {
        props.setItemSearchCompleted(true);
        props.setAgrDetailsCompleted(true);
        props.setInitialPaymentCompleted(true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  // debugger
  useEffect(() => {
    console.log("ReSchedule Check", SaveTrigger);
    console.log("ReSchedule Called", props.isDeliveryReschedule);
    if (
      props !== undefined &&
      props.isDeliveryReschedule !== undefined &&
      props.isDeliveryReschedule.deliveryrescheduling != undefined &&
      props.isDeliveryReschedule.deliveryrescheduling === true &&
      SaveTrigger === false
    ) {
      console.log("ReSchedule Called", props.isDeliveryReschedule);
      Complete_delivery_status();
      // if(exchangeAgreementId || viewAgrData?.data?.agreementInformation?.isExchanged == 1 ){
      //   Complete_delivery_status_exchange();
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);
  useEffect(() => {
    console.log("ViewAgreementData", viewAgrData);
    // eslint-disable-next-line sonarjs/no-collapsible-if
    if (
      viewAgrData.data != undefined &&
      viewAgrData.data != null &&
      viewAgrData.data.agreementWorkflow.isSwitchoutEnabled != undefined &&
      viewAgrData.data.agreementWorkflow.isSwitchoutEnabled != null
    ) {
      if (viewAgrData.data.agreementWorkflow.isSwitchoutEnabled == "1") {
        console.log(
          "isswitchoutenabled in delievry method",
          viewAgrData.data.agreementWorkflow.isSwitchoutEnabled
        );
        console.log("select other address", hideswitchoutbutton);
        sethideswitchoutbutton(false);
      }
    }
    if (viewAgrData?.data?.agreementCustomer) {
      const customerInfodata = viewAgrData.data?.agreementCustomer.filter(
        (el) => el.priority == "1"
      );
      if (customerInfodata.length > 0) {
        customerInfodata.map((value: any) => {
          setemailText(value.emailId);
          setphoneNo(value.phoneNumber);
          const customerName = value.firstName + " " + value.lastName;
          setCustomerName(customerName);
          setCustomer({
            firstName: value.firstName,
            lastName: value.lastName
        });
        });
      }
    }
    if (viewAgrData?.data?.agreementInformation) {
      setappointmentId(viewAgrData?.data?.agreementInformation?.appointmentId);
      const rmsInvInformation = viewAgrData?.data?.agreementInventories
        ?.map((el: any) => {
          if (el.inventoryStatusRefcode != "PSO") {
            return { inventoryNumber: el.inventoryNumber };
          }
        })
        .filter((el) => el);
      setInventoryNumber(rmsInvInformation);
      setAgrNumber(viewAgrData?.data?.agreementInformation?.agreementNumber);

      const invInfo = viewAgrData?.data?.agreementInventories?.map(
        (el: any) => {
          return {
            inventoryNumber: el.inventoryNumber,
            inventoryId: el.inventoryId,
            description: el.description,
            store: "Select",
          };
        }
      );
      setInventoryInfo(invInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewAgrData]);

  useEffect(() => {
    if (exchangeAgreementId) {
      getAgreementInfoFn();
    }
  }, []);

  const getAgreementInfoFn = async () => {
    const getAgreementInfoFnRes = await getAgreementInfo(exchangeAgreementId);
    if (getAgreementInfoFnRes.status == 200) {
      setagrInfoResp(getAgreementInfoFnRes?.data);
    }
  };

  console.log("entersdfghj", agrInfoResp);

  const getStatedata = async () => {
    // PropsDetails();
    const stateDropdown = await GetstateDropdown(featureFlagDetails.MXAddressValidation == 1 ? 'MX' : '');
    if (stateDropdown.status === 200) {
      // eslint-disable-next-line no-console
      const buildConditionOption = stateDropdown.data;

      const setterCondition = [
        { stateAbbreviation: "Select" },

        ...buildConditionOption,
      ];
      console.log("STATESSSSS", setterCondition);
      SetStatedrop(setterCondition);
      SetStateconditionLoader(false);
    } else {
      const setterCondition = [{ stateAbbreviation: "Select" }];
      SetStatedrop(setterCondition);
      SetStateconditionLoader(false);
    }
  };
  const getCoworkerRequiredData = async () => {
    const bodyobject = {
      storeNumbers: [storeNumber],

      paramKeyNames: [
        "CoworkerRequired",
        "EnableGoogleAddressValidation",
        "MXStoreIdentifier",
        'CustomerAddressValidator',
        'AddressDoctorEnabled'
      ],
    };
    let CoworkerNum;
    if (
      storeNumber &&
      storeNumber != null &&
      storeNumber != undefined &&
      storeNumber != "" &&
      storeNumber != "null" &&
      storeNumber != "undefined"
    ) {
      CoworkerNum = await CoworkerRequired(bodyobject);
    }
    if (CoworkerNum.status === 200) {
      console.log(CoworkerNum.data, " CoworkerNum.data");
    
      const configList =
        CoworkerNum?.data?.storeProfileResponse?.configDetails?.[0]?.configDetails || [];
    
      // CoworkerRequired logic
      const coworkerConfig = configList.find(
        (config) => config.paramKeyName === "CoworkerRequired"
      );
      const value = coworkerConfig?.paramValue || "0";
    
      // EnableGoogleAddressValidation
      const exchangeResponse = configList.find(
        (config) => config.paramKeyName === "EnableGoogleAddressValidation"
      );
      if (exchangeResponse?.paramValue === "1") {
        setCanEnableGoogleValdation(true);
      }
    
      // MXStoreIdentifier
      const mxDeliveryProcess = configList.find(
        (config) => config.paramKeyName === "MXStoreIdentifier"
      );
      if (mxDeliveryProcess?.paramValue === "1") {
        setmxDeliveryKey(true);
      }
    
      // Coworker array generation
      console.log(value, "value in worker");
      const integervalue = parseInt(value);
      const arrayNumber : any= [];
      for (let i: any = 1; i <= integervalue; i++) {
        arrayNumber.push(i);
      }
    
      console.log("ArrayNumber", arrayNumber);
      setcoWorkerRequiredArray(arrayNumber);
      SetconditionLoader(false);
    }
    else {
      console.log("enterswertyu");
      const setterCondition = ["Select"];
      setcoWorkerRequiredArray(setterCondition);
      SetconditionLoader(false);
    }
  };

  const renderKey = (storeListArray.length > 0 && mxDeliveryKey) ;

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const GetAddressMethod = async () => {
    const getdeliveryaddress = await GetDeliveryAddress(customerId);

    // eslint-disable-next-line no-console
    console.log(getdeliveryaddress.data, "address value");

    if (
      getdeliveryaddress.data !== undefined &&
      getdeliveryaddress.data.getAdd !== undefined &&
      getdeliveryaddress.data.getAdd !== null &&
      getdeliveryaddress.data.getAdd.length > 0
    ) {
      // eslint-disable-next-line no-console
      console.log(getdeliveryaddress.data, "Inside Log");
      SetGetAddress(getdeliveryaddress.data.getAdd);
      SetaddressId(getdeliveryaddress.data.getAdd[0].addressId);
      addRowArray = getdeliveryaddress.data.getAdd;
    }
    // eslint-disable-next-line no-console
    console.log(getdeliveryaddress.data, "testingresponsetimeslot");

    if (
      props == undefined ||
      props == null ||
      props == "" ||
      props.reScheduleData == undefined ||
      props.reScheduleData == null ||
      props.reScheduleData == ""
    ) {
      SetAddressline1(
        getdeliveryaddress.data !== undefined &&
          getdeliveryaddress.data.getAdd !== undefined &&
          getdeliveryaddress.data.getAdd.length > 0
          ? getdeliveryaddress.data.getAdd[0].addressLine1
          : "-"
      );
      SetAddressline2(
        getdeliveryaddress.data !== undefined &&
          getdeliveryaddress.data.getAdd !== undefined &&
          getdeliveryaddress.data.getAdd.length > 0
          ? getdeliveryaddress.data.getAdd[0].addressLine2
          : "-"
      );

      if (getdeliveryaddress.data !== undefined &&
        getdeliveryaddress.data.getAdd !== undefined &&
        getdeliveryaddress.data.getAdd.length > 0) {
        setExteriorNumber(getdeliveryaddress.data.getAdd[0].exteriorNumber ?? "-");
        setInteriorNumber(getdeliveryaddress.data.getAdd[0].interiorNumer ?? "-");
      }

      const Zipcode =
        getdeliveryaddress.data !== undefined &&
        getdeliveryaddress.data.getAdd !== undefined &&
        getdeliveryaddress.data.getAdd.length > 0
          ? getdeliveryaddress.data.getAdd[0].zip
          : "";

      let plus4Code = "";

      if (getdeliveryaddress.data.getAdd[0].plus4 != null) {
        plus4Code =
          getdeliveryaddress.data !== undefined &&
          getdeliveryaddress.data.getAdd !== undefined &&
          getdeliveryaddress.data.getAdd.length > 0
            ? getdeliveryaddress.data.getAdd[0].plus4
            : "";

        // const tempik = temps '-'

        SetZip(Zipcode + "-" + plus4Code);
      } else {
        SetZip(Zipcode);
      }

      SetCity(
        getdeliveryaddress.data !== undefined &&
          getdeliveryaddress.data.getAdd !== undefined &&
          getdeliveryaddress.data.getAdd.length > 0
          ? getdeliveryaddress.data.getAdd[0].city
          : ""
      );
      SetState(
        getdeliveryaddress.data !== undefined &&
          getdeliveryaddress.data.getAdd !== undefined &&
          getdeliveryaddress.data.getAdd.length > 0
          ? getdeliveryaddress.data.getAdd[0].stateProvinceName
          : ""
      );
      SetStatePopupId(
        getdeliveryaddress.data !== undefined &&
          getdeliveryaddress.data.getAdd !== undefined &&
          getdeliveryaddress.data.getAdd.length > 0
          ? getdeliveryaddress.data.getAdd[0].stateProvinceId
          : ""
      );
      SetIdAddress(
        getdeliveryaddress.data !== undefined &&
          getdeliveryaddress.data.getAdd !== undefined &&
          getdeliveryaddress.data.getAdd.length > 0
          ? getdeliveryaddress.data.getAdd[0].addressId
          : ""
      );
    }
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const GetTimeSlot = async (StartingDate: any, ReSchdeuleSource?: any) => {
    //const startingdate = new Date(StartingDate);
    const startingdate = StartingDate;
    const maximumdate = moment(StartingDate)
      .add(3, "months")
      .format("YYYY-MM-DD");
    setMaxDate(maximumdate);
    const endingdate = moment(StartingDate).add(9, "days").format("YYYY-MM-DD");
    //const endingdate = addDays(startingdate, 9);
    console.log(endingdate);
    console.log("startingdateuh", startingdate);
    console.log("changeDateFormatok", changeDateFormat(startingdate));
    const formattedstartingdate = moment(startingdate).format("YYYY-MM-DD");
    const formattedenddate = moment(endingdate).format("YYYY-MM-DD");
    // const formattedstartingdate = changeDateFormat(startingdate);
    // const formattedenddate = changeDateFormat(endingdate);
    console.log("DAtsssssssrefd", formattedenddate);
    // const bodyobj = {
    //   customerId: customerId,
    //   startDate: formattedstartingdate,
    //   endDate: formattedenddate,
    //   storeId: StoreId,
    //   eventSource: 'Store',
    // };
    const payload = {
      isLoaner: "Y",
      customerId: String(customerId),
      endDate: formattedenddate,
      eventSource: ReSchdeuleSource !== undefined ? ReSchdeuleSource : "STO",
      startDate: formattedstartingdate,
      storeId: window.sessionStorage.getItem("storeNumber"),
    };

    const timeslotresponse = await GetTimeSlots(payload);
    setTimeSlotYes(true);
    if (timeslotresponse.data !== undefined) {
      setAppoinmentSource(timeslotresponse.data.appointmentSource);
      // SetTimeslotReason(timeslotresponse);
      const TimeSlotsDetailsArrayValue: any = [];
      interface TimeSlotDetails {
        timeSlot: string;
        startTime: string;
        endTime: string;
        status: string;
        total?: number;
        helpText?: string;
      }

      interface TimeSlotDetailsArray {
        Date: string;
        TimeSlots: TimeSlotDetails;
      }

      const TimeSlotVariable = timeslotresponse.data.timeSlots;
      const sorted: any = Object.keys(TimeSlotVariable)
        .sort(function (a: any, b: any) {
          const date1: any = new Date(a);
          const date2: any = new Date(b);
          return date1 - date2;
        })
        .reduce((accumulator, key) => {
          accumulator[key] = TimeSlotVariable[key];

          return accumulator;
        }, {});
      Object.keys(sorted).forEach(function (key) {
        const value = sorted[key];
        //  console.log(key + ':' + value);
        const Timeslots: any = [];

        value.map((value: any) => {
          const timeslot_object = {} as TimeSlotDetails | any;
          timeslot_object.timeSlot = value.timeSlot;
          timeslot_object.startTime = value.startTime;
          timeslot_object.endTime = value.endTime;
          timeslot_object.status = value.status;
          timeslot_object.id = irt?.next()?.value;
          const tot = isNaN(value.total) ? 0 : value.total;
          timeslot_object.total = Number.parseInt(timeslotresponse.data.maxNumberOfEvents) - tot;
          timeslot_object.id = irt?.next()?.value;
          timeslot_object.helpText = generateHelpText( value );
          //
          Timeslots.push(timeslot_object);
        });

        const TotalTimeSlots = {} as TimeSlotDetailsArray;
        TotalTimeSlots.Date = key;
        TotalTimeSlots.TimeSlots = Timeslots;
        TimeSlotsDetailsArrayValue.push(TotalTimeSlots);
      });
      SettimeSlotData(TimeSlotsDetailsArrayValue);

      // SetTime('');
      // console.log('beoefevcdvbh', BindtimeslotId);
      // setBindtimeslotId('');
      // eslint-disable-next-line no-console
      console.log(TimeSlotsDetailsArrayValue, "timeslot converted array");
    } else {
      const StartingTime =
        props.reScheduleData.appointmentStartTime !== undefined &&
        props.reScheduleData.appointmentStartTime !== ""
          ? props.reScheduleData.appointmentStartTime
          : "";
      const EndingTime =
        props.reScheduleData.appointmentEndTime !== undefined &&
        props.reScheduleData.appointmentEndTime !== ""
          ? props.reScheduleData.appointmentEndTime
          : "";
      const slicedStartdate =
        StartingTime.slice(0, 5) + StartingTime.slice(8, StartingTime.length);

      const Selectedslot = slicedStartdate + "-" + EndingTime;
      const slotDuration =
        moment(StartingTime, "HH:mm").format("hh:mm") +
        " - " +
        moment(EndingTime, "HH:mm").format("hh:mm A");
      SetTime(slotDuration);
      //Timebind(event);
    }
    // eslint-disable-next-line no-console
    console.log(timeslotresponse.data, "testingresponsetimeslot");
  };

  const GetTimeSlotExc = async (StartingDate: any, ReSchdeuleSource?: any) => {
    //const startingdate = new Date(StartingDate);
    const startingdate = StartingDate;
    const maximumdate = moment(StartingDate)
      .add(3, "months")
      .format("YYYY-MM-DD");
    setMaxDate(maximumdate);
    const endingdate = moment(StartingDate).add(9, "days").format("YYYY-MM-DD");
    //const endingdate = addDays(startingdate, 9);
    console.log(endingdate);
    console.log("startingdateuh", startingdate);
    console.log("changeDateFormatok", changeDateFormat(startingdate));
    const formattedstartingdate = moment(startingdate).format("YYYY-MM-DD");
    const formattedenddate = moment(endingdate).format("YYYY-MM-DD");
    // const formattedstartingdate = changeDateFormat(startingdate);
    // const formattedenddate = changeDateFormat(endingdate);
    console.log("DAtsssssssrefd", formattedenddate);
    // const bodyobj = {
    //   customerId: customerId,
    //   startDate: formattedstartingdate,
    //   endDate: formattedenddate,
    //   storeId: StoreId,
    //   eventSource: 'Store',
    // };
    const payload = {
      isLoaner: "Y",
      customerId: String(customerId),
      endDate: formattedenddate,
      eventSource: ReSchdeuleSource !== undefined ? ReSchdeuleSource : "STO",
      startDate: formattedstartingdate,
      storeId: window.sessionStorage.getItem("storeNumber"),
    };

    const timeslotresponse = await GetTimeSlots(payload);

    // const payload1 = {
    //   isLoaner: "Y",
    //   customerId: String(customerId),
    //   endDate: formattedenddate,
    //   eventSource: ReSchdeuleSource !== undefined ? ReSchdeuleSource : "STO",
    //   startDate: formattedstartingdate,
    //   storeId: "02202",
    // };
    // const timeslotresponse1 = await GetTimeSlots(payload1);

    // console.log(timeslotresponse1);

    setTimeSlotYes(true);
    if (timeslotresponse.data !== undefined) {
      setAppoinmentSource(timeslotresponse.data.appointmentSource);
      // SetTimeslotReason(timeslotresponse);
      const TimeSlotsDetailsArrayValue: any = [];
      interface TimeSlotDetails {
        timeSlot: string;
        startTime: string;
        endTime: string;
        status: string;
        total?: number;
        helpText?: string;
      }

      interface TimeSlotDetailsArray {
        Date: string;
        TimeSlots: TimeSlotDetails;
      }

      const TimeSlotVariable = timeslotresponse.data.timeSlots;
      const sorted: any = Object.keys(TimeSlotVariable)
        .sort(function (a: any, b: any) {
          const date1: any = new Date(a);
          const date2: any = new Date(b);
          return date1 - date2;
        })
        .reduce((accumulator, key) => {
          accumulator[key] = TimeSlotVariable[key];

          return accumulator;
        }, {});
      Object.keys(sorted).forEach(function (key) {
        const value = sorted[key];
        //  console.log(key + ':' + value);
        const Timeslots: any = [];

        value.map((value: any) => {
          const timeslot_object = {} as TimeSlotDetails | any;
          timeslot_object.timeSlot = value.timeSlot;
          timeslot_object.startTime = value.startTime;
          timeslot_object.endTime = value.endTime;
          timeslot_object.status = value.status;
          timeslot_object.id = irt?.next()?.value;
          const tot = isNaN(value.total) ? 0 : value.total;
          timeslot_object.id = irt?.next()?.value;
          timeslot_object.helpText = generateHelpText( value );
          //
          Timeslots.push(timeslot_object);
        });

        const TotalTimeSlots = {} as TimeSlotDetailsArray;
        TotalTimeSlots.Date = key;
        TotalTimeSlots.TimeSlots = Timeslots;
        TimeSlotsDetailsArrayValue.push(TotalTimeSlots);
      });
      SettimeSlotDataExc(TimeSlotsDetailsArrayValue);

      // SetTime('');
      // console.log('beoefevcdvbh', BindtimeslotId);
      // setBindtimeslotId('');
      // eslint-disable-next-line no-console
      console.log(TimeSlotsDetailsArrayValue, "timeslot converted array");
    } else {
      const StartingTime =
        props.reScheduleData.appointmentStartTime !== undefined &&
        props.reScheduleData.appointmentStartTime !== ""
          ? props.reScheduleData.appointmentStartTime
          : "";
      const EndingTime =
        props.reScheduleData.appointmentEndTime !== undefined &&
        props.reScheduleData.appointmentEndTime !== ""
          ? props.reScheduleData.appointmentEndTime
          : "";
      const slicedStartdate =
        StartingTime.slice(0, 5) + StartingTime.slice(8, StartingTime.length);

      const Selectedslot = slicedStartdate + "-" + EndingTime;
      const slotDuration =
        moment(StartingTime, "HH:mm").format("hh:mm") +
        " - " +
        moment(EndingTime, "HH:mm").format("hh:mm A");
      SetTime(slotDuration);
      //Timebind(event);
    }
    // eslint-disable-next-line no-console
    console.log(timeslotresponse.data, "testingresponsetimeslot");
  };

  let itemInventorySTORE;
  const getInventoryId = async () => {
    //const agreementInfoResult = await getAgreementInfo(agreementId);
    itemInventorySTORE =
      viewAgrData?.data.agreementInventories[0].inventoryStoreNumber;
    if (
      viewAgrData != undefined &&
      viewAgrData != null &&
      viewAgrData.data != undefined &&
      viewAgrData.data != null &&
      viewAgrData.data.agreementInventories[0] != undefined &&
      viewAgrData.data.agreementInventories[0] != null &&
      viewAgrData.data.agreementInventories[0].inventoryId != undefined &&
      viewAgrData.data.agreementInventories[0].inventoryId != null &&
      viewAgrData.data.agreementWorkflow != undefined &&
      viewAgrData.data.agreementWorkflow != null &&
      viewAgrData.data.agreementWorkflow.agreementNumber != undefined &&
      viewAgrData.data.agreementWorkflow.agreementNumber != null &&
      viewAgrData.data.agreementCustomer[0] != undefined &&
      viewAgrData.data.agreementCustomer[0] != null &&
      viewAgrData.data.agreementCustomer[0].globalCustomerId != undefined &&
      viewAgrData.data.agreementCustomer[0].globalCustomerId != null
    ) {
      const InventoryArray = viewAgrData.data.agreementInventories.map(
        (Obj: any) => {
          return Obj.inventoryId;
        }
      );
      console.log("InventoryArray", InventoryArray);
      Setinventoryid(InventoryArray);
      SetagreementNumber(viewAgrData.data.agreementWorkflow.agreementNumber);
      SetEpoProps({
        agreementNumber: viewAgrData.data.agreementWorkflow.agreementNumber,
      });
      SetGCID(viewAgrData.data.agreementCustomer[0].globalCustomerId);
      console.log(
        "GCID",
        viewAgrData.data.agreementCustomer[0].globalCustomerId
      );
    }
  };

  function GetDeliveryInformationMapper(
    agreementInformation: any,
    eventInformation: any
  ): any {
    if (agreementInformation != undefined && eventInformation != undefined) {
      const getDeliveryInformation: any = {};
      getDeliveryInformation.agreementId =
        agreementInformation.agreementInformation.agreementId;
      getDeliveryInformation.deliveryMethodStatus = deliveryMethodStatusDefine(
        eventInformation.appointmentInfo.appointmentType,
        eventInformation.appointmentInfo.appointmentStatusDesc,
        agreementInformation.agreementWorkflow.isSwitchoutEnabled,
        agreementInformation.agreementInformation.agreementStatusGroupCode,
        agreementInformation.agreementWorkflow.isDeliveryCompleted
      );
      getDeliveryInformation.deliveryInformation = {
        eventId: agreementInformation.agreementInformation.appointmentId,
        deliveryType: deliveryTypeDefine(
          eventInformation.appointmentInfo.appointmentType,
          eventInformation.appointmentInfo.appointmentTypeDesc,
          eventInformation.appointmentInfo.appointmentStatusDesc,
          agreementInformation.agreementWorkflow.isSwitchoutEnabled
        ),
        deliveryStatus: eventInformation.appointmentInfo.appointmentStatusDesc,
        addressId: eventInformation.customerInfo.address?.addressId,
        addressLine1: eventInformation.customerInfo.address?.addressLine1,
        addressLine2: eventInformation.customerInfo.address?.addressLine2,
        zip: eventInformation.customerInfo.address?.postalCode,
        zipPlus4: eventInformation.customerInfo.address?.postalCode,
        city: eventInformation.customerInfo.address?.city,
        state: eventInformation.customerInfo.address?.state,
        timeSlotId: eventInformation.timeSlotInfo.timeSlot,
        appointmentDate: eventInformation.appointmentInfo.appointmentDate,
        appointmentStartTime: eventInformation.timeSlotInfo.startTime,
        appointmentEndTime: eventInformation.timeSlotInfo.endTime,
        coWorkersRequired: eventInformation.appointmentInfo.requiredCoworkers,
        instructions: eventInformation.appointmentInfo.instructions,
      };
      return getDeliveryInformation;
    }
    return undefined;
  }

  function deliveryTypeDefine(
    appointmentType: string,
    appointmentTypeDesc: string,
    appointmentStatusDesc: string,
    switchout: string
  ): string {
    let appointmentTypeDescription: any = appointmentTypeDesc;
    if (["P", "CI"].includes(appointmentType)) {
      appointmentTypeDescription = "Return";
    }
    return appointmentTypeDescription;
  }

  function deliveryMethodStatusDefine(
    appointmentType: string,
    appointmentStatusDesc: string,
    switchout: string,
    agreementStatusGroup: string,
    isDeliveryCompleted: string
  ): string {
    //View Delivery Method
    let deliveryMethodStatus = "0";
    console.log(
      appointmentType,
      appointmentStatusDesc,
      switchout,
      agreementStatusGroup,
      isDeliveryCompleted
    );
    if (
      appointmentStatusDesc === "Completed" ||
      (["D", "CO"].includes(appointmentType) &&
        ["Completed"].includes(appointmentStatusDesc) &&
        isDeliveryCompleted === "1") ||
      (agreementStatusGroup == "CLOSED" &&
        appointmentStatusDesc == "Cancelled") ||
      ["SCI", "SCO", "SD", "S", "SP"].includes(appointmentType) ||
      (["P", "CI", "D", "CO"].includes(appointmentType) &&
        ["Completed", "Cancelled"].includes(appointmentStatusDesc) &&
        isDeliveryCompleted === "1")
    ) {
      deliveryMethodStatus = "1";
    }
    //View Delivery Method with No Appointment Records
    else if (["VOID", "CLOSED"].includes(agreementStatusGroup)) {
      deliveryMethodStatus = "2";
    }
    return deliveryMethodStatus;
  }

  // Disabling the delivery address Pop up, by clicking on Select Delivery Address.

  const disPopup = async () => {
    SetPopup(true);
    SetAddRow(getaddress);
    // SetenableRdo(true);
  };

  const hideDeliveryaddress = (event: any, isExchange?: any) => {
    // eslint-disable-next-line sonarjs/no-all-duplicated-branches
    if (isExchange) {
      console.log("enetrs the 1st");
      if (
        event?.target.value == "CarryinRdoExc" ||
        document.getElementById("carryout")
      ) {
        SetDeliverytypeExc("CI");
        if (props?.triggerdeliveryChanged) {
          props?.triggerdeliveryChanged();
        }
      } else {
        SetDeliverytypeExc("P");
        if (props?.triggerdeliveryChanged) {
          props?.triggerdeliveryChanged();
        }
      }
      SetcheckDeliverytypeExc("CAR");
      SetSaveTrigger(false);
    } else {
      console.log("enetrs the 2st");
      if (
        event?.target.value == "CarryoutRdo" ||
        document.getElementById("carryout")
      ) {
        SetDeliverytype("CO");
        if (props?.triggerdeliveryChanged) {
          props?.triggerdeliveryChanged();
        }
      } else {
        SetDeliverytype("D");
        if (props?.triggerdeliveryChanged) {
          props?.triggerdeliveryChanged();
        }
      }
      SetcheckDeliverytype("CAR");
      SetSaveTrigger(false);
    }
  };

  // Function for showing Delivery Address when Delivery is clicked again in Delivery Type heading

  const showDeliveryaddress = (event: any, isExchange?: any) => {
    // eslint-disable-next-line sonarjs/no-all-duplicated-branches
    if (isExchange) {
      console.log("enetrs the 1st showdelivery");
      if (
        event?.target.value == "DeliveryRdoExc" ||
        document.getElementById("delivery")
      ) {
        SetDeliverytypeExc("P");
        if (props?.triggerdeliveryChanged) {
          props?.triggerdeliveryChanged();
        }
      } else {
        SetDeliverytypeExc("CI");
        if (props?.triggerdeliveryChanged) {
          props?.triggerdeliveryChanged();
        }
      }
      SetcheckDeliverytypeExc("DEL");
      SetSaveTrigger(false);
    } else {
      console.log("enetrs the 2st showdelivery");
      if (
        event?.target.value == "DeliveryRdo" ||
        document.getElementById("delivery")
      ) {
        SetDeliverytype("D");
        if (props?.triggerdeliveryChanged) {
          props?.triggerdeliveryChanged();
        }
      } else {
        SetDeliverytype("CO");
        if (props?.triggerdeliveryChanged) {
          props?.triggerdeliveryChanged();
        }
      }
      SetcheckDeliverytype("DEL");
      SetSaveTrigger(false);
    }
  };
  // console.log(Deliverytype);
  // Function for Cancel button and close image in Delivery Address Pop-Up

  const cancelbtn = () => {
    setmasterLoader(false);
    SetPopup(false);
    setSuggestAddress(false);

  };

  const changeDateFormat = (date: Date) => {
    // eslint-disable-next-line prefer-const
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      // eslint-disable-next-line prefer-const
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [year, month, day].join("-");
  };

  // Function for displaying selected and next five days
  const dates = async (selectedFormatdate: any, isExchange?: any) => {

    const validateYear = moment(selectedFormatdate)
      .add(12, "months")
      .format("YYYY-MM-DD");
    const selectFormatdate = moment(selectedFormatdate).format("YYYY-MM-DD");
    if (isExchange) {
      if (
        selectFormatdate >= moment(new Date()).format("YYYY-MM-DD") &&
        selectFormatdate < validateYear
      ) {
        setdateError("");
        SettimeSlotDataExc([]);
        setStartDateExc(moment(selectedFormatdate).format("YYYY-MM-DD"));

        const startDateExc = selectedFormatdate;
        if (props.triggerdateChaged) {
          props.triggerdateChaged();
        }
        GetTimeSlotExc(startDateExc);
        setExReturnTime("");
        SetExReturnTimeSlotId("");
        console.log("beoefevcdvbh", BindtimeslotId);
        // setBindtimeslotId('');
        SetExReturnBindtimeslotId("");
      } else {
        setStartDateExc(moment(new Date()).format("YYYY-MM-DD"));
        setdateError("Date must not be in the past");
      }
    } else {
      if (
        selectFormatdate >= moment(new Date()).format("YYYY-MM-DD") &&
        selectFormatdate < validateYear
      ) {
        setdateError("");
        SettimeSlotData([]);
        setStartDate(moment(selectedFormatdate).format("YYYY-MM-DD"));
        // if (openReturnContent == false){
        //   console.log("openReturnContentsdfgh",openReturnContent)
        //   console.log("xcvbnm",selectedFormatdate)
        //   setStartDateExc(moment(selectedFormatdate).format('YYYY-MM-DD'));
        // }

        const startDate = selectedFormatdate;
        if (props.triggerdateChaged) {
          props.triggerdateChaged();
        }
        GetTimeSlot(startDate);
        SetTime("");
        Settimeslotid("");
        console.log("beoefevcdvbh", BindtimeslotId);
        setBindtimeslotId("");
        // SetExReturnBindtimeslotId('')
      } else {
        setStartDate(moment(new Date()).format("YYYY-MM-DD"));
        setdateError("Date must not be in the past");
      }
    }
  };

  const getslotdetails = (
    avail: any,
    modifiedStarttime: any,
    modifiedEndtime: any,
    isExchangeReturnFlow?: any,
    uniqueItem?: any
  ) => {
    if (props.triggertimeChanged !== undefined) {
      props.triggertimeChanged();
    }
    console.log("ContextStart", modifiedStarttime);
    console.log("ContextEnd", modifiedEndtime);
    SetContextStartDate(modifiedStarttime);
    SetContextEndDate(modifiedEndtime);
    if (isExchangeReturnFlow) {
      console.log("in the if isexchange");
      setExReturnTime(avail.target.value);
      SetExReturnBindtimeslotId(avail.target.id);
      SetExReturnTimeSlotId(avail.target.id);
      ExBindtimeslotDate = avail.target.name;
      setStartDateExc(moment(ExBindtimeslotDate).format("YYYY-MM-DD"));

      console.log("exReturnTimedfghj", exReturnTime);
    } else {
      console.log("in the else cond", avail.target.value);
      SetTime(avail.target.value);
      Settimeslotid(avail.target.id);
      setBindtimeslotId(avail.target.id);
      setCurrentBtnClass(uniqueItem);
      BindtimeslotDate = avail.target.name;
      setStartDate(moment(BindtimeslotDate).format("YYYY-MM-DD"));
      console.log(
        {
          openReturnContent,
          exReturnBindtimeslotId,
          exReturnTime,
          exReturnTimeSlotId,
          startDate,
        },
        "sdfghjkvbn"
      );
      // if (openReturnContent == false) {
      //   setExReturnTime(avail.target.value);
      //   SetExReturnBindtimeslotId(avail.target.id);
      //   SetExReturnTimeSlotId(avail.target.id);
      //   ExBindtimeslotDate = avail.target.name;
      //   BindtimeslotDate = avail.target.name
      //   setStartDateExc(moment(ExBindtimeslotDate).format("YYYY-MM-DD"));
      // }
      console.log("sdfghjcvbnm", BindtimeslotDate, Time, timeslotid);
      console.log("sdfghjkvvvddwtttyybnm", ExBindtimeslotDate);
    }
    // Settimeslotid(avail.target.id);
    // setBindtimeslotId(avail.target.id);
    // BindtimeslotId = avail.target.id;
    buildTimeSlot();
    SetSaveTrigger(false);
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const bindGrid = () => {
    if (addRow != undefined && addRow != null && addRow.length > 0) {
      // eslint-disable-next-line no-console
      console.log("addRow", addRow);
      // SetEnableLoaderButton(false);
      return addRow.map((val: any, index: any) => {
        const shtAddr1 =
          val.addressLine1 != null && val.addressLine1 != undefined
            ? val.addressLine1.length > 15
              ? val.addressLine1.substring(0, 25) + "..."
              : val.addressLine1
            : "";
        const shtAddr2 =
          val.addressLine2 != null && val.addressLine2 != undefined
            ? val.addressLine2.length > 15
              ? val.addressLine2.substring(0, 25) + "..."
              : val.addressLine2
            : "";

        let Zipandand4plus = "";
        // eslint-disable-next-line no-console
        console.log(val.zip);
        // eslint-disable-next-line no-console
        console.log(val.plus4);
        if (val.zip != undefined && val.zip != null) {
          if (val.plus4 != null && val.plus4 != undefined) {
            Zipandand4plus = val.zip + "-" + val.plus4;
          } else {
            Zipandand4plus = val.zip;
          }
        }

        const shtZip = Zipandand4plus;

        const shtCity =
          val.city != null && val.city != undefined
            ? val.city.length > 15
              ? val.city.substring(0, 25) + "..."
              : val.city
            : "";
        const shtState =
          val.stateProvinceName != null && val.city != undefined
            ? val.stateProvinceName.length > 15
              ? val.stateProvinceName.substring(0, 25) + "..."
              : val.stateProvinceName
            : "";

        console.log("addressId", val.addressId);

        return (
          // eslint-disable-next-line react/jsx-key
          <RACTableRow>
            <RACTableCell>
              <RACRadio
                value={val.addressId}
                id={index}
                name="flexRadioDefault"
                onClick={Selectaddress.bind(event)}
                checked={TEMP == index ? true : false}
                size={"small"}
              />
              <label
                title={val.addressLine1}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.addressLine1}
                id={"addLin1Lab" + index}
              >
                {shtAddr1}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.addressLine2}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.addressLine2}
                id={"addLin2Lab" + index}
              >
                {shtAddr2}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.zip_plus4}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.zip_plus4}
                id={"addZipLab" + index}
              >
                {shtZip}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.city}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.city}
                id={"addCityLab" + index}
              >
                {shtCity}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.stateProvinceName}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.stateProvinceName}
                id={"addStateLab" + index}
              >
                {shtState}
              </label>
            </RACTableCell>
          </RACTableRow>
        );
      });
    } else {
      return (
        <div className={classes.Norecords}>
          <CircularProgress />
        </div>
      );
    }
  };
  const bindMXGrid = () => {
    if (addRow != undefined && addRow != null && addRow.length > 0) {

      return addRow.map((val: any, index: any) => {
        const shtAddr1 =
          val.addressLine1 != null && val.addressLine1 != undefined
            ? val.addressLine1.length > 25
              ? val.addressLine1.substring(0, 25) + "..."
              : val.addressLine1
            : "-";
        const shtAddr2 =
          val.addressLine2 != null && val.addressLine2 != undefined
            ? val.addressLine2.length > 25
              ? val.addressLine2.substring(0, 25) + "..."
              : val.addressLine2
            : "-";
        const exteriorNo =
          val.exteriorNumber != null && val.exteriorNumber != undefined
            ? val.exteriorNumber.length > 25
              ? val.exteriorNumber.substring(0, 25) + "..."
              : val.exteriorNumber
            : "-";
        const interiorNo =
          val.interiorNumer != null && val.interiorNumer != undefined
            ? val.interiorNumer.length > 25
              ? val.interiorNumer.substring(0, 25) + "..."
              : val.interiorNumer
            : "-";


        let Zipandand4plus = "-";
        // eslint-disable-next-line no-console
        console.log(val.zip);
        // eslint-disable-next-line no-console
        console.log(val.plus4);
        if (val.zip != undefined && val.zip != null) {
          if (val.plus4 != null && val.plus4 != undefined) {
            Zipandand4plus = val.zip + "-" + val.plus4;
          } else {
            Zipandand4plus = val.zip;
          }
        }

        const shtZip = Zipandand4plus;

        const shtCity =
          val.city != null && val.city != undefined
            ? val.city.length > 15
              ? val.city.substring(0, 25) + "..."
              : val.city
            : "";
        const shtState =
          val.stateProvinceName != null && val.city != undefined
            ? val.stateProvinceName.length > 15
              ? val.stateProvinceName.substring(0, 25) + "..."
              : val.stateProvinceName
            : "";

        console.log("addressId", val.addressId);

        return (
          // eslint-disable-next-line react/jsx-key
          <RACTableRow>
            <RACTableCell>
              <RACRadio
                value={val.addressId}
                id={index}
                name="flexRadioDefault"
                onClick={Selectaddress.bind(event)}
                checked={TEMP == index ? true : false}
                size={"small"}
              />
              <label
                title={val.addressLine1}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.addressLine1}
                id={"addLin1Lab" + index}
              >
                {shtAddr1}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.exteriorNumber}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.exteriorNumber}
                id={"exteriorNumber" + index}
              >
                {exteriorNo}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.interiorNumber}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.interiorNumber}
                id={"interiorNumber" + index}
              >
                {interiorNo}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.addressLine2}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.addressLine2}
                id={"addressLine2" + index}
              >
                {shtAddr2}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.zip_plus4}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.zip_plus4}
                id={"addZipLab" + index}
              >
                {shtZip}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.city}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.city}
                id={"addCityLab" + index}
              >
                {shtCity}
              </label>
            </RACTableCell>
            <RACTableCell>
              <label
                title={val.stateProvinceName}
                data-toggle="tooltip"
                data-placement="top"
                data-original-title={val.stateProvinceName}
                id={"addStateLab" + index}
              >
                {shtState}
              </label>
            </RACTableCell>
          </RACTableRow>
        );
      });
    } else {
      return (
        <div className={classes.Norecords}>
          <CircularProgress />
        </div>
      );
    }
  };
  const updateMXAddress = async () => {
    const postaddress = {
      customerId: customerId,
      addresses: [
        {
          addressType: "DELIV",
          active: "Y",
          addressLine1: address.street,
          addressLine2: address.suburb || null,
          city: address.city,
          state: address.state,
          postalCode: address.zipcode,
          exteriorNumber: address.exteriorNum || null,
          interiorNumber: address.interiorNum || null,

          agreementIds: [agreementId],
        },
      ],
    };
    setSuggestAddress(false);
    setmasterLoader(true);
    setSuggestAddress(false);
    newDeliveryAddress = postaddress;
    setNewDeliverAddress(newDeliveryAddress);
    await addadress(postaddress)
    setAddress({
      street: '',
      interiorNum: '',
      exteriorNum: '',
      suburb: '',
      zipcode: '',
      city: '',
      state: ''
    })
  }
  const addadress = async (postaddress: any) => {
    const updatecustomerresponse = await UpdateAddressInfo(postaddress);
    // const updatecustomerresponse = await updatecustomer(postaddress);
    if (updatecustomerresponse.status === 400) {
      SetDisplayErrorMessage("No Records Found");
      setmasterLoader(false);
      SetErrorpopup(true);
    } else if (updatecustomerresponse.status === 500) {
      // eslint-disable-next-line sonarjs/no-duplicate-string
      SetDisplayErrorMessage("Something Went Wrong");
      setmasterLoader(false);
      setValidateIsOpen(false);
      SetErrorpopup(true);
    }
    if (
      updatecustomerresponse !== undefined &&
      updatecustomerresponse.data !== undefined &&
      updatecustomerresponse.data.updateAddress != undefined &&
      updatecustomerresponse.data.updateAddress.value != undefined &&
      updatecustomerresponse.data.updateAddress.value.customerId != undefined &&
      updatecustomerresponse !== null
    ) {
      SetLine1Popup("");
      SetLine2Popup("");
      SetZipPopup("");
      SetCityPopup("");
      SetStatePopup("");

      const getdeliveryaddress = await GetDeliveryAddress(customerId);

      // eslint-disable-next-line no-console
      console.log(getdeliveryaddress.data, "address value");
      setmasterLoader(false);

      if (
        getdeliveryaddress.data !== undefined &&
        getdeliveryaddress.data.getAdd !== undefined &&
        getdeliveryaddress.data.getAdd !== null &&
        getdeliveryaddress.data.getAdd.length > 0
      ) {
        // eslint-disable-next-line no-console
        console.log(getdeliveryaddress.data, "Inside Log");
        if (featureFlagDetails.MXAddressValidation == 1) {
          const index: any = getdeliveryaddress.data.getAdd.findIndex(
            (x) =>
              x.addressLine1 == newDeliveryAddress.addresses[0].addressLine1 &&
              x.city == newDeliveryAddress.addresses[0].city &&
              x.stateProvinceName == newDeliveryAddress.addresses[0].state
          );
          SetTEMP(String(index));
        }
        else {
          const index: any = getdeliveryaddress.data.getAdd.findIndex(
            (x) =>
              x.addressLine1 == newDeliveryAddress.addresses[0].addressLine1 &&
              x.city == newDeliveryAddress.addresses[0].city &&
              x.stateProvinceName == newDeliveryAddress.addresses[0].state
          );
          SetTEMP(String(index));

          if (index >= 0) {
            const newAddressId = getdeliveryaddress.data.getAdd[index].addressId;
            SetIdAddress(newAddressId);
          }
        }

        SetGetAddress(getdeliveryaddress.data.getAdd);
        addRowArray = getdeliveryaddress.data.getAdd;
        SetAddRow(addRowArray);
      }
    }
  };
  const createValPayload = (payload: any, position: number = 0) => {
    const valPayload = JSON.parse(JSON.stringify(payload));
    valPayload.enableGoogleAddressValidation = true;
    const ZipPlus4Split: string = ZipPopup.replace("-", "").trim();
    const arr = [Line1Popup, CityPopup, StatePopup, ZipPlus4Split].map((value: string) =>
      typeof value === "string" ? value.trim() : value
    );
    if (Line2Popup?.trim()) {
      arr.splice(position, 0, Line2Popup.trim());
    }

    valPayload.validateAddress = {
      postalCode: ZipPlus4Split,
      addressLines: arr
    };

    return valPayload;
  };

  function handleResponse(response, gAddrValPayload) {
    if (response.status === 400 || response.status === 400) {
      SetDisplayErrorMessage("No Records Found");
      setmasterLoader(false);
      SetErrorpopup(true);
    } else if (response.status === 500 || response.status === 500) {
      setmasterLoader(false);
      setValidateIsOpen(true);
      setSuggestedAddress(undefined);
      setAddressErrorMsg(
        t(
          "Automatic Address validation is Unavailable for the store # Please validate the address Manually."
        )
      );
    } else if (
      response.status === 200 &&
      response.data
    ) {
      setmasterLoader(false);

      interface AddressResponse {
        message?: string;
        status: boolean;
        matchCode?: string | undefined;
        suggestedAddress?: string;
        postalAddress?: PostalAddress;
        enforce?: any;
      }

      interface PostalAddress {
        addressLines: string[];
        administrativeArea: string;
        postalCode: string;
        locality: string;
      }

      const result: AddressResponse = validateAddressFn(response.data.validateAddress, undefined, true, gAddrValPayload);

      console.log(result, "te result from the validatAddress fn");
      console.log('EnableAddressValidation: ', featureFlagDetails?.EnableAddressValidation);
      const ZipPlus4Split: any = ZipPopup.replace("-", "");

      if (result.status) {
        if (result.matchCode) {
          setmasterLoader(false);
          setValidateIsOpen(true);
          setSuggestedAddress(undefined);
          const errorMessage: string =
            result.matchCode === "1"
              ? t(`Address could not be corrected. Unlikely to match. Do you want to override?`)
              : result.matchCode === "2"
                ? `${t("Zipcode found")}: ${ZipPlus4Split}. ${t("Do you want to override?")}`
                : "";
          setAddressErrorMsg(errorMessage);
        } else {
          if (result?.postalAddress) {
            if (result?.enforce === true && featureFlagDetails?.EnableAddressValidation === '1') {
              console.log("is true", result);
              setValidatedAddress(result);
              continueclick("GA", result);
            } else {
              setdefaultSuggestedAddress("GA");
              setCanSuggestAddress(true);
              setValidatedAddress(result);
              setSuggestedAddress({
                Addresses: {
                  PostalCode: result.postalAddress.postalCode,
                  City: result.postalAddress.locality,
                  StateProvince: result.postalAddress.administrativeArea,
                  StreetAddress:
                    result.postalAddress.addressLines.length > 1
                      ? result.postalAddress.addressLines[0]
                      : result.postalAddress.addressLines[0],
                },
              });
            }
          }
        }
      } else {
        setCantSuggestAddress(true);
        setValidatedAddress(result);
      }
    } else {
      throw new Error("Something went wrong");
    }
  }

  const addGridRow = async () => {
    setmasterLoader(true);

    const ZipPlus4Split: string = ZipPopup.replace("-", "").trim();
    console.log(ZipPlus4Split);

    const addressPayload: any = {
      MessageID: "CMS006-93589345",
      MessageType: "CMS006",
      MessageDTS: "2014-05-23-14:30:15:254633",
      MessageDTSTZOffset: "-06:00",
      RegionID: "1",
      ClientID: "8",
      ClientLocationNumber: "00006",
      ClientSource: "1",
      ClientOriginator: "1",
      LocationNumber: storeNumber,
      EncryptionMethod: "0",
      Addresses: [
        {
          AddressID: "11114",
          StreetAddress: Line2Popup?.trim().length > 0
              ? `${Line1Popup.trim()}, ${Line2Popup.trim()}`
              : Line1Popup.trim(),
          City: CityPopup.trim(),
          StateProvince: StatePopup.trim(),
          PostalCode: ZipPlus4Split,
          Country: "USA",
        },
      ],
      StoreConfig: {
        storeNumbers: [storeNumber],
        paramKeyNames: ["AddressDoctorEnabled"],
      },
    };
    try {
      const { CustomerAddressValidator, AddressDoctorEnabled } = featureFlagDetails
      debugger;
      if (canEnableGoogleValdation && ((CustomerAddressValidator && Number(CustomerAddressValidator) == 0) &&(AddressDoctorEnabled && Number(AddressDoctorEnabled) == 0))) {
        const gAddrValPayload = createValPayload(addressPayload, 0);
        const result = await GetSuggestedAddress(gAddrValPayload);
        handleResponse(result, gAddrValPayload)
      }
      else if (canEnableGoogleValdation) {
        const googleAddressValidationPayload: any = JSON.parse(
          JSON.stringify(addressPayload)
        );
        googleAddressValidationPayload.enableGoogleAddressValidation = true;
        const arr = [Line1Popup, CityPopup, StatePopup, ZipPlus4Split].map((value: string) =>
          typeof value === "string" ? value.trim() : value
        );
        if (Line2Popup?.trim()) {
          addressPayload.Addresses[0].StreetAddress += ` ${Line2Popup.trim()}`;
          arr.unshift(Line2Popup.trim());
        }
        const validateAddressPayload = {
          postalCode: ZipPlus4Split,
          addressLines: arr,
        };
        googleAddressValidationPayload.validateAddress = validateAddressPayload;
        const response: unknown = await Promise.all([
          GetSuggestedAddress(addressPayload),
          GetSuggestedAddress(googleAddressValidationPayload),
        ]);
        handleCombinedResponse(response as CombinedValidationResponseItem[], googleAddressValidationPayload);
      } else {
        const response: unknown = await GetSuggestedAddress(addressPayload);
        const resp = response as {
          status?: number;
          data?: {
            validateAddress?: unknown;
            storeConfig?: {
              storeProfileResponse: {
                configDetails: { configDetails: { paramValue: string | number }[] }[];
              };
            };
          };
        };
        console.log("AddressDoctor", resp);
        if (resp.status === 400) {
          SetDisplayErrorMessage("No Records Found");
          setmasterLoader(false);
          SetErrorpopup(true);
        } else if (resp.status === 500) {
          // SetDisplayErrorMessage('Something Went Wrong');
          setmasterLoader(false);
          setValidateIsOpen(true);
          setSuggestedAddress(undefined);
          setAddressErrorMsg(
            t(
              "Automatic Address validation is Unavailable for the store # Please validate the address Manually."
            )
          );
          // SetErrorpopup(true);
        }
        if (
          resp.data !== undefined &&
          resp.data !== null &&
          resp.data.storeConfig !== undefined &&
          (resp.data.storeConfig.storeProfileResponse.configDetails[0]
            .configDetails[0].paramValue == "Y" ||
            resp.data.storeConfig.storeProfileResponse.configDetails[0]
              .configDetails[0].paramValue == "1" ||
            resp.data.storeConfig.storeProfileResponse.configDetails[0]
              .configDetails[0].paramValue == 1)
        ) {
          setSuggestedAddress(resp.data.validateAddress);
          // const ZipValue = response.validateAddress.Addresses.PostalCode;
          // if (ZipValue.length < 10) {
          //   const values = ZipValue.replace('-', '');
          //   SetTrimmedZip(values);
          // }

          setmasterLoader(false);
          setValidateIsOpen(true);
        } else {
          setmasterLoader(false);
          setValidateIsOpen(true);
          setSuggestedAddress(undefined);
          setAddressErrorMsg(
            t(
              "Automatic Address validation is Unavailable for the store # Please validate the address Manually."
            )
          );
        }
      }
    } catch (e: any) {
      console.log("Error In Address Doctor", e);
      setmasterLoader(false);
    }
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  function handleCombinedResponse(response: CombinedValidationResponseItem[], googleAddressValidationPayload: Record<string, unknown>) {
    const ZipPlus4Split: string = (googleAddressValidationPayload?.validateAddress as { postalCode?: string })?.postalCode || ZipPopup.replace("-", "").trim();
    if (response[0].status === 400 || response[1].status === 400) {
      SetDisplayErrorMessage("No Records Found");
      setmasterLoader(false);
      SetErrorpopup(true);
    } else if (response[0].status === 500 || response[1].status === 500) {
      // SetDisplayErrorMessage('Something Went Wrong');
      setmasterLoader(false);
      setValidateIsOpen(true);
      setSuggestedAddress(undefined);
      setAddressErrorMsg(
        t(
          "Automatic Address validation is Unavailable for the store # Please validate the address Manually."
        )
      );
      // SetErrorpopup(true);
    } else if (
      response[0].status == 200 &&
      response[1].status == 200 &&
      response[0].data &&
      response[1].data
    ) {
      setmasterLoader(false);
      interface AddressResponse {
        message?: string;
        status: boolean;
        matchCode?: string | undefined;
        suggestedAddress?: string;
        postalAddress?: PostalAddress;
        enforce?: any;
      }

      interface PostalAddress {
        addressLines: string[];
        administrativeArea: string;
        postalCode: string;
        locality: string;
      }
      const result: AddressResponse = validateAddressFn(
        response[1].data.validateAddress,
        response[0].data.validateAddress,
        response[0].data &&
          response[0].data.storeConfig &&
          response[0].data.storeConfig.storeProfileResponse.configDetails[0]
            .configDetails[0].paramValue == "1"
          ? true
          : false,
        googleAddressValidationPayload
      );
      console.log(result, "te result from the validatAddress fn");
      console.log('EnableAddressValidation: ', featureFlagDetails?.EnableAddressValidation);

      if (result.status) {
        if (result.matchCode) {
          setmasterLoader(false);
          setValidateIsOpen(true);
          setSuggestedAddress(undefined);
          const errorMessage: string =
            result.matchCode == "1"
              ? t(
                  `Address could not be corrected. Unlikely to match. Do you want to override?`
                )
              : result.matchCode == "2"
              ? `${t("Zipcode found")}: ${ZipPlus4Split}. ${t(
                  "Do you want to override?"
                )}`
              : "";
          setAddressErrorMsg(errorMessage);
        } else {
          if (result?.postalAddress) {
            if(result?.enforce == true && featureFlagDetails?.EnableAddressValidation == '1'){
            console.log("is true", result);
            setValidatedAddress(result)
            continueclick("GA",result)
          }else{
            setdefaultSuggestedAddress("GA");
            setCanSuggestAddress(true);
            setValidatedAddress(result);
            setSuggestedAddress({
              Addresses: {
                PostalCode: result.postalAddress.postalCode,
                City: result.postalAddress.locality,
                StateProvince: result.postalAddress.administrativeArea,
                StreetAddress:
                  result.postalAddress.addressLines.length > 1
                    ? result.postalAddress.addressLines[1]
                    : result.postalAddress.addressLines[0],
              },
            });
          }
          }
        }
      } else {
        setCantSuggestAddress(true);
        setValidatedAddress(result);
      }
    } else {
      throw "Something went wrong";
    }
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const handleChange = (event: any) => {
    if (event.target.value !== undefined) {
      // eslint-disable-next-line no-console
      console.log("Inside", event.target.name);
      let regexItem;
      if (event.target.name !== "state") {
        if (event.target.name == "city") {
          regexItem = new RegExp("^[a-zA-Z ]*$");
        } else if (event.target.name == "zip") {
          regexItem = new RegExp("^[0-9 -]+$");
        }

        if (event.target.value.match(regexItem) || event.target.value == "") {
          console.log(event.target.value);
          // if (regexItem.test(event.target.value)) {
          if (event.target.name == "addressLine1") {
            SetLine1Popup(event.target.value);
          } else if (event.target.name == "addressLine2") {
            SetLine2Popup(event.target.value);
          } else if (event.target.name == "city") {
            // eslint-disable-next-line no-console
            console.log("Inside cisty value", event.target.value);
            SetCityPopup(event.target.value);
          } else if (event.target.name == "state") {
            SetStatePopup(event.target.value);
            SetStatePopupId(event.target.id);
          } else if (event.target.name == "zip") {
            const value = event.target.value.replace("-", "");
            console.log(value);
            if (value.length > 5) {
              SetZipPopup(
                value.trim().substring(0, 5) +
                  "-" +
                  value.trim().substring(5, value.length)
              );
            } else {
              SetZipPopup(value);
            }
          }
        }
      }
    }
  };

  const Selectaddress = (event: any) => {
    /* eslint-disable no-console */
    console.log(event);
    /* eslint-disable no-console */
    console.log(event.target.id);
    console.log("TEMP 1", TEMP);
    SetTEMP(event.target.id);
    SetIdAddress(event.target.value);
    console.log("vhdjsjjdfjdfh", event.target.value);

    console.log("TEMP 2", TEMP);
    const temporary = TEMP;
    console.log("Var TEMP", temporary);
  };

  const Okpopup = () => {
    setmasterLoader(false);
    setAddress({
      street: '',
      interiorNum: '',
      exteriorNum: '',
      suburb: '',
      zipcode: '',
      city: '',
      state: ''
    });
    /* eslint-disable no-console */
    console.log("TEMP 3", TEMP);
    setSuggestAddress(false);
    /* eslint-disable no-console */
    console.log("ArrayValue", addRowArray);
    /* eslint-disable no-console */
    console.log("array size", TEMP);
    SetAddressline1(addRowArray[TEMP].addressLine1);
    SetAddressline2(addRowArray[TEMP].addressLine2);
    setExteriorNumber(addRowArray[TEMP].exteriorNumber);
    setInteriorNumber(addRowArray[TEMP].interiorNumer);

    if (addRowArray[TEMP].zip != null && addRowArray[TEMP].zip != undefined) {
      if (
        addRowArray[TEMP].plus4 != null &&
        addRowArray[TEMP].zip != undefined
      ) {
        SetZip(addRowArray[TEMP].zip + "-" + addRowArray[TEMP].plus4);
      } else {
        SetZip(addRowArray[TEMP].zip);
      }
    }
    SetCity(addRowArray[TEMP].city);
    SetState(addRowArray[TEMP].stateProvinceName);
    Setagreementid(IdAddress);
    SetPopup(false);
    SetSaveTrigger(false);
  };

  const Loadstate = () => {
    if (Statedrop !== undefined) {
      return Statedrop.map((entry: any) => {
        return {
          label: t(entry.stateAbbreviation),
          value: entry.stateAbbreviation,
        };
      });
    } else {
      return [{ label: t("Select"), value: "0" }];
    }
  };

  const RadioBtnclick = (type: any) => {
    if (type === "SUG") {
      setBtnIsdisabled1(true);

      setBtnIsdisabled2(false);

      setdefaultSuggestedAddress("SUG");
    } else if (type === "ENT") {
      setBtnIsdisabled1(false);

      setBtnIsdisabled2(true);

      setdefaultSuggestedAddress("ENT");
    }
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const continueclick = async (type: any, validateAddressFromFunction?: any) => {
    setCanSuggestAddress(false);
    setValidateIsOpen(false);
    setmasterLoader(true);

    // const getGcidresponse = await Getglobalcustomerid(customerId);
    // // SetEnableLoaderButton(true);
    // // eslint-disable-next-line no-console
    // console.log(
    //   'gcid response',
    //   getGcidresponse !== undefined &&
    //     getGcidresponse.data &&
    //     getGcidresponse.data.globalCustomerId !== undefined &&
    //     getGcidresponse.data.globalCustomerId !== null
    //     ? getGcidresponse.data.globalCustomerId
    //     : ''
    // );

    if (type == "SUG" || type == "GA") {
      debugger;
      console.log("continue click");
      let ZipAddress = '';
      if(validateAddressFromFunction){
        ZipAddress = validateAddressFromFunction?.postalAddress?.postalCode
      }else{
        ZipAddress = SuggestedAddress.Addresses.PostalCode;
      }
      console.log("continue click1");
      let postAddresszip = "";
      console.log("continue click2");
      if (ZipAddress.length == 10) {
        console.log("continue click3");
        postAddresszip = ZipAddress.slice(0, 5) + "-" + ZipAddress.slice(6, 10);
      } else if (ZipAddress.length >= 5) {
        console.log("continue click4");
        postAddresszip = ZipAddress.slice(0, 5);
      }

      console.log("continue click5");
      let postaddress
      if(validateAddressFromFunction){
        console.log("true flow", validateAddressFromFunction);

        const streetAddress = validateAddressFromFunction.postalAddress.addressLines[0];

        const line2Address = validateAddressFromFunction.postalAddress.addressLines.length > 1 ? validateAddressFromFunction.postalAddress.addressLines[1] : Line2Popup;

        postaddress = {
          customerId: customerId,
          addresses: [
          {
            addressType: "DELIV",
            active: "Y",
            addressLine1: streetAddress,
            addressLine2: line2Address,
            city: validateAddressFromFunction.postalAddress.locality,
            state: validateAddressFromFunction.postalAddress.administrativeArea,
            postalCode: postAddresszip,
            agreementIds: [agreementId],
          },
        ],
      };
      }else{
          postaddress = {
          customerId: customerId,
          addresses: [
          {
            addressType: "DELIV",
            active: "Y",
            addressLine1: SuggestedAddress.Addresses.StreetAddress,
            addressLine2: Line2Popup,
            city: SuggestedAddress.Addresses.City,
            state: SuggestedAddress.Addresses.StateProvince,
            postalCode: postAddresszip,
            agreementIds: [agreementId],
          },
        ],
      };
    }
      // eslint-disable-next-line no-console
      console.log("after api ", postaddress);
      if (postaddress != undefined) {
        addadress(postaddress);
        newDeliveryAddress = postaddress;
        setNewDeliverAddress(newDeliveryAddress);
        // SetenableRdo(false);
      } else {
        return (
          <div className={classes.Norecords}>
            <CircularProgress />
          </div>
        );
      }
    } else if (type == "ENT") {
      let postAddresszip = "";
      if (ZipPopup.length == 10) {
        postAddresszip = ZipPopup.slice(0, 5) + "-" + ZipPopup.slice(6, 10);
      } else if (ZipPopup.length >= 5) {
        postAddresszip = ZipPopup.slice(0, 5);
      }

      const postaddress = {
        customerId: customerId,
        addresses: [
          {
            addressType: "DELIV",
            active: "Y",
            addressLine1: Line1Popup,
            addressLine2: Line2Popup,
            city: CityPopup,
            state: StatePopup,
            postalCode: postAddresszip,
            agreementIds: [agreementId],
          },
        ],
      };
      // eslint-disable-next-line no-console
      console.log("after api ", postaddress);
      if (postaddress != undefined) {
        addadress(postaddress);
        newDeliveryAddress = postaddress;
        setNewDeliverAddress(newDeliveryAddress);
        // SetenableRdo(false);
      } else {
        return (
          <div className={classes.Norecords}>
            <CircularProgress />
          </div>
        );
      }
    }
  };
  const getnextamountdue = async () => {
    const paymentobject = {
      agreementIdCustomerId: [
        {
          agreementId: parseInt(agreementId),
          customerId: parseInt(customerId),
        },
      ],
    };

    const getamountresponse = await getnextpaymentamount(paymentobject);

    if (getamountresponse.status === 504) {
      SetErrorpopup(true);
    } else {
      if (
        getamountresponse.data !== undefined &&
        getamountresponse.data !== null &&
        getamountresponse.data.amountDueResponse !== undefined &&
        getamountresponse.data.amountDueResponse !== null
      ) {
        const AmountResponse = getamountresponse.data.amountDueResponse.find(
          (x: { agreementId: string }) => x.agreementId == agreementId
        );
        /* eslint-disable no-console */
        console.log("agreementid related data", AmountResponse);

        if (
          AmountResponse !== undefined &&
          AmountResponse !== null &&
          AmountResponse !== "" &&
          AmountResponse.ldwAmount !== undefined &&
          AmountResponse.ldwAmount !== null
        ) {
          const Totalamountdue =
            parseFloat(AmountResponse.amountDue) +
            parseFloat(AmountResponse.ldwAmount);
          /* eslint-disable no-console */
          console.log("agreementid Total Amount", Totalamountdue);
          setnextpaymentinfo({
            ...nextpaymentinfo,
            nextamountdue: Totalamountdue.toFixed(2),
            nextduedate: AmountResponse.nextDueDate,
          });
          console.log("next amount due", nextpaymentinfo);
          return Totalamountdue.toFixed(2);
        } else {
          /* eslint-disable no-console */
          console.log("nextpaymentamount", getamountresponse.data);

          setnextpaymentinfo({
            ...nextpaymentinfo,
            nextamountdue:
              getamountresponse.data.amountDueResponse[0].amountDue,
            nextduedate:
              getamountresponse.data.amountDueResponse[0].nextDueDate,
          });
          console.log("next amount due", nextpaymentinfo);
          console.log(
            "getamountdue response",
            getamountresponse.data.amountDueResponse[0].amountDue
          );
          return getamountresponse.data.amountDueResponse[0].amountDue;
        }
      }
    }
  };
  // eslint-disable-next-line sonarjs/cognitive-complexity
  const receiptstatus = async (nextamount: any) => {
    console.log("view params for nextamount", nextamount);
    await LoadDeliveryreceipt(agreementId);
    // if (
    //   deliveryreceiptresponse !== undefined &&
    //   deliveryreceiptresponse.responseData !== undefined
    // ) {
    //   const TempArr: any = [];
    //   for (
    //     let i = 0;
    //     i <= deliveryreceiptresponse.responseData.length - 1;
    //     i++
    //   ) {
    //     const obj = {
    //       inventoryId: deliveryreceiptresponse.responseData[i].inventoryId,
    //       inventoryNumber:
    //         deliveryreceiptresponse.responseData[i].inventoryNumber,
    //       serialNumber: deliveryreceiptresponse.responseData[i].serialNumber,
    //       inventoryDesc: deliveryreceiptresponse.responseData[i].inventoryDesc,
    //     };
    //     TempArr.push(obj);
    //   }
    //   const bodyobj = {
    //     inventorydescription: TempArr,
    //     customerName:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].customerName
    //         : "",
    //     addressLine1:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].addressLine1
    //         : "",
    //     addressLine2:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0 &&
    //         deliveryreceiptresponse.responseData[0].addressLine2 !== null &&
    //         deliveryreceiptresponse.responseData[0].addressLine2 !== ""
    //         ? deliveryreceiptresponse.responseData[0].addressLine2
    //         : "",
    //     customerCity:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].customerCity
    //         : "",
    //     customerZip:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0 &&
    //         deliveryreceiptresponse.responseData[0].customerZip !== null &&
    //         deliveryreceiptresponse.responseData[0].customerPlus4 !== null
    //         ? deliveryreceiptresponse.responseData[0].customerZip +
    //         "-" +
    //         deliveryreceiptresponse.responseData[0].customerPlus4
    //         : deliveryreceiptresponse.responseData[0].customerZip,
    //     customerState:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].customerState
    //         : "",
    //     customerPhoneNumber:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].customerPhoneNumber
    //         : "",
    //     storeName:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].storeName
    //         : "",
    //     storeNumber:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].storeNumber
    //         : "",
    //     storeAddressLine1:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].storeAddressLine1
    //         : "",
    //     storeAddressLine2:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0 &&
    //         deliveryreceiptresponse.responseData[0].storeAddressLine2 !== null &&
    //         deliveryreceiptresponse.responseData[0].storeAddressLine2 !== ""
    //         ? deliveryreceiptresponse.responseData[0].storeAddressLine2
    //         : "",
    //     storeCity:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].storeCity
    //         : "",
    //     storeState:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].storeState
    //         : "",
    //     storeZip:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].storeZip
    //         : "",
    //     storePhoneNumber:
    //       deliveryreceiptresponse !== undefined &&
    //         deliveryreceiptresponse.responseData !== undefined &&
    //         deliveryreceiptresponse.responseData.length > 0
    //         ? deliveryreceiptresponse.responseData[0].storePhoneNumber
    //         : "",
    //     agreementId: Number(agreementId),
    //     customerId: customerId,
    //     deliveryDate: startDate,
    //     deliveryTime: Time,
    //     agreementNumber: agreementNumber,
    //     nexDueAmount:
    //       nextamount !== undefined && nextamount !== null
    //         ? nextamount.toString()
    //         : "",
    //   };

    //   console.log("view payload", bodyobj);

    //   const receiptresponse = await GenerateReceipt(bodyobj);

    //   if (receiptresponse.data !== undefined && receiptresponse.data !== null) {
    //     setpdfresponse(receiptresponse.data);
    //     console.log("delievry checklist", receiptresponse.data);
    //   }
    // }
  };

  const decideappointmentType = () => {
    return Deliverytype == "D" ? "P" : "CI";
  };
  // eslint-disable-next-line sonarjs/cognitive-complexity

 // AMR-512 -> Override FieldVisit, Navigating to DAP
    const NavigateToFV = (payload)=>{
      history.push({
        pathname: AppRoute.DAP,
        state:{
          agreementDetails:payload,
          isFVOveride:true,
          source:"agreement"
        },
        
      })
    }

  const processFieldVisitMoveOverride = () => {

    const payload = {
            storeNumber: window.sessionStorage.getItem("storeNumber"),
            address_id: IdAddress,
            eventInformation: {
              partyId: customerId,
              agreementId: agreementId,
              inventoryIds: inventoryid,
              type: props.isReturn === true ? "Return" : Deliverytype,
              eventDate: moment(startDate).format("MM/DD/YYYY"),
              eventSource: "Store",
              timeSlot: {
                timeSlotId: timeslotid,
              },
              eventInstructions: Instructions,
              requiredCoworkers: Coworkers ? Coworkers : "1",
              racdbSourced: true,
              agreementNumber: AgrNumber,
              customerName: cusName,
              isLoaner: "Y",
              loanerCreate: {
                storeNumber: window.sessionStorage.getItem("storeNumber"),
                timeSlot: timeslotid,
                customerId: String(customerId),
                agreementNumber: AgrNumber,
                inventories: InventoryNumber,                
                appointmentInfo: {
                  appointmentType: !props.isReturn
                    ? Deliverytype
                    : decideappointmentType(),
                  appointmentSource: AppoinmentSource,
                  appointmentDate: startDate,
                  requiredCoworkers: Coworkers ? Coworkers : "1",
                  instructions: Instructions,
                  deliveryPersonId: salesPersonValue,
                },
              },
            },
          };

      NavigateToFV(payload);
  }

  const Complete_delivery_status  = async (isExchange?: any, rows?: any) : Promise<deliveryResultStatus | void> => {
    if (RescheduleEventId != null && RescheduleEventId != "") {
      setmasterLoader(true);
      let NumberofCoworkers = "";
      if (Coworkers == "") {
        NumberofCoworkers = "1";
      } else {
        NumberofCoworkers = Coworkers;
      }
      let exchangeResponse;

      if (deliveryStatus == "Cancelled") {
        const value = {
          agreementId: "98989898",
          isLoaner: "Y",
          loanerAction: {
            appointmentId: String(RescheduleEventId),
            storeNumber: window.sessionStorage.getItem("storeNumber"),
            actionName: "Reopen",
            coWorkerId: employeeId,
          },
        };
        const result = await Confirmdelivery(value);
        console.log("result", result);
      }
      const complete = {
        storeNumber: storeNumber,
        //address_id: IdAddress,
        eventInformation: {
          partyId: customerId,
          //agreementId: agreementId,
          inventoryIds: inventoryid,
          type: props.isReturn === true ? "Return" : Deliverytype,
          // eslint-disable-next-line sonarjs/no-duplicate-string
          eventDate: moment(startDate).format("MM/DD/YYYY"),
          eventSource: "Store",
          //eventId: RescheduleEventId,
          timeSlot: {
            timeSlotId: timeslotid,
          },
          eventInstruction: Instructions,
          requiredCoworkers: NumberofCoworkers ? NumberofCoworkers : "1",
          racdbSourced: true,
          //agreementNumber: AgrNumber,
          //customerName: cusName,
          isLoaner: "Y",
          loanerCreate: {
            storeNumber: window.sessionStorage.getItem("storeNumber"),
            timeSlot: timeslotid,
            customerId: String(customerId),
            agreementNumber: AgrNumber,
            inventories: InventoryNumber,
            // coworkerId: "654644",
            appointmentId: String(RescheduleEventId),
            appointmentInfo: {
              appointmentType: !props.isReturn
                ? Deliverytype
                : decideappointmentType(),
              appointmentSource: AppoinmentSource,
              appointmentDate: startDate,
              requiredCoworkers: NumberofCoworkers,
              instructions: Instructions,
            },
          },
        },
      };
      // eslint-disable-next-line sonarjs/no-duplicate-string
      console.log("Complete event reuest", complete);
      setmasterLoader(true);
      const Apiresult = await FinishdeliveryStatus(complete);
      setmasterLoader(false);

      if (isExchange && exReturnTimeSlotId) {
        setmasterLoader(true);
        exchangeResponse = await Complete_delivery_status_exchange();
        setmasterLoader(false);
      }
      console.log("Apiresult logg", Apiresult);
      /* eslint-disable no-console */
      try {
        console.log(Apiresult.data);
        setmasterLoader(true);
        const nextamount = await getnextamountdue();
        console.log("1731", nextamount);
        await receiptstatus(nextamount);
        setmasterLoader(false);
        // setmasterLoader(false);
        SetSaveTrigger(true);
        // exchange changes
        if (isExchange && exReturnTimeSlotId) {
          if (Apiresult.status == 200 && exchangeResponse.status == 200) {
            const ApiData = Apiresult.data;
            console.log("enter the open popup");
            setmasterLoader(false);
            SetOpenreturnconfirmpopup(true);
            setNewAppointmentId(ApiData?.appointmentInfo?.appointmentId);
            GetTimeSlot(startDate, AppoinmentSource);
            let TrimmedZip = "";
            let TrimmedPlus4: any = "";
            if (Zip.length > 5) {
              TrimmedZip = Zip.slice(0, 5);
              TrimmedPlus4 = Zip.slice(6, Zip.length);
            } else {
              TrimmedZip = Zip;
            }
            const Value = {
              eventId: RescheduleEventId,
              deliveryType: Deliverytype,
              addressId: IdAddress,
              addressLine1: Addressline1,
              addressLine2: Addressline2,
              zip: TrimmedZip,
              zipPlus4: TrimmedPlus4 != "" ? TrimmedPlus4 : null,
              city: City,
              state: State,
              timeSlotId: timeslotid,
              appointmentDate: moment(startDate).format("MM/DD/YYYY"),
              appointmentStartTime: ContextStartDate,
              appointmentEndTime: ContextEndDate,
              coWorkersRequired: Coworkers,
              instructions: Instructions,
            };
            console.log("Context", Value);

            const some = {
              deliveryMethodStatus: "0",
              deliveryInformation: Value,
            };
            console.log("DeliveryValue", some);
            setdeliveryMethodData(some);
          } else if (Apiresult.status == 200 && openReturnContent == false) {
            const ApiData = Apiresult.data;
            console.log("enter the open popup");
            setmasterLoader(false);
            SetOpendeliveryconfirmpopup(true);
            setNewAppointmentId(ApiData?.appointmentInfo?.appointmentId);
            GetTimeSlot(startDate, AppoinmentSource);
            let TrimmedZip = "";
            let TrimmedPlus4: any = "";
            if (Zip.length > 5) {
              TrimmedZip = Zip.slice(0, 5);
              TrimmedPlus4 = Zip.slice(6, Zip.length);
            } else {
              TrimmedZip = Zip;
            }
            const Value = {
              eventId: RescheduleEventId,
              deliveryType: Deliverytype,
              addressId: IdAddress,
              addressLine1: Addressline1,
              addressLine2: Addressline2,
              zip: TrimmedZip,
              zipPlus4: TrimmedPlus4 != "" ? TrimmedPlus4 : null,
              city: City,
              state: State,
              timeSlotId: timeslotid,
              appointmentDate: moment(startDate).format("MM/DD/YYYY"),
              appointmentStartTime: ContextStartDate,
              appointmentEndTime: ContextEndDate,
              coWorkersRequired: Coworkers,
              instructions: Instructions,
            };
            console.log("Context", Value);

            const some = {
              deliveryMethodStatus: "0",
              deliveryInformation: Value,
            };
            console.log("DeliveryValue", some);
            setdeliveryMethodData(some);
          } else if (
            Apiresult.status == 400 ||
            exchangeResponse.status == 400
          ) {
            setmasterLoader(false);
            SetErrorpopup(true);
            SetDisplayErrorMessage("Something Went Wrong");
          } else {
            /* eslint-disable sonarjs/no-duplicated-branches */
            setmasterLoader(false);
            SetErrorpopup(true);
            SetDisplayErrorMessage("Something Went Wrong");
          }
        } else {
          if (Apiresult.status == 200) {
            const ApiData = Apiresult.data;
            setmasterLoader(false);
            SetOpendeliveryconfirmpopup(true);
            setNewAppointmentId(ApiData?.appointmentInfo?.appointmentId);
            GetTimeSlot(startDate, AppoinmentSource);
            let TrimmedZip = "";
            let TrimmedPlus4: any = "";
            if (Zip.length > 5) {
              TrimmedZip = Zip.slice(0, 5);
              TrimmedPlus4 = Zip.slice(6, Zip.length);
            } else {
              TrimmedZip = Zip;
            }
            const Value = {
              eventId: RescheduleEventId,
              deliveryType: Deliverytype,
              addressId: IdAddress,
              addressLine1: Addressline1,
              addressLine2: Addressline2,
              zip: TrimmedZip,
              zipPlus4: TrimmedPlus4 != "" ? TrimmedPlus4 : null,
              city: City,
              state: State,
              timeSlotId: timeslotid,
              appointmentDate: moment(startDate).format("MM/DD/YYYY"),
              appointmentStartTime: ContextStartDate,
              appointmentEndTime: ContextEndDate,
              coWorkersRequired: Coworkers,
              instructions: Instructions,
            };
            console.log("Context", Value);

            const some = {
              deliveryMethodStatus: "0",
              deliveryInformation: Value,
            };
            console.log("DeliveryValue", some);
            setdeliveryMethodData(some);
          } else {
            setmasterLoader(false);
            SetErrorpopup(true);
            SetDisplayErrorMessage("Something Went Wrong");
          }
        }
      } catch (e) {
        setmasterLoader(false);
        SetErrorpopup(true);
        SetDisplayErrorMessage("Something Went Wrong");
      }
    } else {
      // NOT reschedule
      try {
        setmasterLoader(true);
        let NumberofCoworkers = "";
        console.log(Coworkers);

        if (Coworkers == "") {
          NumberofCoworkers = "1";
        } else {
          NumberofCoworkers = Coworkers;
        }
        let exchangeResponse;
        console.log(mxDeliveryKey, "mxDeliverykeys");
        let complete;
        console.log(salesPersonValue, "salespersonvalue");

        if (rows && !Array.isArray(rows) && rows.type == 'P') {

        const { store, inventory, date, timeSlot, description,type,inventoryIdvalue } = rows;
        console.log(rows, store, inventory, date, timeSlot, description,type,inventoryIdvalue);
        let inventoryIdArray :string[]=[];
        inventoryIdArray.push(inventoryIdvalue)

        if (mxDeliveryKey ) {
          complete = {
            storeNumber: store,
            address_id: IdAddress,
            eventInformation: {
              partyId: customerId,
              agreementId: agreementId,
              inventoryIds: inventoryIdArray ,
              type: props.isReturn === true ? "Return" : "P",
              eventDate: moment(date).format("MM/DD/YYYY"),
              eventSource: "Store",
              timeSlot: {
                timeSlotId: timeSlot,
              },
              eventInstruction: Instructions,
              requiredCoworkers: NumberofCoworkers ? NumberofCoworkers : "1",
              racdbSourced: true,
              agreementNumber: AgrNumber,
              customerName: cusName,
              isLoaner: "Y",
              loanerCreate: {
                storeNumber: store,
                timeSlot: timeSlot,
                agreementNumber: AgrNumber,
                inventories:inventory,
                // coworkerId: "654644",
                appointmentInfo: {
                  appointmentType: "P",
                  appointmentSource: AppoinmentSource,
                  appointmentDate: startDate,
                  requiredCoworkers: NumberofCoworkers,
                  instructions: Instructions,
                  deliveryPersonId: salesPersonValue,
                },
              },
            },
          };
          console.log("Complete event result", complete);
          setmasterLoader(true);
        }
       } else {
          complete = {
            storeNumber: window.sessionStorage.getItem("storeNumber"),
            address_id: IdAddress,
            eventInformation: {
              partyId: customerId,
              agreementId: agreementId,
              inventoryIds: inventoryid,
              type: props.isReturn === true ? "Return" : Deliverytype,
              eventDate: moment(startDate).format("MM/DD/YYYY"),
              eventSource: "Store",
              timeSlot: {
                timeSlotId: timeslotid,
              },
              eventInstructions: Instructions,
              requiredCoworkers: NumberofCoworkers ? NumberofCoworkers : "1",
              racdbSourced: true,
              agreementNumber: AgrNumber,
              customerName: cusName,
              isLoaner: "Y",
              loanerCreate: {
                storeNumber: window.sessionStorage.getItem("storeNumber"),
                timeSlot: timeslotid,
                customerId: String(customerId),
                agreementNumber: AgrNumber,
                inventories: InventoryNumber,
                // coworkerId: "654644",
                appointmentInfo: {
                  appointmentType: !props.isReturn
                    ? Deliverytype
                    : decideappointmentType(),
                  appointmentSource: AppoinmentSource,
                  appointmentDate: startDate,
                  requiredCoworkers: NumberofCoworkers,
                  instructions: Instructions,
                  deliveryPersonId: salesPersonValue,
                },
              },
            },
          };

          console.log("Complete event result", complete);
          setmasterLoader(true);
        }
      
        const Apiresult = await FinishdeliveryStatus(complete);

        console.log(
          Apiresult.data,
          "inside the else block of normal delivery scenario"
        );
        console.log( Apiresult.data.code,"value of status");
        

        await createStorePickupEvent(
          Apiresult,
          NumberofCoworkers,
          props.isReturn
        );
        setmasterLoader(false);

        SetSaveTrigger(true);
        if (isExchange && exReturnTimeSlotId) {
          console.log("inside the if that were issue occur1");
          setmasterLoader(true);
          exchangeResponse = await Complete_delivery_status_exchange();
          setmasterLoader(false);
        }

        if (isExchange && exReturnTimeSlotId) {
          console.log("inside the if that were issue occur1");

          if (Apiresult.status == 200 && exchangeResponse.status == 200) {

            console.log("inside the if block of success api");
            
            const ApiData = Apiresult.data;
            setmasterLoader(false);
            setNewAppointmentId(ApiData?.appointmentInfo?.appointmentId);
            SetOpenreturnconfirmpopup(true);
            /* eslint-disable sonarjs/no-duplicate-string */
            const request = {
              storeNumber: window.sessionStorage.getItem("storeNumber"),
              eventInformation: {
                partyId: "33925768",
                agreementId: agreementId,
                inventoryIds: ["9999207382277"],
                type: "Delivery",
                eventDate: "11/23/2021",
                eventSource: "Store",
                timeSlot: {
                  timeSlotId: "9999100000392",
                },
                eventInstructions: "created customer event",
                requiredCoworkers: "2",
                racdbSourced: true,
                isLoaner: "N",
              },
              address_id: addressId,
            };
            setmasterLoader(true);
            const result = await FinishdeliveryStatus(request);
            setmasterLoader(false);
          } else if (Apiresult.status == 200 && openReturnContent == false) {
            console.log("openReturnContent");
            
            const ApiData = Apiresult.data;
            setmasterLoader(false);
            setNewAppointmentId(ApiData?.appointmentInfo?.appointmentId);
            SetOpendeliveryconfirmpopup(true);
            /* eslint-disable sonarjs/no-duplicate-string */
            const request = {
              storeNumber: window.sessionStorage.getItem("storeNumber"),
              eventInformation: {
                partyId: "33925768",
                agreementId: agreementId,
                inventoryIds: ["9999207382277"],
                type: "Delivery",
                eventDate: "11/23/2021",
                eventSource: "Store",
                timeSlot: {
                  timeSlotId: "9999100000392",
                },
                eventInstructions: "created customer event",
                requiredCoworkers: "2",
                racdbSourced: true,
                isLoaner: "N",
              },
              address_id: addressId,
            };
            setmasterLoader(true);
            const result = await FinishdeliveryStatus(request);
            setmasterLoader(false);
          } else if (
            Apiresult.status == 400 ||
            exchangeResponse.status == 400
          ) {
            console.log("something went wrong1");
            setmasterLoader(false);
            SetErrorpopup(true);
            SetDisplayErrorMessage("Something Went Wrong");
          } else {
            /* eslint-disable sonarjs/no-duplicated-branches */
            console.log("something went wrong2");
            setmasterLoader(false);
            SetErrorpopup(true);
            SetDisplayErrorMessage("Something Went Wrong");
          }
        } else {  
          if (Apiresult.status == 200) {

            if(mxDeliveryKey){
              const ApiData = Apiresult.data;
              setNewAppointmentId(ApiData?.appointmentInfo?.appointmentId);
              
              // Show pickup confirmation popup for pickup appointments
              if (props.isReturn || Deliverytype === "P") {
                SetOpenPickupConfirmPopup(true);
              } else {
                SetOpendeliveryconfirmpopup(true);
              }

              const request = {
                storeNumber: window.sessionStorage.getItem("storeNumber"),
                eventInformation: {
                  partyId: "33925768",
                  agreementId: agreementId,
                  inventoryIds: ["9999207382277"],
                  type: "Delivery",
                  eventDate: "11/23/2021",
                  eventSource: "Store",
                  timeSlot: {
                    timeSlotId: "9999100000392",
                  },
                  eventInstructions: "created customer event",
                  requiredCoworkers: "2",
                  racdbSourced: true,
                  isLoaner: "N",
                },
                address_id: IdAddress,
              };
              setmasterLoader(true);
              const result = await FinishdeliveryStatus(request);
              setmasterLoader(false);

              return{
                  status: Apiresult?.status === 200 ? "success" : "failed",
                  res: Apiresult.data,
                  row: rows,
              }

            }
            const ApiData = Apiresult.data;
            setmasterLoader(false);
            setNewAppointmentId(ApiData?.appointmentInfo?.appointmentId);
             SetOpendeliveryconfirmpopup(true);
            const request = {
              storeNumber: window.sessionStorage.getItem("storeNumber"),
              eventInformation: {
                partyId: "33925768",
                agreementId: agreementId,
                inventoryIds: ["9999207382277"],
                type: "Delivery",
                eventDate: "11/23/2021",
                eventSource: "Store",
                timeSlot: {
                  timeSlotId: "9999100000392",
                },
                eventInstructions: "created customer event",
                requiredCoworkers: "2",
                racdbSourced: true,
                isLoaner: "N",
              },
              address_id: IdAddress,
            };
            setmasterLoader(true);
            const result = await FinishdeliveryStatus(request);
            setmasterLoader(false);
          } else {

            if(mxDeliveryKey){
              return{
                status: "failed",
                res: Apiresult.data,
                row: rows,
              
            }
          }
            console.log("something went wrong3");
            setmasterLoader(false);
            SetErrorpopup(true);
            SetDisplayErrorMessage("Something Went Wrong");
          }
        }
      }
    
       catch (e:any) {

        if (mxDeliveryKey) {
          return {
            status: "failed",
            res: { message: e?.message || "Unexpected error occurred" },
            row: rows,
          };
        }
        console.log("something went wrong4");       
        setmasterLoader(false);
        SetErrorpopup(true);
        SetDisplayErrorMessage("Something Went Wrong");
      }
    } // end of else for NOT reschedule
  }; // end of method Complete_delivery_status

  const Complete_delivery_status_exchange = async () => {
    let Apiresult: any;
    if (RescheduleEventId != null && RescheduleEventId != "") {
      setmasterLoader(true);
      console.log("cowokeeeerr", CoworkersExc);
      let NumberofCoworkers = "";
      if (CoworkersExc == "") {
        NumberofCoworkers = "1";
      } else {
        NumberofCoworkers = CoworkersExc;
      }
      let agrNum;
      let InventoryArray;
      let InventoryNumber;
      const agrResponse = await getAgreementInfo(
        exchangeAgreementId
          ? exchangeAgreementId
          : viewAgrData?.data?.agreementInformation?.agreementId
      );
      console.log(agrResponse, "agrResponsesdfghj");
      if (agrResponse.status == 200) {
        const agreementInfo = agrResponse.data;
        setAgreementResponse(agreementInfo);
        const InventoryArray = agreementInfo?.agreementInventories?.map(
          (Obj: any) => {
            return Obj.inventoryId;
          }
        );
        const InventoryNumber = agreementInfo?.agreementInventories?.map(
          (el: any) => {
            return { inventoryNumber: el.inventoryNumber };
          }
        );
        setInventoryNumberExc(InventoryNumber);
        console.log("InventoryArray", InventoryArray);
        Setinventoryidexc(InventoryArray);
        agrNum = agreementInfo?.agreementInformation?.agreementNumber;
        setAgrNumberExc(agrNum);
        console.log({ agrNumberExc, agrNum }, "agrNumberExcasdfgh");
      } else {
        setmasterLoader(false);
        SetErrorpopup(true);
        SetDisplayErrorMessage("Something Went Wrong");
      }
      /*eslint-disable no-constant-condition*/
      if (deliveryStatus == "Cancelled") {
        const value = {
          agreementId: "98989898",
          isLoaner: "Y",
          loanerAction: {
            appointmentId: String(RescheduleEventId),
            storeNumber: window.sessionStorage.getItem("storeNumber"),
            actionName: "Reopen",
            coWorkerId: employeeId,
          },
        };
        setmasterLoader(true);
        const result = await Confirmdelivery(value);
        setmasterLoader(false);
        console.log("result", result);
      }
      const complete = {
        storeNumber: storeNumber,
        //address_id: IdAddress,
        eventInformation: {
          partyId: customerId,
          //agreementId: agreementId,
          inventoryIds: InventoryArray,
          type:
            props.isReturn === true
              ? "Return"
              : DeliverytypeExc == "P" || "CI"
              ? "Return"
              : DeliverytypeExc,
          // eslint-disable-next-line sonarjs/no-duplicate-string
          eventDate: moment(startDateExc).format("MM/DD/YYYY"),
          eventSource: "Store",
          //eventId: RescheduleEventId,
          timeSlot: {
            timeSlotId: exReturnTimeSlotId,
          },
          eventInstruction: InstructionsExc,
          requiredCoworkers: NumberofCoworkers ? NumberofCoworkers : "1",
          racdbSourced: true,
          agreementNumber: agrNum,
          customerName: cusName,
          isLoaner: "Y",
          loanerCreate: {
            storeNumber: window.sessionStorage.getItem("storeNumber"),
            timeSlot: exReturnTimeSlotId,
            customerId: String(customerId),
            agreementNumber: agrNum,
            inventories: InventoryNumber,
            // coworkerId: "654644",
            appointmentId: String(RescheduleEventId),
            appointmentInfo: {
              appointmentType: !props.isReturn
                ? DeliverytypeExc
                : decideappointmentType(),
              appointmentSource: AppoinmentSource,
              appointmentDate: startDateExc,
              requiredCoworkers: NumberofCoworkers,
              instructions: InstructionsExc,
            },
          },
        },
      };

      console.log("Complete event reuest", complete);
      setmasterLoader(true);
      Apiresult = await FinishdeliveryStatus(complete);
      setmasterLoader(false);
      /* eslint-disable no-console */
      try {
        console.log(Apiresult.data);
        const nextamount = await getnextamountdue();
        console.log("1731", nextamount);
        await receiptstatus(nextamount);
        SetSaveTrigger(true);
        if (Apiresult.status == 200) {
          const ApiData = Apiresult.data;
          setmasterLoader(false);
          SetOpenreturnconfirmpopup(true);
          setNewAppointmentId(ApiData?.appointmentInfo?.appointmentId);
          GetTimeSlot(startDateExc, AppoinmentSource);
          let TrimmedZip = "";
          let TrimmedPlus4: any = "";
          if (Zip.length > 5) {
            TrimmedZip = Zip.slice(0, 5);
            TrimmedPlus4 = Zip.slice(6, Zip.length);
          } else {
            TrimmedZip = Zip;
          }
          const Value = {
            eventId: RescheduleEventId,
            deliveryType: DeliverytypeExc,
            addressId: IdAddress,
            addressLine1: Addressline1,
            addressLine2: Addressline2,
            zip: TrimmedZip,
            zipPlus4: TrimmedPlus4 != "" ? TrimmedPlus4 : null,
            city: City,
            state: State,
            timeSlotId: exReturnTimeSlotId,
            appointmentDate: moment(startDate).format("MM/DD/YYYY"),
            appointmentStartTime: ContextStartDate,
            appointmentEndTime: ContextEndDate,
            coWorkersRequired: CoworkersExc,
            instructions: InstructionsExc,
          };
          console.log("Context", Value);

          const some = {
            deliveryMethodStatus: "0",
            deliveryInformation: Value,
          };
          console.log("DeliveryValue", some);
          setdeliveryMethodData(some);
        } else {
          setmasterLoader(false);
          SetErrorpopup(true);
          SetDisplayErrorMessage("Something Went Wrong");
        }
      } catch (e) {
        setmasterLoader(false);
        SetErrorpopup(true);
        SetDisplayErrorMessage("Something Went Wrong");
      }
    } else {
      try {
        setmasterLoader(true);
        let NumberofCoworkers = "";
        if (CoworkersExc == "") {
          NumberofCoworkers = "1";
        } else {
          NumberofCoworkers = CoworkersExc;
        }
        let agrNum;
        let InventoryArray;
        let InventoryNumber;
        const agrResponse = await getAgreementInfo(
          exchangeAgreementId
            ? exchangeAgreementId
            : viewAgrData?.data?.agreementInformation?.agreementId
        );
        console.log(agrResponse, "agrResponsesdfghj");
        if (agrResponse.status == 200) {
          const agreementInfo = agrResponse.data;
          setAgreementResponse(agreementInfo);
          InventoryArray = agreementInfo?.agreementInventories?.map(
            (Obj: any) => {
              return Obj.inventoryId;
            }
          );
          InventoryNumber = agreementInfo?.agreementInventories?.map(
            (el: any) => {
              return { inventoryNumber: el.inventoryNumber };
            }
          );
          setInventoryNumberExc(InventoryNumber);
          console.log("InventoryArray", InventoryArray);
          Setinventoryidexc(InventoryArray);
          agrNum = agreementInfo?.agreementInformation?.agreementNumber;
          setAgrNumberExc(agrNum);
          console.log({ agrNumberExc, agrNum }, "agrNumberExcasdfgh");
        } else {
          setmasterLoader(false);
          SetErrorpopup(true);
          SetDisplayErrorMessage("Something Went Wrong");
        }

        const complete = {
          storeNumber: storeNumber,
          address_id: IdAddress,
          eventInformation: {
            partyId: customerId,
            agreementId: exchangeAgreementId
              ? exchangeAgreementId
              : viewAgrData?.data?.agreementInformation?.agreementId,
            inventoryIds: InventoryArray,
            type:
              props.isReturn === true
                ? "Return"
                : DeliverytypeExc == "P" || "CI"
                ? "Return"
                : DeliverytypeExc,
            eventDate: moment(startDateExc).format("MM/DD/YYYY"),
            eventSource: "Store",
            timeSlot: {
              timeSlotId: exReturnTimeSlotId,
            },
            eventInstruction: InstructionsExc,
            requiredCoworkers: NumberofCoworkers ? NumberofCoworkers : "1",
            racdbSourced: true,
            agreementNumber: agrNum,
            customerName: cusName,
            isLoaner: "Y",
            loanerCreate: {
              storeNumber: window.sessionStorage.getItem("storeNumber"),
              timeSlot: exReturnTimeSlotId,
              customerId: String(customerId),
              agreementNumber: agrNum,
              inventories: InventoryNumber,
              // coworkerId: "654644",
              appointmentInfo: {
                appointmentType: !props.isReturn
                  ? DeliverytypeExc
                  : decideappointmentType(),
                appointmentSource: AppoinmentSource,
                appointmentDate: startDateExc,
                requiredCoworkers: NumberofCoworkers,
                instructions: InstructionsExc,
              },
            },
          },
        };

        console.log("Complete event reuest", complete);
        setmasterLoader(true);
        Apiresult = await FinishdeliveryStatus(complete);
        /* eslint-disable no-console */
        console.log(Apiresult.data);
        setmasterLoader(false);
        SetSaveTrigger(true);
        if (Apiresult.status == 200) {
          setmasterLoader(false);
          const ApiData = Apiresult.data;
          setNewAppointmentId(ApiData?.appointmentInfo?.appointmentId);
          // SetOpendeliveryconfirmpopup(true);
          const request = {
            storeNumber: window.sessionStorage.getItem("storeNumber"),
            eventInformation: {
              partyId: "33925768",
              agreementId: exchangeAgreementId,
              inventoryIds: ["9999207382277"],
              type: "Delivery",
              eventDate: "11/23/2021",
              eventSource: "Store",
              timeSlot: {
                timeSlotId: "9999100000392",
              },
              eventInstructions: "created customer event",
              requiredCoworkers: "2",
              racdbSourced: true,
              isLoaner: "N",
            },
            address_id: addressId,
          };
          setmasterLoader(true);
          const result = await FinishdeliveryStatus(request);
          setmasterLoader(false);
        }
        // else {
        //   SetErrorpopup(true);
        //   SetDisplayErrorMessage("Something Went Wrong");
        // }
      } catch (e) {
        setmasterLoader(false);
        SetErrorpopup(true);
        SetDisplayErrorMessage("Something Went Wrong");
      }
    }
    return Apiresult;
  };

  // const formatDate = (dates: any) => {
  //   const dateFormat = new Date(dates);
  //   console.log(dateFormat, "<--- Date Format");
  //   console.log(dateFormat.toUTCString(), "UTC");
  //   return (
  //     dateFormat.toUTCString().slice(0, 4) +
  //     dateFormat.toUTCString().slice(7, 12) +
  //     dateFormat.toUTCString().slice(5, 7)
  //   );
  // };
  const formatDate = (dates: any) => {
    const dateFormat = new Date(dates);
    console.log(dateFormat, "<--- Date Format");
    console.log(dateFormat.toUTCString(), "UTC");

    const dayKey = dateFormat.toUTCString().slice(0, 3);
    const monthKey = dateFormat.toUTCString().slice(8, 11);
    const date = dateFormat.toUTCString().slice(5, 7);

    // Translate day and month using t function or mapping dictionary
    const translatedDay = t(`${dayKey}`);
    const translatedMonth = t(`${monthKey}`);

    return `${translatedDay}, ${translatedMonth} ${date}`;
  };

  const buildTimeSlot = (isExchangeReturnFlow?: any) => {
    console.log(isExchangeReturnFlow, "isExchangeReturnFlow in builtime");
    if (isExchangeReturnFlow) {
      if (timeSlotDataExc != undefined && timeSlotDataExc.length > 0) {
        let slotNumbers = 0;
        return timeSlotDataExc.map((objdate: any) => {
          if (
            objdate.TimeSlots != null &&
            objdate.TimeSlots != "" &&
            slotNumbers < timeslotCount
          ) {
            slotNumbers++;
            const formattedDate = formatDate(objdate.Date);
            return (
              // eslint-disable-next-line react/jsx-key
              <Grid
                item
                className={`${classes.agrTimeSlot} ${classes1.agrTimeSlot}`}
              >
                <Typography
                  className={`${classes.semiBold} ${classes.font14} ${classes.MarginDate}`}
                >
                  {formattedDate}
                </Typography>
                <Grid className={classes.agrListGroup}>
                  {timeslotbindExc(objdate, isExchangeReturnFlow)}
                </Grid>
              </Grid>
            );
          }
        });
      } else {
        return (
          <div className={classes.Norecords}>
            <CircularProgress />
          </div>
        );
      }
    } else {
      if (timeSlotData != undefined && timeSlotData.length > 0) {
        let slotNumbers = 0;
        return timeSlotData.map((objdate: any) => {
          if (
            objdate.TimeSlots != null &&
            objdate.TimeSlots != "" &&
            slotNumbers < timeslotCount
          ) {
            slotNumbers++;
            const formattedDate = formatDate(objdate.Date);

            return (
              // eslint-disable-next-line react/jsx-key
              <Grid
                item
                className={`${classes.agrTimeSlot} ${classes1.agrTimeSlot}`}
              >
                <Typography
                  className={`${classes.semiBold} ${classes.font14} ${classes.MarginDate}`}
                >
                  {formattedDate}
                </Typography>
                <Grid className={classes.agrListGroup}>
                  {timeslotbind(objdate)}
                </Grid>
              </Grid>
            );
          }
        });
      } else {
        return (
          <div className={classes.Norecords}>
            <CircularProgress />
          </div>
        );
      }
    }
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const timeslotbind = (objdate: any, isExchangeReturnFlow?: any) => {
    // var itr = 0;
    if (masterLoader) return;
    console.log('I am the One triggered for the OnChange', objdate)

    console.log("enters in the else", isExchangeReturnFlow)

    if (objdate.TimeSlots != undefined) {
      
      return objdate.TimeSlots.map((objtime: any) => {
        // itr += 1;
        const modifiedStarttime = moment(objtime.startTime, "HH:mm:ss").format(
          "LT"
        );
        const modifiedEndtime = moment(objtime.endTime, "HH:mm:ss").format(
          "LT"
        );
        const slicedTimeslot =
          modifiedStarttime.slice(0, 5) +
          modifiedStarttime.slice(8, modifiedStarttime.length);

        let modifiedStarttimeExc;
        let modifiedEndtimeExc;
        let slicedTimeslotExc;
        // inside the condition
        if (isExchangeReturnFlow) {
          modifiedStarttimeExc = moment(objtime.startTime, "HH:mm:ss").format(
            "LT"
          );
          modifiedEndtimeExc = moment(objtime.endTime, "HH:mm:ss").format("LT");
          slicedTimeslotExc =
            modifiedStarttimeExc.slice(0, 5) +
            modifiedStarttimeExc.slice(8, modifiedStarttimeExc.length);
        }
        console.log(slicedTimeslotExc, "slicedTimeslotExcsdfghj");

        const Currently = new Date();
        const todayDate = String(Currently.getDate()).padStart(2, "0");
        const todayMonth = String(Currently.getMonth() + 1).padStart(2, "0"); //January is 0!
        const todayYear = Currently.getFullYear();

        const todaysDate = todayMonth + "/" + todayDate + "/" + todayYear;
        const TodayUpdatedDate = new Date(todaysDate);
        const ObjUpdatedDate = new Date(objdate.Date);
        if (isExchangeReturnFlow) {
          if (
            TodayUpdatedDate == ObjUpdatedDate ||
            TodayUpdatedDate > ObjUpdatedDate
          ) {
            const startTime: any = objtime.startTime;
            const hoursdisplayed = startTime.split(":")[0];
            const minutesdisplayed = startTime.split(":")[1];
            const displayedTime = hoursdisplayed + ":" + minutesdisplayed;
            console.log(displayedTime);

            const Currently = new Date();
            const TimeatPresent = new Date(Currently.getTime());
            const currentHours = TimeatPresent.getHours();
            console.log(currentHours);
            const currentMinutes = TimeatPresent.getMinutes();
            console.log(currentMinutes);
            const Currenttime = currentHours + ":" + currentMinutes;
            console.log(Currenttime);

            if (objtime.status !== "Available") {
              let slotColor = "";

              if (
                exReturnBindtimeslotId !== "" &&
                exReturnBindtimeslotId == objtime.timeSlot &&
                ExBindtimeslotDate !== "" &&
                ExBindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotBusy;
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.currentTimeSlotBooking : classes.currentTimeSlotCanceling}`}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={overrideButtons}
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if (
              todaysDate > objdate.Date ||
              (todaysDate == objdate.Date && displayedTime <= Currenttime)
              // eslint-disable-next-line sonarjs/no-duplicated-branches
            ) {
              let slotColor = "";

              if (
                exReturnBindtimeslotId !== "" &&
                exReturnBindtimeslotId == objtime.timeSlot &&
                ExBindtimeslotDate !== "" &&
                ExBindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotBusy;

              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={slotColor}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc, isExchangeReturnFlow, objtime.id)
                  }                  
                  disabled={overrideButtons}
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if(!FVSConfigurable) {
              let slotColor = "";

              if (
                exReturnBindtimeslotId !== "" &&
                exReturnBindtimeslotId == objtime.timeSlot &&
                ExBindtimeslotDate !== "" &&
                ExBindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                className={`${slotColor} ${objtime.id == currentBtnClass ? classes.currentTimeSlotBooking : classes.currentTimeSlotCanceling}`}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if (FVSConfigurable) {
              let slotColor = '';
              if (
                BindtimeslotId !== '' &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== '' &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              } 
              return (
                //
                <>
                { objtime.helpText ?
                <RACTooltip
                PopperProps={
                  headerPresent
                    ? {
                        style: {
                          marginTop: -100,
                          paddingBottom: 75,
                          paddingLeft: 5, 
                        },
                      }
                    : {}
                }
                title={objtime.helpText}> 
              <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + '-' + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`}

                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                {slicedTimeslot} - {modifiedEndtime} 
                {!isNaN(objtime.total) && overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>              
                </RACTooltip> 
                : 
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + '-' + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`}

                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                {slicedTimeslot} - {modifiedEndtime} 
                {!isNaN(objtime.total) && overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>
            }
                </>
              );
            }
          } else {
            if (objtime.status !== "Available") {
              return (
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={classes.slotBusyPos}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc, isExchangeReturnFlow, objtime.id)
                  }                  
                  disabled={overrideButtons}
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if (!FVSConfigurable) { 
              
              let slotColor = "";
              if (
                exReturnBindtimeslotId !== "" &&
                exReturnBindtimeslotId == objtime.timeSlot &&
                ExBindtimeslotDate !== "" &&
                ExBindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  // value={modifiedtimeExc ? slicetimeExc : slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  // className={modifiedtimeExc ? colourExc : slotColor}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.currentTimeSlotBooking : classes.currentTimeSlotCanceling}`}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if (FVSConfigurable) {
              let slotColor = '';
              if (
                BindtimeslotId !== '' &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== '' &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              }
              return (
                //
                <>
                { objtime.helpText ?
                <RACTooltip
                PopperProps={
                  headerPresent
                    ? {
                        style: {
                          marginTop: -100,
                          paddingBottom: 75,
                          paddingLeft: 5, 
                        },
                      }
                    : {}
                }
                title={objtime.helpText}> 
              <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + '-' + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`}

                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                {slicedTimeslot} - {modifiedEndtime} 
                {!isNaN(objtime.total) && overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>              
                </RACTooltip> 
                : 
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + '-' + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`}

                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                {slicedTimeslot} - {modifiedEndtime} 
                {!isNaN(objtime.total) && overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>
            }
                </>
              );
            }
          } 
        } // end of isExchangeReturnFlow line 5186

        else { // working
          if (
            TodayUpdatedDate == ObjUpdatedDate ||
            TodayUpdatedDate > ObjUpdatedDate
          ) {
            const startTime: any = objtime.startTime;
            const hoursdisplayed = startTime.split(":")[0];
            const minutesdisplayed = startTime.split(":")[1];
            const displayedTime = hoursdisplayed + ":" + minutesdisplayed;
            console.log(displayedTime);

            const Currently = new Date();
            const TimeatPresent = new Date(Currently.getTime());
            const currentHours = TimeatPresent.getHours();
            console.log(currentHours);
            const currentMinutes = TimeatPresent.getMinutes();
            console.log(currentMinutes);
            const Currenttime = currentHours + ":" + currentMinutes;
            console.log(Currenttime);

            if (objtime.status !== "Available") {
              let slotColor = "";

              if (
                BindtimeslotId !== "" &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== "" &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBookedPos;
              } else {
                slotColor = overrideButtons ?
                classes.slotBusyPos : classes.slotAvailablePos;
                
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + "-" + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={slotColor}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={overrideButtons}
                  
                >
                  {slicedTimeslot} - {modifiedEndtime}
                   {!isNaN(objtime.total) && FVSConfigurable && !overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>
              );
            } else if (
              todaysDate > objdate.Date ||
              (todaysDate == objdate.Date && displayedTime <= Currenttime)
              // eslint-disable-next-line sonarjs/no-duplicated-branches
            ) {
              let slotColor = "";

              if (
                BindtimeslotId !== "" &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== "" &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotBusyPos;
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + "-" + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={overrideButtons ? slotColor : classes.slotBusyPos}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={overrideButtons}
                >
                  {slicedTimeslot} - {modifiedEndtime}
                </button>
              );
            } else if (!FVSConfigurable) {
              let slotColor = "";

              if (
                BindtimeslotId !== "" &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== "" &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable; //focus
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + "-" + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={overrideButtons ? slotColor : classes.slotBusyPos}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                  {slicedTimeslot} - {modifiedEndtime}
                </button>
              );
            } else if (FVSConfigurable) {
              let slotColor = '';
              if (
                BindtimeslotId !== '' &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== '' &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              }
              return (
                //
                <>
                { objtime.helpText ?
                <RACTooltip
                PopperProps={
                  headerPresent
                    ? {
                        style: {
                          marginTop: -100,
                          paddingBottom: 75,
                          paddingLeft: 5, 
                        },
                      }
                    : {}
                }
                title={
                  <span style={{ whiteSpace: 'pre-line' }}>
                    {objtime.helpText}
                  </span>
                }> 
              <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + '-' + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={overrideButtons ? 
                            `${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`
                                              : classes.slotBusyPos}
                           
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                {slicedTimeslot} - {modifiedEndtime}
                {!isNaN(objtime.total) && overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>              
                </RACTooltip> 
                : 
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + '-' + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={overrideButtons ? 
                            `${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`
                                              : classes.slotBusyPos}
                         
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                {slicedTimeslot} - {modifiedEndtime} 
                {!isNaN(objtime.total) && overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>
            }
                </>
              );
            }
          }// end of today's column moving on to other days below 
          else { 
            if (objtime.status !== "Available") {
              
                let slotColor = "";

              if (
                BindtimeslotId !== "" &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== "" &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBookedPos;
              } else {
                 slotColor = overrideButtons ?
                classes.slotBusyPos : classes.slotAvailablePos;
              }
 
              return (
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + "-" + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={slotColor}
                    
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }                  
                  disabled={overrideButtons}
                >
                  {slicedTimeslot} - {modifiedEndtime}
                  
                   {!isNaN(objtime.total) && FVSConfigurable && !overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>
              );
            } else if (!FVSConfigurable) {
               // working 
              let slotColor = "";
              if (
                BindtimeslotId !== "" &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== "" &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable; //focus
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + "-" + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={overrideButtons ? slotColor : classes.slotBusyPos }
                  onClick={(e) => {
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id
                    )
                    // setslicetimeExc(slicedTimeslot + "-" + modifiedEndtime)
                    // colourExc = slotColor
                    // setcolourExc(colourExc)
                    // setmodifiedEndtimeExc(true)
                  }                  
                  }
                  disabled={!overrideButtons}
                >
                  {slicedTimeslot} - {modifiedEndtime}
                </button>
              );
            } else if (FVSConfigurable) {
              let slotColor = '';
              if (
                BindtimeslotId !== '' &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== '' &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              }
              return (
                //
                <>
                { objtime.helpText ?
                <RACTooltip
                PopperProps={
                  headerPresent
                    ? {
                        style: {
                          marginTop: -100,
                          paddingBottom: 75,
                          paddingLeft: 5, 
                        },
                      }
                    : {}
                }
                title={
                  <span style={{ whiteSpace: 'pre-line' }}>
                    {objtime.helpText}
                  </span>
                }> 
                  <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + '-' + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={overrideButtons ? 
                            `${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`
                                              : classes.slotBusyPos }
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                {slicedTimeslot} - {modifiedEndtime} 
                {!isNaN(objtime.total) && overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>              
                </RACTooltip> 
                : 
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslot + '-' + modifiedEndtime}
                  id={objtime.timeSlot}
                  className={overrideButtons ? 
                    `${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`
                       : classes.slotBusyPos }

                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttime, modifiedEndtime, isExchangeReturnFlow, objtime.id)
                  }
                  disabled={!overrideButtons}
                >
                {slicedTimeslot} - {modifiedEndtime}
                {!isNaN(objtime.total) && overrideButtons && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>
            }
                </>
              );
            } // end of else if (FVSConfigurable)
          }  // end of else 
        }
      });
      // }
    }
  };

  const timeslotbindExc = (objdate: any, isExchangeReturnFlow?: any) => {
    // var itr = 0;
    if (masterLoader) return;
    console.log('I am the One triggered for the OnChange', objdate)

    console.log("enters in the else", isExchangeReturnFlow)

    if (objdate.TimeSlots != undefined) {
      console.log("entersdfgh")
      return objdate.TimeSlots.map((objtime: any) => {
        // itr += 1;
        // const modifiedStarttime = moment(objtime.startTime, "HH:mm:ss").format(
        //   "LT"
        // );
        // const modifiedEndtime = moment(objtime.endTime, "HH:mm:ss").format(
        //   "LT"
        // );
        // const slicedTimeslot =
        //   modifiedStarttime.slice(0, 5) +
        //   modifiedStarttime.slice(8, modifiedStarttime.length);

        let modifiedStarttimeExc;
        let modifiedEndtimeExc;
        let slicedTimeslotExc;
        // inside the condition
        if (isExchangeReturnFlow) {
          modifiedStarttimeExc = moment(objtime.startTime, "HH:mm:ss").format(
            "LT"
          );
          modifiedEndtimeExc = moment(objtime.endTime, "HH:mm:ss").format("LT");
          slicedTimeslotExc =
            modifiedStarttimeExc.slice(0, 5) +
            modifiedStarttimeExc.slice(8, modifiedStarttimeExc.length);
        }
        console.log(slicedTimeslotExc, "slicedTimeslotExcsdfghj");

        const Currently = new Date();
        const todayDate = String(Currently.getDate()).padStart(2, "0");
        const todayMonth = String(Currently.getMonth() + 1).padStart(2, "0"); //January is 0!
        const todayYear = Currently.getFullYear();

        const todaysDate = todayMonth + "/" + todayDate + "/" + todayYear;
        const TodayUpdatedDate = new Date(todaysDate);
        const ObjUpdatedDate = new Date(objdate.Date);
        if (isExchangeReturnFlow) {
          if (
            TodayUpdatedDate == ObjUpdatedDate ||
            TodayUpdatedDate > ObjUpdatedDate
          ) {
            const startTime: any = objtime.startTime;
            const hoursdisplayed = startTime.split(":")[0];
            const minutesdisplayed = startTime.split(":")[1];
            const displayedTime = hoursdisplayed + ":" + minutesdisplayed;
            console.log(displayedTime);

            const Currently = new Date();
            const TimeatPresent = new Date(Currently.getTime());
            const currentHours = TimeatPresent.getHours();
            console.log(currentHours);
            const currentMinutes = TimeatPresent.getMinutes();
            console.log(currentMinutes);
            const Currenttime = currentHours + ":" + currentMinutes;
            console.log(Currenttime);

            if (objtime.status !== "Available") {
              let slotColor = "";

              if (
                exReturnBindtimeslotId !== "" &&
                exReturnBindtimeslotId == objtime.timeSlot &&
                ExBindtimeslotDate !== "" &&
                ExBindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotBusy;
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={slotColor}
                  onClick={(e) =>
                      getslotdetails(
                      e,
                      modifiedStarttimeExc,
                      modifiedEndtimeExc,
                      isExchangeReturnFlow
                    )
                  }
                  disabled={true}
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if (
              todaysDate > objdate.Date ||
              (todaysDate == objdate.Date && displayedTime <= Currenttime)
              // eslint-disable-next-line sonarjs/no-duplicated-branches
            ) {
              let slotColor = "";

              if (
                exReturnBindtimeslotId !== "" &&
                exReturnBindtimeslotId == objtime.timeSlot &&
                ExBindtimeslotDate !== "" &&
                ExBindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotBusy;

              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={slotColor}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc)
                  }
                  disabled={true}
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if (!FVSConfigurable) {
              let slotColor = "";

              if (
                exReturnBindtimeslotId !== "" &&
                exReturnBindtimeslotId == objtime.timeSlot &&
                ExBindtimeslotDate !== "" &&
                ExBindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={slotColor}
                  onClick={(e) =>
                    getslotdetails(
                      e,
                      modifiedStarttimeExc,
                      modifiedEndtimeExc,
                      isExchangeReturnFlow
                    )
                  }
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if (FVSConfigurable) { 
              let slotColor = '';
              if (
                BindtimeslotId !== '' &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== '' &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              }
              return (
                //
                <>
                { objtime.helpText ?
                <RACTooltip
                PopperProps={
                  headerPresent
                    ? {
                        style: {
                          marginTop: -100,
                          paddingBottom: 75,
                          paddingLeft: 5, 
                        },
                      }
                    : {}
                }
                  title={
                  <span style={{ whiteSpace: 'pre-line' }}>
                    {objtime.helpText}
                  </span>
                }> 
              <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + '-' + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`}

                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc, isExchangeReturnFlow, objtime.id)
                  }
                >
                {slicedTimeslotExc} - {modifiedEndtimeExc} 
                {!isNaN(objtime.total) && 
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>              
                </RACTooltip> 
                : 
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + '-' + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`}

                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc, isExchangeReturnFlow, objtime.id)
                  }
                >
                {slicedTimeslotExc} - {modifiedEndtimeExc} 
                {!isNaN(objtime.total) &&
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>
            }
                </>
              );
            }
          } else {
            if (objtime.status !== "Available") {
              return (
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={classes.slotBusy}
                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc)
                  }
                  disabled={true}
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if (!FVSConfigurable) {
              console.log("enter thxcvbncvbn", slicedTimeslotExc);
              let slotColor = "";
              if (
                exReturnBindtimeslotId !== "" &&
                exReturnBindtimeslotId == objtime.timeSlot &&
                ExBindtimeslotDate !== "" &&
                ExBindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              }
              return (
                //
                <button
                  type="button"
                  name={objdate.Date}
                  // value={modifiedtimeExc ? slicetimeExc : slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  value={slicedTimeslotExc + "-" + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  // className={modifiedtimeExc ? colourExc : slotColor}
                  className={slotColor}
                  onClick={(e) =>
                    getslotdetails(
                      e,
                      modifiedStarttimeExc,
                      modifiedEndtimeExc,
                      isExchangeReturnFlow
                    )
                  }
                >
                  {slicedTimeslotExc} - {modifiedEndtimeExc}
                </button>
              );
            } else if (FVSConfigurable) {
              let slotColor = '';
              if (
                BindtimeslotId !== '' &&
                BindtimeslotId == objtime.timeSlot &&
                BindtimeslotDate !== '' &&
                BindtimeslotDate == objdate.Date
              ) {
                slotColor = classes.slotBooked;
              } else {
                slotColor = classes.slotAvailable;
              }
              return (
                //
                <>
                { objtime.helpText ?
                <RACTooltip
                PopperProps={
                  headerPresent
                    ? {
                        style: {
                          marginTop: -100,
                          paddingBottom: 75,
                          paddingLeft: 5, 
                        },
                      }
                    : {}
                }
                title={
                  <span style={{ whiteSpace: 'pre-line' }}>
                    {objtime.helpText}
                  </span>
                }> 
              <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + '-' + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`}

                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc, isExchangeReturnFlow, objtime.id)
                  }
                >
                {slicedTimeslotExc} - {modifiedEndtimeExc} 
                {!isNaN(objtime.total) &&
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>              
                </RACTooltip> 
                : 
                <button
                  type="button"
                  name={objdate.Date}
                  value={slicedTimeslotExc + '-' + modifiedEndtimeExc}
                  id={objtime.timeSlot}
                  className={`${slotColor} ${objtime.id == currentBtnClass ? classes.floatcurrentTimeSlotBooking : classes.floatcurrentTimeSlotCanceling}`}

                  onClick={(e) =>
                    getslotdetails(e, modifiedStarttimeExc, modifiedEndtimeExc, isExchangeReturnFlow, objtime.id)
                  }
                >
                {slicedTimeslotExc} - {modifiedEndtimeExc} 
                {!isNaN(objtime.total) &&
                              
                <span  style={{
                      position: 'absolute',
                      bottom: '4px',
                      left: '4px',
                      background: '#ff4757',
                      color: 'white',
                      fontSize: '0.75rem',
                      padding: '2px 6px',
                      borderRadius: '6px',
                      pointerEvents: 'none', 
                    }}
                  >{objtime.total}</span>
                  }
                </button>
            }
                </>
              );
            }
          }
        }

        // else { // working
        //   // debugger
        //   if (
        //     TodayUpdatedDate == ObjUpdatedDate ||
        //     TodayUpdatedDate > ObjUpdatedDate
        //   ) {
        //     const startTime: any = objtime.startTime;
        //     const hoursdisplayed = startTime.split(":")[0];
        //     const minutesdisplayed = startTime.split(":")[1];
        //     const displayedTime = hoursdisplayed + ":" + minutesdisplayed;
        //     console.log(displayedTime);

        //     const Currently = new Date();
        //     const TimeatPresent = new Date(Currently.getTime());
        //     const currentHours = TimeatPresent.getHours();
        //     console.log(currentHours);
        //     const currentMinutes = TimeatPresent.getMinutes();
        //     console.log(currentMinutes);
        //     const Currenttime = currentHours + ":" + currentMinutes;
        //     console.log(Currenttime);

        //     if (objtime.status !== "Available") {
        //       let slotColor = "";

        //       if (
        //         BindtimeslotId !== "" &&
        //         BindtimeslotId == objtime.timeSlot &&
        //         BindtimeslotDate !== "" &&
        //         BindtimeslotDate == objdate.Date
        //       ) {
        //         slotColor = classes.slotBooked;
        //       } else {
        //         slotColor = classes.slotBusy;
        //       }
        //       return (
        //         //
        //         <button
        //           type="button"
        //           name={objdate.Date}
        //           value={slicedTimeslot + "-" + modifiedEndtime}
        //           id={objtime.timeSlot}
        //           className={slotColor}
        //           onClick={(e) =>
        //             getslotdetails(e, modifiedStarttime, modifiedEndtime)
        //           }
        //           disabled={true}
        //         >
        //           {slicedTimeslot} - {modifiedEndtime}
        //         </button>
        //       );
        //     } else if (
        //       todaysDate > objdate.Date ||
        //       (todaysDate == objdate.Date && displayedTime <= Currenttime)
        //       // eslint-disable-next-line sonarjs/no-duplicated-branches
        //     ) {
        //       let slotColor = "";

        //       if (
        //         BindtimeslotId !== "" &&
        //         BindtimeslotId == objtime.timeSlot &&
        //         BindtimeslotDate !== "" &&
        //         BindtimeslotDate == objdate.Date
        //       ) {
        //         slotColor = classes.slotBooked;
        //       } else {
        //         slotColor = classes.slotBusy;
        //       }
        //       return (
        //         //
        //         <button
        //           type="button"
        //           name={objdate.Date}
        //           value={slicedTimeslot + "-" + modifiedEndtime}
        //           id={objtime.timeSlot}
        //           className={slotColor}
        //           onClick={(e) =>
        //             getslotdetails(e, modifiedStarttime, modifiedEndtime)
        //           }
        //           disabled={true}
        //         >
        //           {slicedTimeslot} - {modifiedEndtime}
        //         </button>
        //       );
        //     } else {
        //       let slotColor = "";

        //       if (
        //         BindtimeslotId !== "" &&
        //         BindtimeslotId == objtime.timeSlot &&
        //         BindtimeslotDate !== "" &&
        //         BindtimeslotDate == objdate.Date
        //       ) {
        //         slotColor = classes.slotBooked;
        //       } else {
        //         slotColor = classes.slotAvailable;
        //       }
        //       return (
        //         //
        //         <button
        //           type="button"
        //           name={objdate.Date}
        //           value={slicedTimeslot + "-" + modifiedEndtime}
        //           id={objtime.timeSlot}
        //           className={slotColor}
        //           onClick={(e) =>
        //             getslotdetails(e, modifiedStarttime, modifiedEndtime)
        //           }
        //         >
        //           {slicedTimeslot} - {modifiedEndtime}
        //         </button>
        //       );
        //     }
        //   }
        //   else {
        //     if (objtime.status !== "Available") {
        //       return (
        //         <button
        //           type="button"
        //           name={objdate.Date}
        //           value={slicedTimeslot + "-" + modifiedEndtime}
        //           id={objtime.timeSlot}
        //           className={classes.slotBusy}
        //           onClick={(e) =>
        //             getslotdetails(e, modifiedStarttime, modifiedEndtime)
        //           }
        //           disabled={true}
        //         >
        //           {slicedTimeslot} - {modifiedEndtime}
        //         </button>
        //       );
        //     } else { // working
        //       let slotColor = "";
        //       if (
        //         BindtimeslotId !== "" &&
        //         BindtimeslotId == objtime.timeSlot &&
        //         BindtimeslotDate !== "" &&
        //         BindtimeslotDate == objdate.Date
        //       ) {
        //         slotColor = classes.slotBooked;
        //       } else {
        //         slotColor = classes.slotAvailable;
        //       }
        //       return (
        //         //
        //         <button
        //           type="button"
        //           name={objdate.Date}
        //           value={slicedTimeslot + "-" + modifiedEndtime}
        //           id={objtime.timeSlot}
        //           className={slotColor}
        //           onClick={(e) => {
        //             getslotdetails(e, modifiedStarttime, modifiedEndtime)
        //             // setslicetimeExc(slicedTimeslot + "-" + modifiedEndtime)
        //             // colourExc = slotColor
        //             // setcolourExc(colourExc)
        //             // setmodifiedEndtimeExc(true)
        //           }
        //           }
        //         >
        //           {slicedTimeslot} - {modifiedEndtime}
        //         </button>
        //       );
        //     }
        //   }
        // }
      });
      // }
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const Addressselect = () => {
    return (
      <div>
        {masterLoader ? (
          <Grid
            style={{
              position: "fixed",
              background: "#f7f5f5",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              opacity: 0.6,
              zIndex: 1050,
              textAlign: "center",
              margin: "0px 0px",
            }}
          >
            <Grid
              style={{
                display: "block",
                position: "fixed",
                zIndex: 9999999,
                top: "40%",
                right: "50%",
              }}
            >
              <CircularProgress />
            </Grid>
          </Grid>
        ) : null}
        <Grid className={classes.fixTableHead}>
          <RACTable
            // renderTableHead={RenderTable}
            renderTableContent={featureFlagDetails.MXAddressValidation == 1 ? RenderMXTableBody : RenderTableBody}
          />
        </Grid>

        <Grid item md={12} className={classes.modalFooter}>
          <RACButton
            variant="outlined"
            color="primary"
            className={classes.spacerMR4}
            onClick={cancelbtn}
          >
            {t("Cancel")}
          </RACButton>

          <RACButton
            variant="contained"
            color="primary"
            // disabled={enableOkpopup}
            onClick={Okpopup}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const CoworkerOptionsArray = () => {
    console.log("enters the options", coWorkerRequiredArray);
    if (coWorkerRequiredArray !== undefined) {
      console.log("enters the options if");

      return coWorkerRequiredArray.map((entry: any) => {
        const some: any = entry.toString();
        if (entry == "Select") {
          return { label: entry, value: "1" };
        } else {
          return { label: entry, value: some };
        }
      });
    } else {
      console.log("enters the options else");
      return [{ label: t("Select"), value: "0" }];
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const Timebind = (event: any, exchangeReturn?: any) => {
    if (exchangeReturn) {
      setExReturnTime(event.target.value);
    } else {
      SetTime(event.target.value);
    }
    SetSaveTrigger(false);
  };

  function* numCount() {
    let count = 99;
    while (true) yield count++; /*  ww w  .  j av a2s.co  m*/
  }

  const generateHelpText = (value:any) :string | undefined => {
    let out = '';

    for ( const oneEventRefCode of Object.keys(EVENT_TYPES)) {
      if ( value[oneEventRefCode] ) {
        out = out + value[oneEventRefCode] + ' ' + getEventType(oneEventRefCode) + '\n';
      }

    }

    
    if ( out ) return out;

    return undefined;
  }

  const irt = numCount();

  // const AddressgridHead = [
  //   {
  //     displayName: 'Address Line 1*',
  //   },
  //   {
  //     displayName: 'Apt/Unit #',
  //   },
  //   {
  //     displayName: 'Zip*',
  //   },
  //   {
  //     displayName: 'City*',
  //   },
  //   {
  //     displayName: 'State*',
  //   },
  // ];

  // const AddressgridBody =[
  //   {
  //     displayAddress:
  //   }
  // ]

  // const RenderTable = () => (
  //   <>
  //     {AddressgridHead.map((value, index) => {
  //       return <RACTableCell key={index}>{value.displayName}</RACTableCell>;
  //     })}
  //   </>
  // );

  const RenderTableBody = () => (
    <>
      <>
        <RACTableRow>
          <RACTableCell className={classes.AddressPopup}>
            {t("Address Line 1")}{" "}
            <Box component="span" className={classes.Mandatory}>
              {" "}
              *{" "}
            </Box>
          </RACTableCell>

          <RACTableCell className={classes.AddressPopup}>
            {t("Apt/Unit #")}
          </RACTableCell>
          <RACTableCell className={classes.AddressPopup}>
            {t("Zip")}{" "}
            <Box component="span" className={classes.Mandatory}>
              {" "}
              *{" "}
            </Box>
          </RACTableCell>
          <RACTableCell className={classes.AddressPopup}>
            {t("City")}{" "}
            <Box component="span" className={classes.Mandatory}>
              {" "}
              *{" "}
            </Box>
          </RACTableCell>
          <RACTableCell className={classes.AddressPopup}>
            {t("State")}{" "}
            <Box component="span" className={classes.Mandatory}>
              {" "}
              *{" "}
            </Box>
          </RACTableCell>
        </RACTableRow>
      </>
      <RACTableRow>
        <RACTableCell>
          <RACTextbox
            // type="text"
            value={Line1Popup}
            maxlength={30}
            name="addressLine1"
            OnChange={(e) => handleChange(e)}
            disabled={InputGrid}
            isCurrency={false}
          />
        </RACTableCell>
        <RACTableCell>
          <RACTextbox
            type="text"
            value={Line2Popup}
            maxlength={30}
            name="addressLine2"
            OnChange={() => handleChange(event)}
            disabled={InputGrid}
            isCurrency={false}
          />
        </RACTableCell>

        <RACTableCell>
          <RACTextbox
            // type="phoneno"
            maxlength={10}
            value={ZipPopup}
            name="zip"
            OnChange={(e) => handleChange(e)}
            disabled={InputGrid}
            isCurrency={false}
          />
        </RACTableCell>

        <RACTableCell>
          <RACTextbox
            type="text"
            value={CityPopup}
            maxlength={30}
            name="city"
            OnChange={() => handleChange(event)}
            disabled={InputGrid}
            isCurrency={false}
          />
        </RACTableCell>

        <RACTableCell>
          <RACSelect
            options={Loadstate()}
            loading={StateconditionLoader}
            // defaultValue={StatePopup}
            defaultValue={StatePopup !== "" ? StatePopup : "Select"}
            onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
              if (e.target.value == "Select") {
                SetStatePopup("");
              } else {
                SetStatePopup(e.target.value);
              }
            }}
            isDisabled={InputGrid}
            {...(Statedrop.length == 1 &&
              !conditionLoader && {
                // eslint-disable-next-line sonarjs/no-duplicate-string
                errorMessage: t("Unable to fetch Data"),
              })}
          />
        </RACTableCell>
        <RACTableCell>
          <RACButton onClick={() => addGridRow()} disabled={enableadd}>
            <Addimage />
          </RACButton>
        </RACTableCell>
      </RACTableRow>
      {bindGrid()}
    </>
  );

  const RenderMXTableBody = () => {
    const stateDropdown = JSON.parse(JSON.stringify(Statedrop));
    stateDropdown.shift();
    return (
      <>
        <>
          <RACTableRow>
            <RACTableCell className={classes.AddressPopup}>
              {t("Street")}{" "}
              <Box component="span" className={classes.Mandatory}>
                {" "}
                *{" "}
              </Box>
            </RACTableCell>

            <RACTableCell className={classes.AddressPopup}>
              {t("Exterior Number")}
              <Box component="span" className={classes.Mandatory}>
                {" "}
                *{" "}
              </Box>
            </RACTableCell>
            <RACTableCell className={classes.AddressPopup}>
              {t("Interior Number")}
            </RACTableCell>
            <RACTableCell className={classes.AddressPopup}>
              {t("Suburb")}
              <Box component="span" className={classes.Mandatory}>
                {" "}
                *{" "}
              </Box>
            </RACTableCell>
            <RACTableCell className={classes.AddressPopup}>
              {t("Zip Code")}{" "}
              <Box component="span" className={classes.Mandatory}>
                {" "}
                *{" "}
              </Box>
            </RACTableCell>
            <RACTableCell className={classes.AddressPopup}>
              {t("City")}{" "}
              <Box component="span" className={classes.Mandatory}>
                {" "}
                *{" "}
              </Box>
            </RACTableCell>
            <RACTableCell className={classes.AddressPopup}>
              {t("State")}{" "}
              <Box component="span" className={classes.Mandatory}>
                {" "}
                *{" "}
              </Box>
            </RACTableCell>
          </RACTableRow>
        </>
        <RACTableRow>
          <MXAddressComp
            address={address} setAddress={setAddress} googleAddressEnabled={canEnableGoogleValdation} stateOpt={stateDropdown} canEdit={false} processSuggestion={suggestAddress} setLoader={setmasterLoader} setActionCompeleted={setActionCompeleted} setCantProcessAddress={() => {
              setActionCompeleted(false);
              setSuggestAddress(false);
            }}
          />
          <RACTableCell>
            <RACButton onClick={() => {
              setActionCompeleted(false)
              setSuggestAddress(true)
              }} disabled={(address.street && address.exteriorNum && address.suburb && address.state && address.zipcode && address.city) ? false : true}>
              <Addimage />
            </RACButton>
          </RACTableCell>
        </RACTableRow>
        {bindMXGrid()}
      </>
    )
  };
  // eslint-disable-next-line sonarjs/cognitive-complexity
  const addressDoctorPopup = () => {
    return (
      <Grid
        item
        md={12}
        id="confirmduedate"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        {masterLoader ? (
          <Grid
            style={{
              position: "fixed",
              background: "#f7f5f5",
              width: "100%",
              height: "100%",
              top: 0,
              left: 0,
              opacity: 0.6,
              zIndex: 1050,
              textAlign: "center",
              margin: "0px 0px",
            }}
          >
            <Grid
              style={{
                display: "block",
                position: "fixed",
                zIndex: 9999999,
                top: "40%",
                right: "50%",
              }}
            >
              <CircularProgress />
            </Grid>
          </Grid>
        ) : SuggestedAddress == undefined ? (
          <React.Fragment>
            <Typography className={classes.RACPopupMsg}>
              {addressErrorMsg}
            </Typography>
            <Grid
              item
              md={12}
              className={`${classes.textCenter} ${classes.spacerMT2}`}
            >
              <RACButton
                variant="contained"
                color="primary"
                onClick={() => {
                  continueclick("ENT");
                }}
              >
                {t("Ok")}
              </RACButton>
            </Grid>
            {/* )} */}
          </React.Fragment>
        ) : (
          <Grid item md={12} className={classes.spacerPX2}>
            <Typography className={classes.RACPopupMsg}>
              {t("Entered address is not located")}
            </Typography>
            <Grid item md={12}>
              <Typography className={classes.RACPopupMsg}>
                {t("Suggested Addresses")}
              </Typography>
              <div className={classes.validateCheck}>
                <RACRadio
                  id="inlineRadio1"
                  name="inlineRadioOptions"
                  checked={defaultSuggestedAddress == "SUG" ? true : false}
                  onClick={() => RadioBtnclick("SUG")}
                  value={"SUG"}
                />
                <Typography variant="caption" className={classes.RACPopupMsg}>
                  {SuggestedAddress !== undefined &&
                  SuggestedAddress !== null &&
                  SuggestedAddress.Addresses !== null &&
                  // SuggestedAddress.value.Addresses !== null &&
                  SuggestedAddress.Addresses.StreetAddress !== undefined
                    ? `${SuggestedAddress.Addresses.StreetAddress},`
                    : ""}
                  {SuggestedAddress !== undefined &&
                  SuggestedAddress !== null &&
                  // SuggestedAddress.value !== null &&
                  SuggestedAddress.Addresses !== null &&
                  SuggestedAddress.Addresses.City !== undefined
                    ? `${SuggestedAddress.Addresses.City},`
                    : ""}
                  {SuggestedAddress !== undefined &&
                  SuggestedAddress !== null &&
                  // SuggestedAddress.value !== null &&
                  SuggestedAddress.Addresses !== null &&
                  SuggestedAddress.Addresses.StateProvince !== undefined
                    ? `${SuggestedAddress.Addresses.StateProvince},`
                    : ""}
                  {SuggestedAddress !== undefined &&
                  SuggestedAddress !== null &&
                  // SuggestedAddress.value !== null &&
                  SuggestedAddress.Addresses !== null &&
                  SuggestedAddress.Addresses.PostalCode !== undefined
                    ? `${SuggestedAddress.Addresses.PostalCode}`
                    : ""}
                </Typography>
              </div>
            </Grid>
            <Grid item md={12}>
              <Typography className={classes.RACPopupMsg}>
                {t("Entered Address")}
              </Typography>
              <div className={classes.validateCheck}>
                <RACRadio
                  id="inlineRadio2"
                  name="inlineRadioOptions"
                  checked={defaultSuggestedAddress == "ENT" ? true : false}
                  onClick={() => RadioBtnclick("ENT")}
                  value={"ENT"}
                />
                {Line2Popup != "" ? (
                  <Typography variant="caption" className={classes.RACPopupMsg}>
                    {Line1Popup}, {Line2Popup ? Line2Popup : ""}, {CityPopup},{" "}
                    {StatePopup}, {ZipPopup}
                  </Typography>
                ) : (
                  <Typography variant="caption" className={classes.RACPopupMsg}>
                    {Line1Popup}, {CityPopup}, {StatePopup}, {ZipPopup}
                  </Typography>
                )}
              </div>
            </Grid>
            <Grid container className={classes.dInherit}>
              <Grid className={classes.floatLeft}>
                <RACButton
                  variant="outlined"
                  color="primary"
                  onClick={() => setValidateIsOpen(false)}
                >
                  {t("Cancel")}
                </RACButton>
              </Grid>
              <Grid className={classes.floatRight}>
                <RACButton
                  variant="contained"
                  color="primary"
                  className={classes.spacerMR4}
                  onClick={() => continueclick("ENT")}
                  disabled={BtnIsdisabled1}
                >
                  {t("Override")}
                </RACButton>
                <RACButton
                  variant="contained"
                  color="primary"
                  disabled={BtnIsdisabled2}
                  onClick={() => continueclick("SUG")}
                >
                  {t("Continue")}
                </RACButton>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    );
  };

  const errorpopup = () => {
    return (
      <div
        id="success"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid item md={12} className={classes.textCenter}>
          <Alertimage></Alertimage>
          <Typography className={classes.my2}>
            {t(DisplayErrorMessage)}
          </Typography>
        </Grid>

        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            variant="contained"
            color="primary"
            isRounded={false}
            onClick={() => CloseErrorPopup()}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const DeliveryConfirmPopupOpen = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Successimage></Successimage>
          <Typography className={classes.mt3}>
            {t("Delivery Scheduled Successfully.")}
          </Typography>
          {storepickupMsg && (
            <>
              {" "}
              <br />
              <span>{t("The maximum of")} </span>{" "}
              <span style={{ color: "red", textDecoration: "underline" }}>
                &lt;4 &gt;{" "}
              </span>
              <span>
                {" "}
                {t(
                  "allowed events has been reached for the timeslot selected. Store pick-ups for stores"
                )}{" "}
              </span>
              <span style={{ color: "red", textDecoration: "underline" }}>
                &lt;{storepickupMsg}&gt;
              </span>
              <span>
                {" "}
                {t(
                  "have not been auto created. You will need to manually create an event for each in a timeslot before the current timeslot you just selected."
                )}
              </span>
            </>
          )}
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={DeliveryScheduled}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const DeliveryConfirmPopupOpenMx = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Successimage />
          <Typography className={classes.mt3}>
            {t("Pickup failed but Delivery succeeded.")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={DeliveryScheduled}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  
  const DeliveryReturnConfirmPopupOpen = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Successimage></Successimage>
          <Typography className={classes.mt3}>
            {t("Delivery and Return Scheduled Successfully.")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={DeliveryScheduled}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const PickupConfirmPopupOpen = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Successimage></Successimage>
          <Typography className={classes.mt3}>
            {t("Pickup Scheduled Successfully.")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={DeliveryScheduled}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  // const BookedtimeSlotpopup = () => {
  //   return (
  //     <div
  //       id="success"
  //       data-bs-backdrop="static"
  //       data-bs-keyboard="false"
  //       aria-hidden="true"
  //     >
  //       <Grid item md={12} className={classes.textCenter}>
  //         <Alertimage></Alertimage>
  //         <Typography className={classes.my2}>
  //           Selected Slot is Already Booked. Please Choose a different Time
  //         </Typography>
  //       </Grid>

  //       <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
  //         <RACButton
  //           variant="contained"
  //           color="primary"
  //           isRounded={false}
  //           onClick={() => SetOpenTimeslotbookedPopup(false)}
  //         >
  //           Ok
  //         </RACButton>
  //       </Grid>
  //     </div>
  //   );
  // };

  const ReturnDelivery = async () => {
    setmasterLoader(true);
    const response = await getAgreementDelivery(agreementId, appointmentId);
    if (response.status == 200) {
      setmasterLoader(false);
      const result = await GetDeliveryInformationMapper(
        viewAgrData?.data,
        response.data
      );
      console.log("ReturnDeliveryResult", result);
      setdeliveryMethodData(result);
      //setdeliveryMethodData(response.data);
      RescheduledDelivery();
    }
  };
  const DeliveryScheduled = () => {
    SetOpendeliveryconfirmpopup(false);
    SetOpenreturnconfirmpopup(false);
    if (
      props !== undefined &&
      props.isDeliveryReschedule !== undefined &&
      props.isDeliveryReschedule.deliveryrescheduling != undefined &&
      props.isDeliveryReschedule.deliveryrescheduling === true &&
      props.isReturn == true
    ) {
      SetOpendeliveryconfirmpopup(false);
      SetOpenreturnconfirmpopup(false);

      //RescheduledDelivery();
      window.location.reload();
    } else if (
      props !== undefined &&
      props.isDeliveryReschedule !== undefined &&
      props.isDeliveryReschedule.deliveryrescheduling != undefined &&
      props.isDeliveryReschedule.deliveryrescheduling === true
    ) {
      SetOpendeliveryconfirmpopup(false);
      SetOpenreturnconfirmpopup(false);

      ReturnDelivery();
    } else if (props.isReturn === true) {
      console.log("isDeliveryReschedulkkkkkkk");
      SetOpendeliveryconfirmpopup(false);
      SetOpenreturnconfirmpopup(false);
    } else {
      history.push({
        pathname: `/dashboard`,
      });
      setBindtimeslotId("");
      SetExReturnBindtimeslotId("");
      // BindtimeslotId = '';
      BindtimeslotDate = "";
      ExBindtimeslotDate = "";
    }
  };

  const RescheduledDelivery = () => {
    props.rescheduleDatas({ data: true });
  };

  const CloseErrorPopup = () => {
    SetErrorpopup(false);
    if(mxDeliveryKey){
      SetErrorpopupMsg(false);

    }
  };

  const PreviousbuttonClick = () => {
    if (redirectOrigin === AMOrigin) {
      history.push({
        pathname: `${AppRoute.AMCustomer}/${customerId}`,
      });
      return;
    }
    history.push({
      pathname: `/agreement/rental/details/${customerId}/${agreementId}`,
    });

    // communicate to Routes that URL has changed
    const navEvent = new PopStateEvent("popstate");
    window.dispatchEvent(navEvent);
  };

  const formatPhone = (input: any) => {
    const cleaned = ("" + input).replace(/\D/g, "");
    //This is raw data to pass on props
    const PhoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return cleaned.replace(PhoneRegex, "($1) $2-$3");
  };
  function ValidateEmail(inputText: any) {
    // eslint-disable-next-line no-useless-escape
    const mailformat = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    return mailformat.test(inputText);
  }
  const welcomeValidateOnChange = (e: any) => {
    if (e.target.name == "phoneno") {
      const cleaned = ("" + e.target.value).replace(/\D/g, "");
      console.log("cleaned", cleaned.length);
      if (cleaned.length <= 10) {
        console.log("njnjnjn");

        const PhoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        const phoneFormat = "($1) $2-$3";
        const temp = cleaned.replace(PhoneRegex, phoneFormat);
        setphoneNo(temp);
        setphoneErrMsg("");
        temp == "" || temp == undefined ? setphoneErrMsg("") : null;
      }
    } else if (e.target.name == "Email") {
      if (e.target.value == "") {
        //setemailErrMsg(true)
        setemailText(e.target.value);
        // setwelcomeEnable(true);
      } else {
        if (!ValidateEmail(e.target.value)) {
          setemailErrMsg("Please enter valid Email");
          setwelcomeEnable(true);
          setemailText(e.target.value);
        } else {
          setwelcomeEnable(false);
          setemailErrMsg("");
          setemailText(e.target.value);
        }

        // setwelcomeEnable(false)
      }
    }
  };
  const resumeSuccessPopup = () => {
    return (
      <div>
        <Grid item md={12} className={globalStyle.textCenter}>
          <Successimage></Successimage>
          <Typography
            className={`${globalStyle.agrDeliveryReceiptText} ${globalStyle.semiBold}`}
          >
            {t("Welcome video sent")}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${globalStyle.py4} ${globalStyle.textCenter}`}
        >
          <RACButton
            className={globalStyle.mx1}
            variant="contained"
            color="primary"
            onClick={() => setResendsuccess(false)}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  //Return Methods
  const ReturnChange = () => {
    console.log("hhihh", viewAgrData?.data);
    if (viewAgrData?.data) {
      const AgrData = viewAgrData?.data;
      if (AgrData?.agreementWorkflow?.isDeliveryCompleted == 0) {
        if (
          AgrData?.agreementWorkflow?.isInitialPaymentPaid == 1 &&
          AgrData?.agreementInformation?.isLastReceiptReversed == 1
        ) {
          SetReturnDeliveryCompleted(false);
          setSOTwoFactorReturnEnabled(true);
        } else {
          SetReturnDeliveryCompleted(true);
        }
      } else {
        setSOTwoFactorReturnEnabled(true);
        SetReturnDeliveryCompleted(false);
      }
    }
  };
  const SOTwoFactorReturnCompleted = (e) => {
    if (e) {
      setreturnbtnRdn(true);
      setconfirmFlow(false);
    }
    // history.push({
    //   pathname:`/agreement/info/details/${customerId}/${agreementId}?type=REV`
    // })
    //     // communicate to Routes that URL has changed
    //     const navEvent = new PopStateEvent('popstate');
    //     window.dispatchEvent(navEvent);
  };
  const ReversePaymentInfoPopContent = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Typography
            className={`${classes.agrDeliveryReceiptText} ${classes.semiBold}`}
          >
            {t("Please reverse the payment to return the agreement?")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="outlined"
            color="secondary"
            onClick={() => {
              SetReturnDeliveryCompleted(false);
            }}
          >
            {t("Cancel")}
          </RACButton>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              SetReturnDeliveryCompleted(false);
              setReverseConfirmation(true);
            }}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const ReversePaymentConfirmationContent = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Typography
            className={`${classes.agrDeliveryReceiptText} ${classes.semiBold}`}
          >
            {t("Do you want to reverse the payment?")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="outlined"
            color="secondary"
            onClick={() => {
              setReverseConfirmation(false);
            }}
          >
            {t("No")}
          </RACButton>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setReverseConfirmation(false);
              history.push({
                pathname: `/payment1/reversepayment/${customerId}`,
                search: `?agreementId=${agreementId}`,
              });
            }}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const ResendVideoFinishClick = async () => {
    if (phoneNo.length <= 9 && !sendEmail) {
      if (phoneNo == "") {
        setphoneErrMsg(t("Please enter phone number"));
      } else {
        setphoneErrMsg(t("Please enter valid phone number"));
      }
    } else if (emailText == "" && sendEmail) {
      setemailErrMsg(t("Please enter email"));
    } else {
      setphoneErrMsg("");
      setemailErrMsg("");
      setResendVopen(false);
      console.log("emailTextojjkj", emailText);
      console.log("phoneNojkjkj", phoneNo);
      const refCode = sendEmail ? "SSKYES" : "SSKYTS";
      const payload = {
        customerId: customerId,
        agreementId: agreementId,
        emailId: emailText,
        phoneNumber: phoneNo?.replace(/\D/g, ""),
        isSendMail: true,
        sendEmailType: refCode,
        firstName: customer?.firstName ? customer.firstName : '',
        lastName: customer?.lastName ? customer.lastName : ''
      };
      setmasterLoader(true);
      const response = await sendEPO(payload);
      console.log("responsesendEPO", response);

      if (response.statusCode == 200) {
        setmasterLoader(false);
        setResendsuccess(true);
        // const agrInfoData = agreementInfoData
        // agrInfoData.agreementWorkflow.isWelcomeVideoSent ='1';
        // agrInfoData.welcomeVideoInfo.activityDate = moment(new Date()).format('DD/MM/YYYY');
        // agrInfoData.welcomeVideoInfo.activityDesc = `Text was sent to ${sendEmail?emailText:phoneNo}`;
        // agrInfoData.welcomeVideoInfo.activityRefCode = refCode;

        // setAgreementInfoData(agrInfoData)
      }
    }

    // if(emailText ==''){
    //   setemailErrMsg(true);
    // }
    // temp =='' || temp ==undefined ?setwelcomeEnable(true):setwelcomeEnable(false)
  };
  const sendAgreementPopup = () => {
    return (
      <Grid className={globalStyle.p3}>
        <Grid container>
          <Grid item md={12} className={globalStyle.mb3}>
            <Typography
              component="label"
              className={`${globalStyle.formLabel} ${globalStyle.w100} ${globalStyle.fontBold}`}
            >
              {t("How do you want the welcome video to be shared?")}
            </Typography>
          </Grid>
          <Grid item md={12} className={globalStyle.mb3}>
            <RACRadio
              value={sendEmail}
              checked={sendEmail}
              onChange={() => {
                setsendEmail(true);
                settextMsg(false);
              }}
              label={t("Email")}
            />
            <RACRadio
              value={textMsg}
              checked={textMsg}
              onChange={() => {
                setsendEmail(false);
                settextMsg(true);
                setwelcomeEnable(false);
              }}
              label={t("Text Message")}
            />
          </Grid>
          <Grid item md={6}>
            {sendEmail ? (
              <div>
                <RACTextbox
                  inputlabel={t("Email")}
                  inputLabelClassname="form-label"
                  name="Email"
                  value={emailText != undefined ? emailText : ""}
                  OnChange={(e) => welcomeValidateOnChange(e)}
                  isCurrency={false}
                  type="email"
                  errorMessage={emailErrMsg}
                />
              </div>
            ) : (
              <div>
                <RACTextbox
                  inputlabel={t("Phone Number")}
                  inputLabelClassname="form-label"
                  name="phoneno"
                  value={phoneNo != undefined ? formatPhone(phoneNo) : ""}
                  OnChange={(e) => welcomeValidateOnChange(e)}
                  isCurrency={false}
                  type="text"
                  errorMessage={phoneErrMsg}
                />
              </div>
            )}
          </Grid>
        </Grid>

        <Grid
          item
          md={12}
          className={`${globalStyle.pb4} ${globalStyle.px3} ${globalStyle.textRight}`}
        >
          <RACButton
            variant="outlined"
            color="primary"
            className={classes.mx1}
            name="SendAgreementCancel"
            onClick={() => {
              setResendVopen(false);
            }}
          >
            {t("Cancel")}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            disabled={welcomeEnable}
            className={classes.mx1}
            name=""
            onClick={() => ResendVideoFinishClick()}
          >
            {t("Finish")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const ReturnStableFunc = () => {
    setreturnbtnRdn(false);
  };

  // const deliveryCancel = () => {
  //   history.push({
  //     pathname: `/customer/searchcustomer`,
  //   });
  // };

  const PreviousTimeSlotFn = async () => {
    let date1: any = "";
    let date2: any = "";
    date2 = date2 = new Date(timeSlotData[0]["Date"]);
    date1 = new Date(
      new Date().toLocaleString("en-US", { timeZone: "America/Chicago" })
    );
    const differenceInMilliseconds = date2 - date1;
    let differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    differenceInDays = Math.ceil(differenceInDays);
    if (differenceInDays > 3) {
      differenceInDays = 3;
    }
    const previousDate = moment(timeSlotData[0]["Date"])
      .subtract(differenceInDays, "days")
      .format("YYYY-MM-DD");
    setmasterLoader(true);
    const GetTimeSlotRes = await GetTimeSlot(previousDate);
    setmasterLoader(false);
  };
  const NextTimeSlotFn = async () => {
    let nextDate = timeSlotData[3]["Date"];
    setmasterLoader(true);
    const GetTimeSlotRes = await GetTimeSlot(nextDate);
    setmasterLoader(false);
  };
  function suggestAddressFn() {
    return (
      <>
        <Grid item md={12} className={classes.spacerPX2}>
          <Typography className={`${classes.RACPOPMsg} ${classes.bold}`}>
            {t("Entered Address")}
          </Typography>
          <div className={classes.formCheck}>
            <RACRadio
              id="inlineRadio1"
              name="inlineRadioOptions"
              checked={defaultSuggestedAddress == "ENT" ? true : false}
              onClick={() => setdefaultSuggestedAddress("ENT")}
              value={"ENT"}
            />
            <Typography
              className={`${classes.RACPOPMsg} ${classes.semiBold} ${classes.dispInlineFlex}`}
            >
              {`${Line2Popup ? Line1Popup + ", " + Line2Popup : Line1Popup}` +
                ", " +
                CityPopup +
                ", " +
                StatePopup +
                ", " +
                ZipPopup}
            </Typography>
          </div>
          <Grid
            item
            md={12}
            className={`${classes.spacerMB2} ${classes.spacerMT2}`}
          >
            <Typography className={`${classes.RACPOPMsg} ${classes.bold}`}>
              {t("Suggested Addresses")}
            </Typography>
            <div className={classes.formCheck}>
              <RACRadio
                id="inlineRadio1"
                name="inlineRadioOptions"
                checked={defaultSuggestedAddress == "GA" ? true : false}
                onClick={() => setdefaultSuggestedAddress("GA")}
                value={"GA"}
              />
              <Typography
                className={`${classes.RACPOPMsg} ${classes.semiBold} ${classes.dispInlineFlex}`} /* style={{width:'85%'}} */
              >
                {validatedAddresses.suggestedAddress}
              </Typography>
            </div>
          </Grid>
        </Grid>
        <Grid
          className={`${classes.spacerMT4} ${classes.w100} ${classes.floatLeft}`}
        >
          <Grid className={classes.floatLeft}>
            <RACButton
              variant="outlined"
              color="primary"
              className={classes.foc}
              onClick={() => setCanSuggestAddress(false)}
            >
              {t("Cancel")}
            </RACButton>
          </Grid>
          <Grid className={`${classes.floatRight}`}>
            <RACButton
              variant="contained"
              color="primary"
              onClick={() => continueclick(defaultSuggestedAddress)}
            >
              {t("Continue")}
            </RACButton>
          </Grid>
        </Grid>
      </>
    );
  }
  function suggestErrorInAddress() {
    return (
      <>
        <Grid item md={12}>
          <Grid
            style={{
              justifyContent: "center",
              display: "flex",
              marginBottom: "2%",
            }}
          >
            <Alertimage width={"10%"} height={"10%"} />
          </Grid>
          <Grid item md={12} className={classes.textCenter}>
            <Typography variant={"body2"} className={classes.RACPOPMsg}>
              {validatedAddresses?.message}
            </Typography>
          </Grid>
          <Grid
            container
            className={`${classes.justifyContentCenter} ${classes.spacerMT4}`}
          >
            <RACButton
              variant="contained"
              color="primary"
              isRounded={false}
              onClick={() => setCantSuggestAddress(false)}
            >
              {t("Ok")}
            </RACButton>
          </Grid>
        </Grid>
      </>
    );
  }
  function extractPartFromUrl(url: any, prefixToRemove: any): any {
    const currentUrl: URL = new URL(url);
    const pathname: string = currentUrl.pathname;
    return pathname.replace(prefixToRemove, "");
  }
  const verificationWarningPopupFn = () => {
    return (
      <Grid item md={12} className="px-2">
        <Grid item md={12} className="text-center">
          <WarningIcon></WarningIcon>
          <Typography
            style={{
              marginTop: "18px",
              marginBottom: "10px",
              fontSize: "18px",
            }}
          >
            {t(
              "This customer has incomplete verification,Do you want to continue?"
            )}
          </Typography>
        </Grid>
        <Grid container style={{ justifyContent: "center" }}>
          <RACButton
            color="primary"
            variant="contained"
            style={{ marginRight: "10px" }}
            onClick={() => {
              setverificationWarningPopup(false);
              history.push({
                pathname: `/customer/update/${customerId}/customer`,
                state: {
                  navFrom: extractPartFromUrl(window.location.href, "/menu/"),
                },
              });
            }}
          >
            {t("Verify Customer")}
          </RACButton>
          <RACButton
            color="primary"
            variant="outlined"
            onClick={() => {
              setverificationWarningPopup(false);
              setVerifcationRequiredContinue(true);
            }}
          >
            {t("Continue")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  const handleInputChange = (index: any, field: any, value: any) => {
    const updatedDataRows = [...inventoryInfo];
    updatedDataRows[index][field] = value;
    setInventoryInfo(updatedDataRows);
  };
  const LMDInventoryStore = () => {
    return (
      <div>
        <Grid container spacing={2}>
          <Grid item style={{ width: "100%" }}>
            <Typography variant="h5" className={classes.subTitle}>
              {t("Store Pick-up")}
            </Typography>{" "}
          </Grid>
          <Grid item style={{ width: "100%" }}>
            <Typography className={classes.deliveryEventDesc}>
              {t(
                "If a store is selected, a Store Pick-up Event will be created for the same time slot as the Delivery Event."
              )}
            </Typography>{" "}
          </Grid>
          <Grid item sm={2} md={2} lg={2}>
            <Typography>{t("Store to Pick-up From")}</Typography>{" "}
          </Grid>
          <Grid item sm={2} md={2} lg={2}>
            <Typography>{t("Inventory #")}</Typography>{" "}
          </Grid>
          <Grid item sm={8} md={8} lg={8}>
            <Typography>{t("Description")}</Typography>{" "}
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          {inventoryInfo?.map((row: any, index: any) => (
            <>
              <Grid item sm={2} md={2} lg={2}>
                <RACSelect
                  name="Radius Stores"
                  inputLabel=""
                  options={radiusStores}
                  defaultValue={row?.store}
                  isDisabled={false}
                  onChange={(e) =>
                    handleInputChange(index, "store", e.target.value)
                  }
                  {...(radiusStores?.length == 1 &&
                    !conditionLoader && {
                      errorMessage: t("Unable to fetch Data"),
                    })}
                />
              </Grid>
              <Grid item sm={2} md={2} lg={2} style={{ marginTop: "5px" }}>
                {" "}
                <Typography> {row.inventoryNumber}</Typography>
              </Grid>
              <Grid item sm={8} md={8} lg={8} style={{ marginTop: "5px" }}>
                {" "}
                <Typography> {row.description}</Typography>
              </Grid>
            </>
          ))}
        </Grid>
      </div>
    );
  };

  console.log("PLEASE CHECK HERE", viewAgrData?.data?.agreementWorkflow?.isDeliveryScheduled ==
                  "1",
                (getAgreementDeliveryRes?.appointmentInfo?.appointmentStatus !=
                  "CAN" ||
                  getAgreementDeliveryRes?.appointmentInfo?.appointmentStatus ==
                    "CMP"),
                featureFlagDetails?.FieldDevice == "1" );

  return (
    <div>
      {masterLoader ? (
        <Grid
          style={{
            position: "fixed",
            background: "#f7f5f5",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            opacity: 0.6,
            zIndex: 1050,
            textAlign: "center",
            margin: "0px 0px",
          }}
        >
          <Grid
            style={{
              display: "block",
              position: "fixed",
              zIndex: 9999999,
              top: "40%",
              right: "50%",
            }}
          >
            <CircularProgress />
          </Grid>
        </Grid>
      ) : null}
      <div id="step-4" className={classes.tabPanel}>
        <Grid
          container
          className={openReturnContent ? `${classes.height90Vh}` : ""}
        >
          <Grid item md={12}>
            <Typography className={classes.title} variant="h6">
              {/* Delivery Information */}
              {props.isReturn
                ? t("Return Information")
                : t("Delivery Information")}{" "}
            </Typography>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid
                    item
                    sm={12}
                    md={12}
                    lg={3}
                    className={classes.DetailsPadding}
                  >
                    <Typography className={classes.deliverytype} variant="h5">
                      {t("Delivery Type")}
                    </Typography>

                    <Grid className={classes.formCheck}>
                      <RACRadio
                        name="inlineRadioOptions"
                        id="delivery"
                        checked={checkDeliverytype == "DEL" ? true : false}
                        value={DeliveryRdo}
                        onClick={showDeliveryaddress}
                        size={"small"}
                        label={props.isReturn ? t("Pickup") : t("Delivery")}
                      />
                    </Grid>
                    <Grid className={classes.formCheck}>
                      <RACRadio
                        name="inlineRadioOptions"
                        id="carryout"
                        checked={checkDeliverytype == "CAR" ? true : false}
                        value={CarryoutRdo}
                        onClick={hideDeliveryaddress}
                        size={"small"}
                        label={props.isReturn ? t("Carry In") : t("Carryout")}
                      />
                    </Grid>
                  </Grid>
                  {featureFlagDetails.MXAddressValidation == 1 ?
                    <Grid
                      item
                      sm={12}
                      md={12}
                      lg={9}
                      className={classes.DetailsPadding}
                    >
                      <Typography className={classes.deliverytype} variant="h5">
                        {t("Delivery Address")}
                      </Typography>

                      <Grid container>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={3}
                          className={classes.widthAdjust16}
                        >
                          <Typography className={classes.formLabel}>
                            {t("Street")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {Addressline1}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={3}
                          className={classes.widthAdjust16}
                        >
                          <Typography className={classes.formLabel}>
                            {t("Exterior Number")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {exteriorNumber ?? '-'}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={3}
                          className={classes.widthAdjust16}
                        >
                          <Typography className={classes.formLabel}>
                            {t("Interior Number")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {interiorNumber ?? '-'}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={3}
                          className={classes.widthAdjust16}
                        >
                          <Typography className={classes.formLabel}>
                            {t("Suburb")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {Addressline2 ?? '-'}
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          sm={2}
                          md={2}
                          lg={2}
                        // className={classes.widthAdjust16}
                        >
                          <Typography className={classes.formLabel}>
                            {t("Zip Code")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {Zip}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={2}
                          className={classes.widthAdjust16}
                        >
                          <Typography className={classes.formLabel}>
                            {t("City")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {City}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={2}
                          className={classes.widthAdjust13}
                        >
                          <Typography className={classes.formLabel}>
                            {t("State")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {State}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={2}
                          className={classes.widthAdjust16}
                        >
                          {!props.isReturn ? (
                            <>
                              {hideswitchoutbutton ? (
                                <RACButton
                                  className={classes.buttonAddRows}
                                  onClick={() => disPopup()}
                                  disabled={datePickerEnable ? false : true}
                                >
                                  {t("Select Other Address")}
                                </RACButton>
                              ) : (
                                <RACButton
                                  className={classes.buttonAddRows}
                                  onClick={() => disPopup()}
                                  disabled={datePickerEnable ? false : true}
                                >
                                  {t("Select Other Address")}
                                </RACButton>
                              )}
                            </>
                          ) : null}
                        </Grid>
                      </Grid>
                    </Grid>
                    :
                    <Grid
                      item
                      sm={12}
                      md={12}
                      lg={10}
                      className={classes.DetailsPadding}
                    >
                      <Typography className={classes.deliverytype} variant="h5">
                        {t("Delivery Address")}
                      </Typography>

                    <Grid container>
                      <Grid
                        item
                        sm={4}
                        md={4}
                        lg={2}
                        className={classes.widthAdjust16}
                      >
                        <Typography className={classes.formLabel}>
                          {t("Address Line 1")}
                        </Typography>
                        <Typography className={classes.formLabelValue}>
                          {Addressline1}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sm={4}
                        md={4}
                        lg={2}
                        className={classes.widthAdjust16}
                      >
                        <Typography className={classes.formLabel}>
                          {t("Apt/Unit #")}
                        </Typography>
                        <Typography className={classes.formLabelValue}>
                          {Addressline2}
                        </Typography>
                      </Grid>

                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={2}
                          className={classes.widthAdjust16}
                        >
                          <Typography className={classes.formLabel}>
                            {t("Zip")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {Zip}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={2}
                          className={classes.widthAdjust16}
                        >
                          <Typography className={classes.formLabel}>
                            {t("City")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {City}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={2}
                          className={classes.widthAdjust13}
                        >
                          <Typography className={classes.formLabel}>
                            {t("State")}
                          </Typography>
                          <Typography className={classes.formLabelValue}>
                            {State}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          md={4}
                          lg={2}
                          className={classes.widthAdjust16}
                        >
                          {!props.isReturn ? (
                            <>
                              {hideswitchoutbutton ? (
                                <RACButton
                                  className={classes.buttonAddRows}
                                  onClick={() => disPopup()}
                                  disabled={datePickerEnable ? false : true}
                                >
                                  {t("Select Other Address")}
                                </RACButton>
                              ) : (
                                <RACButton
                                  className={classes.buttonAddRows}
                                  onClick={() => disPopup()}
                                  disabled={datePickerEnable ? false : true}
                                >
                                  {t("Select Other Address")}
                                </RACButton>
                              )}
                            </>
                          ) : null}
                        </Grid>
                      </Grid>
                    </Grid>}
                </Grid>

                {props.reScheduleData != undefined &&
                props.reScheduleData.deliveryType != "" ? (
                  <Grid container className={classes.DetailsPadding}>
                    <Grid item md={12}>
                      {props.reScheduleData.deliveryType === "Delivery" &&
                      Deliverytype === "D" ? (
                        <Typography
                          className={classes.deliverytype}
                          variant="h5"
                        >
                          {t("Delivery Details")}
                        </Typography>
                      ) : Deliverytype === "D" ? (
                        <Typography
                          className={classes.deliverytype}
                          variant="h5"
                        >
                          {t("Delivery Details")}
                        </Typography>
                      ) : (
                        <Typography
                          className={classes.deliverytype}
                          variant="h5"
                        >
                          {t("Carryout Details")}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container className={classes.DetailsPadding}>
                    <Grid item md={12}>
                      {Deliverytype === "D" ? (
                        <Typography
                          className={classes.deliverytype}
                          variant="h5"
                        >
                          {t("Delivery Details")}
                        </Typography>
                      ) : (
                        <Typography
                          className={classes.deliverytype}
                          variant="h5"
                        >
                          {t("Carryout Details")}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                )}
                <Grid container spacing={2} className={classes.mb3}>
                  {mxDeliveryKey && (
                    <Grid item sm={4} md={4} lg={2}>
                      <RACSelect
                        inputLabelClassName={
                          agrGeneralInfoClassName.dropDownLabel
                        }
                        name="Assignee "
                        inputLabel={t("Assignee")}
                        required={true}
                        loading={isLoading}
                        options={salesPersonOptions}
                        defaultValue={salesPersonValue}
                        onChange={(e: any) =>
                          SalesPersonOnchange(e.target.value)
                        }
                         isDisabled ={salesPersonValue  && isDisableSalesPerson ? true : false}
                        
                        {...(salesPersonOptions.length == 0 &&
                          !conditionLoader && {
                            errorMessage: t("Unable to fetch Data"),
                          })}
                      />
                    </Grid>
                  )}
                  <Grid item sm={4} md={4} lg={2}>
                    {featureFlagDetails?.DateTimeLocalization =='1'?
                      <div className={classes.RACMUIDatePicker}>
                    <RACMUIDatePicker
                      label={t("Date")}
                      value={startDate}
                      classes={{
                        input: dateError !== "" ? classes.bgdateError : "",
                      }}
                      errorMessage={t(dateError)}
                      onChange={(e) => dates(e)}
                      inputProps={{
                        min: moment().format("YYYY-MM-DD"),
                        max: MaxDate,
                      }}
                      disabled={datePickerEnable ? false : true}
                    />
                    </div>
                     :
                    <RACDatePicker
                      label={t("Date")}
                      value={startDate}
                      classes={{
                        input: dateError !== "" ? classes.bgdateError : "",
                      }}
                      errorMessage={t(dateError)}
                      onChange={(e) => dates(e)}
                      inputProps={{
                        min: moment().format("YYYY-MM-DD"),
                        max: MaxDate,
                      }}
                      disabled={datePickerEnable ? false : true}
                    />}
                  </Grid>
                  {/* dates.bind(event) */}
                  <Grid item sm={4} md={4} lg={2}>
                    <RACTextbox
                      isCurrency={false}
                      id="a11y_time"
                      disabled
                      value={Time}
                      inputlabel={t("Time")}
                      OnChange={Timebind}
                    />
                  </Grid>
                  {props.reScheduleData != undefined &&
                  props.reScheduleData.deliveryType != "" ? (
                    <>
                      {props.reScheduleData.deliveryType === "Delivery" &&
                      Deliverytype === "D" ? (
                        <Grid item sm={4} md={4} lg={2}>
                          <RACSelect
                            inputLabel={t("# Co-workers Required")}
                            loading={conditionLoader}
                            options={CoworkerOptionsArray()}
                            defaultValue={Coworkers !== "" ? Coworkers : "1"}
                            // defaultValue={'1'}
                            onChange={(
                              e: React.ChangeEvent<HTMLSelectElement>
                            ) => {
                              SetCoworkers(e.target.value);
                              if (props.triggerdeliveryChanged) {
                                props.triggerdeliveryChanged();
                              }
                              SetSaveTrigger(false);
                            }}
                            {...(coWorkerRequiredArray.length == 1 &&
                              !conditionLoader && {
                                errorMessage: t("Unable to fetch Data"),
                              })}
                            isDisabled={datePickerEnable ? false : true}
                          />
                        </Grid>
                      ) : Deliverytype === "D" ? (
                        <Grid item sm={4} md={4} lg={2}>
                          <RACSelect
                            inputLabel={t("# Co-workers Required")}
                            loading={conditionLoader}
                            options={CoworkerOptionsArray()}
                            defaultValue={Coworkers !== "" ? Coworkers : "1"}
                            // defaultValue={'1'}
                            onChange={(
                              e: React.ChangeEvent<HTMLSelectElement>
                              // eslint-disable-next-line sonarjs/no-identical-functions
                            ) => {
                              SetCoworkers(e.target.value);

                              if (props.triggerdeliveryChanged) {
                                props.triggerdeliveryChanged();
                              }
                              SetSaveTrigger(false);
                            }}
                            {...(coWorkerRequiredArray.length == 1 &&
                              !conditionLoader && {
                                errorMessage: t("Unable to fetch Data"),
                              })}
                            isDisabled={datePickerEnable ? false : true}
                          />
                        </Grid>
                      ) : null}
                    </>
                  ) : (
                    <>
                      {Deliverytype === "D" ? (
                        <Grid item sm={4} md={4} lg={2}>
                          <RACSelect
                            inputLabel={t("# Co-workers Required")}
                            loading={conditionLoader}
                            options={CoworkerOptionsArray()}
                            defaultValue={Coworkers !== "" ? Coworkers : "1"}
                            // defaultValue={'1'}
                            onChange={(
                              e: React.ChangeEvent<HTMLSelectElement>
                              // eslint-disable-next-line sonarjs/no-identical-functions
                            ) => {
                              SetCoworkers(e.target.value);

                              if (props.triggerdeliveryChanged) {
                                props.triggerdeliveryChanged();
                              }
                              SetSaveTrigger(false);
                            }}
                            {...(coWorkerRequiredArray.length == 1 &&
                              !conditionLoader && {
                                errorMessage: t("Unable to fetch Data"),
                              })}
                            isDisabled={datePickerEnable ? false : true}
                          />
                        </Grid>
                      ) : null}
                    </>
                  )}
                  <Grid item sm={8} md={8} lg={4}>
                    <RACTextbox
                      inputlabel={t("Instructions")}
                      id="a11y_Instructions"
                      isCurrency={false}
                      value={Instructions}
                      OnChange={(e) => {
                        SetInstructions(e.target.value);
                        if (props.triggerdeliveryChanged) {
                          props.triggerdeliveryChanged();
                        }
                        SetSaveTrigger(false);
                      }}
                      disabled={datePickerEnable ? false : true}
                    />
                  </Grid>
                </Grid>

                {/* {LMDConfigurable ? LMDInventoryStore() : ''} */}

                {/* (viewAgrData?.data?.agreementWorkflow?.isDeliveryScheduled == '1') && (viewAgrData?.data?.agreementWorkflow?.isSwitchoutEnabled == '0') && (viewAgrData?.data?.agreementInformation?.agreementType == 'Rental Agreement (RTO)' || viewAgrData?.data?.agreementInformation?.agreementType == 'Rent to Rent - Loaner') && (props.appiontmentType == 'D' || props.appiontmentType == 'CO' || deliveryMethodData?.appiontmentType == 'D' || deliveryMethodData?.appiontmentType == 'CO') &&  */}
                {viewAgrData?.data?.agreementWorkflow?.isDeliveryScheduled ==
                  "1" &&
                (getAgreementDeliveryRes?.appointmentInfo?.appointmentStatus !=
                  "CAN" ||
                  getAgreementDeliveryRes?.appointmentInfo?.appointmentStatus ==
                    "CMP") &&
                featureFlagDetails?.FieldDevice == "1" ? (
                  <Grid>
                    <Grid style={{ display: "inline-block" }}>
                      <RACToggle
                        checked={manualSignatureEnabled}
                        toggleColor="#0d6efd"
                        OnClick={() => {
                          manualSignatureEnabled
                            ? setManualSignatureEnabled(false)
                            : setManualSignatureEnabled(true);
                        }}
                      />
                    </Grid>
                    <Typography style={{ display: "inline" }}>
                      {" "}
                      {t("Manual Signature")}
                    </Typography>
                  </Grid>
                ) : (
                  setManualSignatureEnabled(true)
                )}

                {getAgreementDeliveryRes?.appointmentInfo?.appointmentStatus ==
                "CAN" ? (
                  <div>
                    <p
                      style={{
                        width: "100%",
                        textAlign: "center",
                        borderBottom: "1px solid #000",
                        lineHeight: "0.1rem",
                        margin: "10px 0 20px",
                      }}
                    >
                      <span style={{ background: "#fff", padding: "0 10px" }}>
                        {t("Event Status")}:
                        <span
                          style={{ backgroundColor: "lightpink", color: "red" }}
                        >
                          {t("Cancelled")}
                        </span>
                      </span>
                    </p>
                  </div>
                ) : null}
                {rescheduleEnable && !desktopView ? (
                  <>
                    <Grid container>
                      <Grid
                        item
                        sm={12}
                        md={12}
                        lg={8}
                        className={classes.spacerMT8}
                      >
                        <Grid className={classes.floatLeft}>
                          <Typography variant="h5" className={classes.subTitle}>
                            {t("Select Available Timeslot")}
                          </Typography>
                          <Typography className={classes.deliveryEventDesc}>
                            {t("Only 4 events can be added in one time slot.")}
                          </Typography>
                        </Grid>
                        <Grid className={classes.floatRight}>
                          <Grid
                            className={`${classes.floatLeft} ${classes.me48}`}
                          >
                            <span className={classes.circleAvailable} />
                            <span>{t("Available")}</span>
                          </Grid>
                          <Grid
                            classes={{
                              root: clsx(classes.floatLeft, classes.spacerMR4),
                            }}
                          >
                            <span className={classes.circleBusy} />
                            <span>{t("Busy")}</span>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item md={12} className={classes.spacerMB5}>
                      <Grid
                        className={`${classes.mt2} ${classes.me2} ${classes1.timeSlot}`}
                      >
                        {buildTimeSlot()}
                      </Grid>
                      <Grid
                        className={`${globalStyle.flexCenter} ${globalStyle.mt3}  ${classes1.dMdFlex}`}
                      >
                        <RACButton
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            PreviousTimeSlotFn();
                          }}
                          disabled={previousBtnEnable ? false : true}
                        >
                          {t("Previous")}
                        </RACButton>
                        <RACButton
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            NextTimeSlotFn();
                          }}
                        >
                          {t("Next")}
                        </RACButton>
                      </Grid>
                    </Grid>
                  </>
                ) : rescheduleEnable && desktopView ? (
                  <>
                    <Grid container>
                      <Grid
                        item
                        sm={12}
                        md={12}
                        lg={8}
                        className={classes.spacerMT8}
                      >
                        <Grid className={classes.floatLeft}>
                          <Typography variant="h5" className={classes.subTitle}>
                            {t("Select Available Timeslot") }
                            { FieldVisitOverride && <span  style={{
                                background: '#ff4757',
                                color: 'white',
                                fontSize: '0.75rem',
                                borderRadius: '16px',
                                pointerEvents: 'none', 
                              }}
                            > Override</span>
                            }
                          </Typography>
                          <Typography className={classes.deliveryEventDesc}>
                            {t("Only 4 events can be added in one time slot.")}
                          </Typography>
                        </Grid>
                        <Grid className={classes.floatRight}>
                          <Grid
                            className={`${classes.floatLeft} ${classes.me48}`}
                          >
                            <span className={classes.circleAvailable} />
                            <span>{t("Available")}</span>
                          </Grid>
                          <Grid
                            classes={{
                              root: clsx(classes.floatLeft, classes.spacerMR4),
                            }}
                          >
                            <span className={classes.circleBusy} />
                            <span>{t("Busy")}</span>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item md={12} className={classes.spacerMB5}>
                      <Grid
                        className={`${classes.mt2} ${classes.me2} ${classes1.timeSlot}`}
                      >
                        {buildTimeSlot()}
                      </Grid>
                    </Grid>

                    {(exchangeAgreementId &&
                      agrInfoResp?.agreementInformation
                        ?.agreementStatusRefCode != "ARTS" &&
                      agrInfoResp?.agreementWorkflow?.isReturnScheduled ==
                        "0" &&
                      agrInfoResp?.agreementWorkflow?.isReturnConfirmed ==
                        "0") ||
                    (viewAgrData?.data?.agreementInformation?.isExchanged ==
                      1 &&
                      viewAgrData?.data?.agreementInformation
                        .isDeliveryConfirmed == 0 &&
                      viewAgrData?.agreementInformation.isDeliveryScheduled ==
                        0) ? (
                      <RACCheckBox
                        className={`${classes.floatLeft} ${classes.textCenter}`}
                        onClick={() => {
                          setOpenReturnContent(!openReturnContent);
                          setStartDateExc(moment().format("YYYY-MM-DD"));
                          setExReturnTime("");
                          SetExReturnBindtimeslotId("");
                          SetExReturnTimeSlotId("");
                          SetExcInstructions("");
                          SetCoworkersExc("");
                          SetcheckDeliverytypeExc("DEL");
                        }}
                        checked={openReturnContent}
                        disabled={Time ? false : true}
                        label={t("Schedule Pickup for the Exchange Agreement")}
                      />
                    ) : null}
                  </>
                ) : null}

                {renderKey && !enableFinish &&  (
                  <>
                    <Grid className={classes.floatLeft}>
                      <Typography variant="h5" className={classes.subTitle}>
                        {t("Store Transfer")}
                      </Typography>
                      <Typography className={classes.deliveryEventDesc}>
                        {t(
                        "If a store is selected, a Store Pick-up Event will be created for the same time slot as the Delivery Event."
                        )}
                      </Typography>
                    </Grid>
                    <Grid container spacing={2} className={classes.mb3}>
                      {/* Store Dropdown */}
                      <Grid item sm={4} md={2} lg={2}>
                        <RACSelect
                          inputLabel={t("Store to Pick-up from")}
                          options={getStoreOptions()}
                          value={selectedStore}
                          onChange={(e) => {
                            const val = e.target.value;
                            console.log(val, "selected store");
                            setSelectedStore(val);
                            setSelectedInventory("");
                            setSelectedInventoryId("");
                            setSelectedDate("");
                            setSelectedTimeSlot("");
                          }}
                        />
                      </Grid>

                      {/* Inventory Dropdown */}
                      <Grid item sm={4} md={4} lg={2}>
                        <RACSelect
                          inputLabel={t("Inventory #")}
                          options={
                            selectedStore
                              ? getInventoryOptions(selectedStore)
                              : [{  label: t("Select"), value: "" }]
                          }
                          value={selectedInventory}
                          disabled={!selectedStore}
                          onChange={(e) => {
                            const val = e.target.value;
                             console.log(inventoryIdList,"inventory id object");
                             
                            // Find the selected inventory object
                            const selected = inventoryIdList.find((item: any) => item.inventoryNo === val);
                            console.log(selected,"selected inventoryId");
                            
                      
                            // Update state
                            setSelectedInventory(val);
                            setSelectedInventoryId(selected?.value || ""); // fallback if not found
                            setSelectedDate("");
                            setSelectedTimeSlot("");
                      
                            // Call with updated inventory
                            filterTimeSlotsForDelivery(
                              selectedStore,
                              startDate,
                              Time,
                              val // <-- pass the updated selectedInventory directly
                            );
                          }}
                        />
                      </Grid>

                      {/* Date Dropdown */}
                      <Grid item sm={4} md={4} lg={2}>
                        <RACSelect
                          inputLabel={t("Date")}
                          options={
                            selectedInventory
                              ? getDateOptions(selectedInventory,false)
                              : [{  label: t("Select"), value: "" }]
                          }
                          value={selectedDate}
                          disabled={!selectedInventory}
                          onChange={(e) => {
                            const val = e.target.value;
                            setSelectedDate(val);
                            setSelectedTimeSlot("");
                          }}
                        />
                      </Grid>

                    {/* Time Slot Dropdown */}
                    <Grid item sm={4} md={4} lg={2}>
                      <RACSelect
                        inputLabel={t("Time Slot")}
                        options={
                          selectedDate
                            ? getTimeSlotOptions(selectedDate)
                            : [{ label: "Select", value: "" }]
                        }
                        value={selectedTimeSlot}
                        disabled={!selectedDate}
                        onChange={(e) => {
                          setSelectedTimeSlot(e.target.value);
                        }}
                      />
                    </Grid>
                    

                      {/* Description Box */}
                      <Grid item sm={4} md={4} lg={2}>
                        <Typography
                          variant="subtitle1"
                          className={classes.subTitle}
                        >
                          {t("Description")}
                        </Typography>
                        <Typography className={classes.deliveryEventDesc}>
                          {description || t("No description available")}
                        </Typography>
                      </Grid>

                      {/* Add Button */}
                      {selectedStore &&
                        selectedInventory &&
                        selectedDate &&
                        selectedTimeSlot && (
                          <Grid
                            item
                            sm={4}
                            md={2}
                            lg={1}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "8px",
                            }}
                          >
                            <RACButton
                              onClick={handleAddRow}
                              variant="icon"
                            >
                              <AddIcon />
                            </RACButton>
                          </Grid>
                        )}
                    </Grid>
                  </>
                )}

                {/* Conditional Table Display */}
                {mxDeliveryKey && rows.length > 0 && (
                  <Grid className={fixedGridClassName.fixTableHead}>
                    <RACTable renderTableContent={renderTableContentGrid} />
                  </Grid>
                )}

                {/* -----------------------Tiem slot end------------------------- */}
                {RescheduleProps === "Schedule" ? (
                  <Grid className={classes.fixedBottom}>
                    <Grid className={classes.floatLeft}>
                      <RACButton
                        variant="outlined"
                        color="primary"
                        className={classes.floatLeft}
                        onClick={() => PreviousbuttonClick()}
                      >
                        {t("Previous")}
                      </RACButton>
                      {/* <RACButton
                        variant="outlined"
                        color="primary"
                        className={`${classes.floatLeft} ${classes.ms2}`}
                        onClick={() => deliveryCancel()}
                      >
                        Cancel
                      </RACButton> */}
                    </Grid>

                    <Grid
                      className={classes.floatRight}
                      style={{ display: "flex" }}
                    >
                      {
                        featureFlagDetails?.EnablePreDeliveryCancellation === '1' ? (
                            viewAgrData?.data.agreementWorkflow.isDeliveryCompleted === '0' ? (
                            <Grid className={classes.me2}>
                                <VoidAgreement AgreementId={agreementId}
                                customerId={customerId}
                                COVoidFlow={viewAgrData?.data.agreementInformation.agreementStatusRefCode}
                                paymentCount={viewAgrData?.data.agreementInformation.paymentCount}>
                                </VoidAgreement>
                            </Grid>
                            ) : 
                            (<RACButton
                              disabled={
                                viewAgrData?.data?.agreementWorkflow
                                  ?.isTransferInitiated == 1
                                  ? true
                                  : false
                              }
                              className={classes.mx1}
                              onClick={ReturnChange}
                              variant="contained"
                              color="primary"
                            >
                              {t("Return")}
                            </RACButton>)
                        ) : null
                      }
                      

                      {resumebtnFeatureFlag == "1" &&
                      featureFlagDetails?.SundaySky == "1" ? (
                        <RACButton
                          variant="contained"
                          color="primary"
                          className={`${classes.floatLeft} ${classes.mx1}`}
                          // disabled={enableFinish}
                          onClick={() => setResendVopen(true)}
                        >
                          {t("Resend Welcome Video")}
                        </RACButton>
                      ) : null}

                      {
                        featureFlagDetails?.EnablePreDeliveryCancellation !== '1' ? (
                          <RACButton
                            disabled={
                              viewAgrData?.data?.agreementWorkflow
                                ?.isTransferInitiated == 1
                                ? true
                                : false
                            }
                            className={classes.mx1}
                            onClick={ReturnChange}
                            variant="contained"
                            color="primary"
                          >
                            {t("Return")}
                          </RACButton>
                        ) : null
                      }
                      { FVSConfigurable && 
                      <RACButton                            
                            className={classes.mx1}
                            variant="contained"
                            color="primary"
                            disabled={overrideButtonOff}
                            onClick={() => setDAPEventOverrideSLA(true)}
                          >
                            {FieldVisitOverride ? t("Reset Override") : t("Override")}
                          </RACButton>
                        }
                        {FVSConfigurable && DAPEventOverrideSLA ? (
                                    <SecondFactor
                                      setTwoFactorCompleted={eventOverrideSLAsuccess}
                                      setTwoFactorCancelClick={() => setDAPEventOverrideSLA(false)}
                                      currentRole={currentUserRole}
                                      moduleName="DAPEventOverride"              
                                    />
                                  ) : null}
                      
                      <AddCoCustomer
                        // coCustomerData={Cocustomer}
                        func={pull_data}
                      />
                      <Eposchedule epoData={EpoProps} />
                      <RACButton
                        variant="contained"
                        color="primary"
                        className={classes.floatLeft}
                        disabled={enableFinish}
                        onClick={() => { FVSConfigurable && FieldVisitOverride ? processFieldVisitMoveOverride() :
                          mxDeliveryKey
                            ? handleFinish()
                            :Complete_delivery_status();
                        }}
                      >
                        { FVSConfigurable && FieldVisitOverride  ? t("Move") : t("Finish")}
                      </RACButton>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid className={classes.fixedBottom}>
                    <Grid className={classes.floatLeft}>
                      <RACButton
                        variant="contained"
                        color="primary"
                        className={classes.floatLeft}
                        disabled={enableFinish}
                        onClick={() => Complete_delivery_status()}
                      >
                        {t("Save")}
                      </RACButton>
                    </Grid>
                  </Grid>
                )}
                {LMDConfigurable ? LMDInventoryStore() : ""}
              </CardContent>
            </Card>
            {openReturnContent ? (
              // <Card className={`${classes.card} ${classes.spacerMT2}`}>
              //   <CardContent>
              <div
                id="step-4"
                className={`${classes.tabPanel} ${classes.spacerMT2}`}
              >
                <Grid container>
                  <Grid item md={12}>
                    <Typography className={classes.title} variant="h6">
                      {t("Return Information")}
                    </Typography>
                    <Card className={classes.card}>
                      <CardContent>
                        <Grid container spacing={2}>
                          <Grid
                            item
                            sm={12}
                            md={12}
                            lg={3}
                            className={classes.DetailsPadding}
                          >
                            <Typography
                              className={classes.deliverytype}
                              variant="h5"
                            >
                              {t("Pickup Type")}
                            </Typography>

                            <Grid className={classes.formCheck}>
                              <RACRadio
                                name="inlineRadioOptions"
                                id="delivery"
                                checked={
                                  checkDeliverytypeExc == "DEL" ? true : false
                                }
                                value={DeliveryRdoExc}
                                onClick={(e) => showDeliveryaddress(e, true)}
                                size={"small"}
                                label={t("Pickup")}
                              />
                            </Grid>
                            <Grid className={classes.formCheck}>
                              <RACRadio
                                name="inlineRadioOptions"
                                id="carryout"
                                checked={
                                  checkDeliverytypeExc == "CAR" ? true : false
                                }
                                value={CarryinRdoExc}
                                onClick={(e) => hideDeliveryaddress(e, true)}
                                size={"small"}
                                label={t("Carry In")}
                              />
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            sm={12}
                            md={12}
                            lg={9}
                            className={classes.DetailsPadding}
                          >
                            <Typography
                              className={classes.deliverytype}
                              variant="h5"
                            >
                              {t("Pickup Address")}
                            </Typography>

                            <Grid container>
                              <Grid
                                item
                                sm={4}
                                md={4}
                                lg={2}
                                className={classes.widthAdjust16}
                              >
                                <Typography className={classes.formLabel}>
                                  {t("Address Line 1")}
                                </Typography>
                                <Typography className={classes.formLabelValue}>
                                  {Addressline1}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                sm={4}
                                md={4}
                                lg={2}
                                className={classes.widthAdjust16}
                              >
                                <Typography className={classes.formLabel}>
                                  {t("Apt/Unit #")}
                                </Typography>
                                <Typography className={classes.formLabelValue}>
                                  {Addressline2}
                                </Typography>
                              </Grid>

                              <Grid
                                item
                                sm={4}
                                md={4}
                                lg={2}
                                className={classes.widthAdjust16}
                              >
                                <Typography className={classes.formLabel}>
                                  {t("Zip")}
                                </Typography>
                                <Typography className={classes.formLabelValue}>
                                  {Zip}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                sm={4}
                                md={4}
                                lg={2}
                                className={classes.widthAdjust16}
                              >
                                <Typography className={classes.formLabel}>
                                  {t("City")}
                                </Typography>
                                <Typography className={classes.formLabelValue}>
                                  {City}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                sm={4}
                                md={4}
                                lg={2}
                                className={classes.widthAdjust13}
                              >
                                <Typography className={classes.formLabel}>
                                  {t("State")}
                                </Typography>
                                <Typography className={classes.formLabelValue}>
                                  {State}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                sm={4}
                                md={4}
                                lg={2}
                                className={classes.widthAdjust16}
                              >
                                {/* {!props.isReturn ? (
                                        <>
                                          {hideswitchoutbutton ? (
                                            <RACButton
                                              className={classes.buttonAddRows}
                                              onClick={() => disPopup()}
                                              disabled={datePickerEnable ? false : true}
                                            >
                                              Select Other Address
                                            </RACButton>
                                          ) : (
                                            <RACButton
                                              className={classes.buttonAddRows}
                                              onClick={() => disPopup()}
                                              disabled={datePickerEnable ? false : true}
                                            >
                                              Select Other Address
                                            </RACButton>
                                          )}
                                        </>
                                      ) : null} */}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        {props.reScheduleData != undefined &&
                        props.reScheduleData.deliveryType != "" ? (
                          <Grid container className={classes.DetailsPadding}>
                            <Grid item md={12}>
                              {props.reScheduleData.deliveryType === "Pickup" &&
                              DeliverytypeExc === "P" ? (
                                <Typography
                                  className={classes.deliverytype}
                                  variant="h5"
                                >
                                  {t("Pickup Details")}
                                </Typography>
                              ) : DeliverytypeExc === "P" ? (
                                <Typography
                                  className={classes.deliverytype}
                                  variant="h5"
                                >
                                  {t("Pickup Details")}
                                </Typography>
                              ) : (
                                <Typography
                                  className={classes.deliverytype}
                                  variant="h5"
                                >
                                  {t("Carry In Details")}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        ) : (
                          <Grid container className={classes.DetailsPadding}>
                            <Grid item md={12}>
                              {DeliverytypeExc === "P" ? (
                                <Typography
                                  className={classes.deliverytype}
                                  variant="h5"
                                >
                                  {t("Pickup Details")}
                                </Typography>
                              ) : (
                                <Typography
                                  className={classes.deliverytype}
                                  variant="h5"
                                >
                                  {t("Carry In Details")}
                                </Typography>
                              )}
                            </Grid>
                          </Grid>
                        )}
                        <Grid container spacing={2} className={classes.mb3}>
                          <Grid item sm={4} md={4} lg={2}>
                            {featureFlagDetails?.DateTimeLocalization =='1'?
                             <RACMUIDatePicker
                              label={t("Date")}
                              value={startDateExc}
                              classes={{
                                input:
                                  dateError !== "" ? classes.bgdateError : "",
                              }}
                              errorMessage={t(dateError)}
                              onChange={(e) => dates(e, true)}
                              inputProps={{
                                min: moment().format("YYYY-MM-DD"),
                                max: MaxDate,
                              }}
                              disabled={datePickerEnable ? false : true}
                            />
                            :
                            <RACDatePicker
                              label={t("Date")}
                              value={startDateExc}
                              classes={{
                                input:
                                  dateError !== "" ? classes.bgdateError : "",
                              }}
                              errorMessage={t(dateError)}
                              onChange={(e) => dates(e, true)}
                              inputProps={{
                                min: moment().format("YYYY-MM-DD"),
                                max: MaxDate,
                              }}
                              disabled={datePickerEnable ? false : true}
                            />}
                          </Grid>
                          {/* dates.bind(event) */}
                          <Grid item sm={4} md={4} lg={2}>
                            <RACTextbox
                              isCurrency={false}
                              id="a11y_time"
                              disabled
                              value={exReturnTime}
                              inputlabel={t("Time")}
                              OnChange={(e) => {
                                Timebind(e, true);
                              }}
                            />
                          </Grid>
                          {props.reScheduleData != undefined &&
                          props.reScheduleData.deliveryType != "" ? (
                            <>
                              {props.reScheduleData.deliveryType === "Pickup" &&
                              DeliverytypeExc === "P" ? (
                                <Grid item sm={4} md={4} lg={2}>
                                  <RACSelect
                                    inputLabel={t("# Co-workers Required")}
                                    loading={conditionLoader}
                                    options={CoworkerOptionsArray()}
                                    defaultValue={
                                      CoworkersExc !== "" ? CoworkersExc : "1"
                                    }
                                    // defaultValue={'1'}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLSelectElement>
                                    ) => {
                                      SetCoworkersExc(e.target.value);
                                      if (props.triggerdeliveryChanged) {
                                        props.triggerdeliveryChanged();
                                      }
                                      SetSaveTrigger(false);
                                    }}
                                    {...(coWorkerRequiredArray.length == 1 &&
                                      !conditionLoader && {
                                        errorMessage: t("Unable to fetch Data"),
                                      })}
                                    isDisabled={datePickerEnable ? false : true}
                                  />
                                </Grid>
                              ) : DeliverytypeExc === "P" ? (
                                <Grid item sm={4} md={4} lg={2}>
                                  <RACSelect
                                    inputLabel={t("# Co-workers Required")}
                                    loading={conditionLoader}
                                    options={CoworkerOptionsArray()}
                                    defaultValue={
                                      CoworkersExc !== "" ? CoworkersExc : "1"
                                    }
                                    // defaultValue={'1'}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLSelectElement>
                                      // eslint-disable-next-line sonarjs/no-identical-functions
                                    ) => {
                                      SetCoworkersExc(e.target.value);
                                      if (props.triggerdeliveryChanged) {
                                        props.triggerdeliveryChanged();
                                      }
                                      SetSaveTrigger(false);
                                    }}
                                    {...(coWorkerRequiredArray.length == 1 &&
                                      !conditionLoader && {
                                        errorMessage: t("Unable to fetch Data"),
                                      })}
                                    isDisabled={datePickerEnable ? false : true}
                                  />
                                </Grid>
                              ) : null}
                            </>
                          ) : (
                            <>
                              {DeliverytypeExc === "P" ? (
                                <Grid item sm={4} md={4} lg={2}>
                                  <RACSelect
                                    inputLabel={t("# Co-workers Required")}
                                    loading={conditionLoader}
                                    options={CoworkerOptionsArray()}
                                    defaultValue={
                                      CoworkersExc !== "" ? CoworkersExc : "1"
                                    }
                                    // defaultValue={'1'}
                                    onChange={(
                                      e: React.ChangeEvent<HTMLSelectElement>
                                      // eslint-disable-next-line sonarjs/no-identical-functions
                                    ) => {
                                      SetCoworkersExc(e.target.value);

                                      if (props.triggerdeliveryChanged) {
                                        props.triggerdeliveryChanged();
                                      }
                                      SetSaveTrigger(false);
                                    }}
                                    {...(coWorkerRequiredArray.length == 1 &&
                                      !conditionLoader && {
                                        errorMessage: t("Unable to fetch Data"),
                                      })}
                                    isDisabled={datePickerEnable ? false : true}
                                  />
                                </Grid>
                              ) : null}
                            </>
                          )}
                          <Grid item sm={8} md={8} lg={4}>
                            <RACTextbox
                              inputlabel={t("Instructions")}
                              id="a11y_Instructions"
                              isCurrency={false}
                              value={InstructionsExc}
                              OnChange={(e) => {
                                SetExcInstructions(e.target.value);
                                if (props.triggerdeliveryChanged) {
                                  props.triggerdeliveryChanged();
                                }
                                SetSaveTrigger(false);
                              }}
                              disabled={datePickerEnable ? false : true}
                            />
                          </Grid>
                        </Grid>
                        {/* (viewAgrData?.data?.agreementWorkflow?.isDeliveryScheduled == '1') && (viewAgrData?.data?.agreementWorkflow?.isSwitchoutEnabled == '0') && (viewAgrData?.data?.agreementInformation?.agreementType == 'Rental Agreement (RTO)' || viewAgrData?.data?.agreementInformation?.agreementType == 'Rent to Rent - Loaner') && (props.appiontmentType == 'D' || props.appiontmentType == 'CO' || deliveryMethodData?.appiontmentType == 'D' || deliveryMethodData?.appiontmentType == 'CO') &&  */}
                        {/* {((viewAgrData?.data?.agreementWorkflow?.isDeliveryScheduled == '1') && (getAgreementDeliveryRes?.appointmentInfo?.appointmentStatus != 'CAN' || getAgreementDeliveryRes?.appointmentInfo?.appointmentStatus == 'CMP') && (featureFlagDetails?.FieldDevice == '1')) || true ? (<Grid>
                                <Grid style={{ display: 'inline-block' }}>
                                  <RACToggle
                                    checked={manualSignatureEnabled}
                                    toggleColor="#0d6efd"
                                    OnClick={() => { manualSignatureEnabled ? setManualSignatureEnabled(false) : setManualSignatureEnabled(true) }}
                                  />
                                </Grid>
                                <Typography style={{ display: 'inline' }}>{" "}Manual Signature</Typography>
                              </Grid>) : setManualSignatureEnabled(true)
                              } */}

                        {getAgreementDeliveryRes?.appointmentInfo
                          ?.appointmentStatus == "CAN" ? (
                          <div>
                            <p
                              style={{
                                width: "100%",
                                textAlign: "center",
                                borderBottom: "1px solid #000",
                                lineHeight: "0.1rem",
                                margin: "10px 0 20px",
                              }}
                            >
                              <span
                                style={{
                                  background: "#fff",
                                  padding: "0 10px",
                                }}
                              >
                                {t("Event Status")}:
                                <span
                                  style={{
                                    backgroundColor: "lightpink",
                                    color: "red",
                                  }}
                                >
                                  {t("Cancelled")}
                                </span>
                              </span>
                            </p>
                          </div>
                        ) : null}
                        {rescheduleEnable && !desktopView ? (
                          <>
                            <Grid container>
                              <Grid
                                item
                                sm={12}
                                md={12}
                                lg={8}
                                className={classes.spacerMT8}
                              >
                                <Grid className={classes.floatLeft}>
                                  <Typography
                                    variant="h5"
                                    className={classes.subTitle}
                                  >
                                    {t("Select Available Timeslot")}
                                  </Typography>
                                  <Typography
                                    className={classes.deliveryEventDesc}
                                  >
                                    {t(
                                      "Only 4 events can be added in one time slot."
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid className={classes.floatRight}>
                                  <Grid
                                    className={`${classes.floatLeft} ${classes.me48}`}
                                  >
                                    <span className={classes.circleAvailable} />
                                    <span>{t("Available")}</span>
                                  </Grid>
                                  <Grid
                                    classes={{
                                      root: clsx(
                                        classes.floatLeft,
                                        classes.spacerMR4
                                      ),
                                    }}
                                  >
                                    <span className={classes.circleBusy} />
                                    <span>{t("Busy")}</span>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item md={12} className={classes.spacerMB5}>
                              <Grid
                                className={`${classes.mt2} ${classes.me2} ${classes1.timeSlot}`}
                              >
                                {buildTimeSlot(true)}
                              </Grid>
                              <Grid
                                className={`${globalStyle.flexCenter} ${globalStyle.mt3}  ${classes1.dMdFlex}`}
                              >
                                <RACButton
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    PreviousTimeSlotFn();
                                  }}
                                  disabled={previousBtnEnable ? false : true}
                                >
                                  {t("Previous")}
                                </RACButton>
                                <RACButton
                                  variant="contained"
                                  color="primary"
                                  onClick={() => {
                                    NextTimeSlotFn();
                                  }}
                                >
                                  {t("Next")}
                                </RACButton>
                              </Grid>
                            </Grid>
                          </>
                        ) : rescheduleEnable && desktopView ? (
                          <>
                            <Grid container>
                              <Grid
                                item
                                sm={12}
                                md={12}
                                lg={8}
                                className={classes.spacerMT8}
                              >
                                <Grid className={classes.floatLeft}>
                                  <Typography
                                    variant="h5"
                                    className={classes.subTitle}
                                  >
                                    {t("Select Available Timeslot")}
                                  </Typography>
                                  <Typography
                                    className={classes.deliveryEventDesc}
                                  >
                                    {t(
                                      "Only 4 events can be added in one time slot."
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid className={classes.floatRight}>
                                  <Grid
                                    className={`${classes.floatLeft} ${classes.me48}`}
                                  >
                                    <span className={classes.circleAvailable} />
                                    <span>{t("Available")}</span>
                                  </Grid>
                                  <Grid
                                    classes={{
                                      root: clsx(
                                        classes.floatLeft,
                                        classes.spacerMR4
                                      ),
                                    }}
                                  >
                                    <span className={classes.circleBusy} />
                                    <span>{t("Busy")}</span>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item md={12} className={classes.spacerMB5}>
                              <Grid
                                className={`${classes.mt2} ${classes.me2} ${classes1.timeSlot}`}
                              >
                                {buildTimeSlot(true)}
                              </Grid>
                            </Grid>
                          </>
                        ) : null}
                        {/* -----------------------Tiem slot end------------------------- */}
                        {RescheduleProps === "Schedule" ? (
                          <Grid className={classes.fixedBottom}>
                            <Grid className={classes.floatLeft}>
                              <RACButton
                                variant="outlined"
                                color="primary"
                                className={classes.floatLeft}
                                onClick={() => PreviousbuttonClick()}
                              >
                                {t("Previous")}
                              </RACButton>
                              {/* <RACButton
                                  variant="outlined"
                                  color="primary"
                                  className={`${classes.floatLeft} ${classes.ms2}`}
                                  onClick={() => deliveryCancel()}
                                >
                                  Cancel
                                </RACButton> */}
                            </Grid>

                            <Grid
                              className={classes.floatRight}
                              style={{ display: "flex" }}
                            >
                              {resumebtnFeatureFlag == "1" &&
                              featureFlagDetails?.SundaySky == "1" ? (
                                <RACButton
                                  variant="contained"
                                  color="primary"
                                  className={`${classes.floatLeft} ${classes.mx1}`}
                                  // disabled={enableFinish}
                                  onClick={() => setResendVopen(true)}
                                >
                                  {t("Resend Welcome Video")}
                                </RACButton>
                              ) : null}
                              <RACButton
                                disabled={
                                  viewAgrData?.data?.agreementWorkflow
                                    ?.isTransferInitiated == 1
                                    ? true
                                    : false
                                }
                                className={classes.mx1}
                                onClick={ReturnChange}
                                variant="contained"
                                color="primary"
                              >
                                {t("Return")}
                              </RACButton>
                              <AddCoCustomer
                                // coCustomerData={Cocustomer}
                                func={pull_data}
                              />
                              <Eposchedule epoData={EpoProps} />
                              <RACButton
                                variant="contained"
                                color="primary"
                                className={classes.floatLeft}
                                disabled={enableFinish}
                                onClick={() => {
                                  Complete_delivery_status(true);
                                  // Complete_delivery_status_exchange();
                                }}
                              >
                                {t("Finish")}
                              </RACButton>
                            </Grid>
                          </Grid>
                        ) : (
                          <Grid className={classes.fixedBottom}>
                            <Grid className={classes.floatLeft}>
                              <RACButton
                                variant="contained"
                                color="primary"
                                className={classes.floatLeft}
                                disabled={enableFinish}
                                onClick={() => {
                                  Complete_delivery_status(true);
                                  // Complete_delivery_status_exchange();
                                }}
                              >
                                {t("Save")}
                              </RACButton>
                            </Grid>
                          </Grid>
                        )}
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </div>
            ) : //   </CardContent>
            // </Card>
            null}
          </Grid>
        </Grid>
      </div>
      {returnbtnRdn ? (
        <AgreementReturn
          confirmFlow={confirmFlow}
          paymentredirectFlow={false}
          printRestrict={false}
          InvisibleFlow={() => {
            console.log("ih");
          }}
          ReturnStable={ReturnStableFunc}
          scheduleReturn={true}
        />
      ) : null}
      {/* Delivery Method ends here  */}
      {SOTwoFactorReturnEnabled ? (
        <SecondFactor
          setTwoFactorCompleted={SOTwoFactorReturnCompleted}
          setTwoFactorCancelClick={() => setSOTwoFactorReturnEnabled(false)}
          closeSLAClicked={() => setSOTwoFactorReturnEnabled(false)}
          currentRole={currentUserRole}
          moduleName="Return"
          //throwCurrentPage="SwitchoutScenario"
        />
      ) : null}
      {/* Delivery Address Pop-Up */}

      <RACModalCard
        isOpen={Popup}
        borderRadius="25px"
        maxWidth="lg"
        title={t("Select Delivery Address")}
        onClose={() => {
          SetPopup(false)
          setSuggestAddress(false);
          setAddress({
            street: '',
            interiorNum: '',
            exteriorNum: '',
            suburb: '',
            zipcode: '',
            city: '',
            state: ''
          });
        }}
        closeIcon={true}
        // eslint-disable-next-line react/no-children-prop
        children={Addressselect()}
      />

      {/* please reverse payment */}
      <RACModalCard
        isOpen={ReturnDeliveryCompleted}
        onClose={() => SetReturnDeliveryCompleted(false)}
        maxWidth="xs"
        closeIcon={true}
        borderRadius="20px"
        // eslint-disable-next-line react/no-children-prop
        children={ReversePaymentInfoPopContent()}
      />
      {/* please reverse payment confirmation */}
      <RACModalCard
        isOpen={ReverseConfirmation}
        onClose={() => setReverseConfirmation(false)}
        maxWidth="xs"
        closeIcon={true}
        borderRadius="20px"
        // eslint-disable-next-line react/no-children-prop
        children={ReversePaymentConfirmationContent()}
      />
      <RACModalCard
        isOpen={ValidateIsOpen}
        borderRadius="15px"
        maxWidth="xs"
        closeIcon={true}
        onClose={() => setValidateIsOpen(false)}
        // eslint-disable-next-line react/no-children-prop
        children={addressDoctorPopup()}
        title={t("Validation Message")}
      />

      <RACModalCard
        isOpen={ResendVopen}
        closeIcon={true}
        maxWidth="sm"
        title={t("Resend Welcome Video")}
        TitleVariantClassName={globalStyle.popupTitle}
        // eslint-disable-next-line react/no-children-prop
        children={sendAgreementPopup()}
        onClose={() => setResendVopen(false)}
        borderRadius={"20px !important"}
      />
      <RACModalCard
        isOpen={resendsuccess}
        maxWidth="xs"
        // eslint-disable-next-line react/no-children-prop
        children={resumeSuccessPopup()}
        borderRadius={"20px !important"}
      />
      <RACModalCard
        isOpen={Errorpopup}
        maxWidth="xs"
        borderRadius="15px"
        // title="Modal title"
        closeIcon={true}
        onClose={() => SetErrorpopup(false)}
        // eslint-disable-next-line react/no-children-prop
        children={errorpopup()}
      />

      <RACModalCard
        isOpen={ErrorpopupMsg}
        maxWidth="xs"
        borderRadius="15px"
        // title="Modal title"
        // closeIcon={true}
        onClose={() => SetErrorpopup(false)}
        // eslint-disable-next-line react/no-children-prop
        children={errorpopup()}
      />
      <RACModalCard
        isOpen={Opendeliveryconfirmpopup}
        borderRadius="15px"
        // onClose={() => SetOpendeliveryconfirmpopup(false)}
        maxWidth="xs"
        // closeIcon={true}
        // eslint-disable-next-line react/no-children-prop
        children={DeliveryConfirmPopupOpen()}
      />
      <RACModalCard
       isOpen={isProceedConfirmationPopupOpen}
       borderRadius="15px"
        maxWidth="xs"
        children={DeliveryConfirmPopupOpenMx()}
      />


      <RACModalCard
        isOpen={Openreturnconfirmpopup}
        borderRadius="15px"
        // onClose={() => SetOpendeliveryconfirmpopup(false)}
        maxWidth="xs"
        // closeIcon={true}
        // eslint-disable-next-line react/no-children-prop
        children={DeliveryReturnConfirmPopupOpen()}
      />
      <RACModalCard
        isOpen={OpenPickupConfirmPopup}
        borderRadius="15px"
        maxWidth="xs"
        // eslint-disable-next-line react/no-children-prop
        children={PickupConfirmPopupOpen()}
      />
      {/* <RACModalCard
        isOpen={OpenTimeslotbookedPopup}
        onClose={() => SetOpenTimeslotbookedPopup(false)}
        maxWidth="xs"
        closeIcon={true}
        // eslint-disable-next-line react/no-children-prop
        children={BookedtimeSlotpopup()}
      /> */}
      {/* <Userscontext.Provider value={obj}>   
        <Footer></Footer>   
      </Userscontext.Provider> */}
      {canEnableGoogleValdation ? (
        <>
          <RACModalCard
            isOpen={canSuggestAddress}
            maxWidth="sm"
            closeIcon={true}
            borderRadius="20px"
            onClose={() => setCanSuggestAddress(false)}
            // eslint-disable-next-line react/no-children-prop
            children={suggestAddressFn()}
            title={t("Validation Message")}
          />
          <RACModalCard
            isOpen={cantSuggestAddress}
            maxWidth="xs"
            //  closeIcon={true}
            borderRadius="20px"
            //  onClose={() => setCantSuggestAddress(false)}
            // eslint-disable-next-line react/no-children-prop
            children={suggestErrorInAddress()}
          />
          <RACModalCard
            isOpen={verificationWarningPopup}
            maxWidth={"sm"}
            borderRadius={"25px !important"}
            closeIcon={true}
            onClose={() => {
              setverificationWarningPopup(false);
              setVerifcationRequiredContinue(true);
            }}
            //eslint-disable-next-line react/no-children-prop
            children={verificationWarningPopupFn()}
          ></RACModalCard>
        </>
      ) : null}
    </div>
  );
}
